import React, { useState, useEffect, useRef, useCallback } from "react";
import ReportsSection from "../components/ReportDropdown2";
import LanguageSelector from "../components/LangugageSelector";
import Profile from "../components/Profile";
import AutoSaveIndicator from './AutoSaveIndicator';
import SessionRecoveryModal from './SessionRecoveryModal';
import UnsavedChangesModal from './UnsavedChangesModal';
import { updateProfile,    updatePassword  ,   sendPasswordResetEmail} from "firebase/auth";
import ProductService from "../components/ProductService";
import { useNavigate } from 'react-router-dom';
import PersonalInfoForm from "../components/PersonalInfoForm";

import OrganizationForm0 from "../components/OrganizationForm0";

import CelebrationAnimation from "../components/CelebrationAnimation";
import TypeFarming from "../components/TypeFarming";
import TypeUser from  "../components/TypeUser";
import Data from "../components/Data";
import { FiEye, FiEyeOff } from "react-icons/fi";

import OrganizationForm from "../components/OrganizationForm";
import IndustrySection from "../components/IndustrySection";
import MembershipSection from "../components/MembershipSection";
import SectionD from "../components/SectionD";
import SectionDnew from "../components/SectionDnew";
import BackgroundInfoSection from "../components/BackgroundInfoSection";
import LocationPicker from "./LocationPicker";
import { motion, AnimatePresence } from "framer-motion";
import GroupExperience from "../components/GroupExperience";
import Modal from "react-modal";
import SaveButtonWithModal from "../components/SaveButtonWithModel";
import { getFirestore, setDoc, serverTimestamp,collection,  doc, getDoc,increment,updateDoc,runTransaction  } from "firebase/firestore";
import {
    getAuth,
    createUserWithEmailAndPassword,
    fetchSignInMethodsForEmail
} from "firebase/auth";
import { generateRegistrationNumber } from "../utils/generateRegNumber";
import { uploadToCloudinary } from "../utils/CloudinaryUpload";
import { sendRegistrationEmail } from "../utils/sendRegistrationsEmail";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../firebase"; // Make sure `firebaseConfig` is exported from your firebase.js
import { signInWithEmailAndPassword } from "firebase/auth";
import PDFGenerator from "../components/PDFGenerator";
import { useCountry } from '../pages/CountryContext';

import PDFPreviewPage from "../components/PDFPreviewPage";
import { useBlocker } from 'react-router-dom';
import ImageEditorModal from "../components/ImageEditorModal";
import AreasFocus from "../components/GroupExperience";
// Init Firebase singletons
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const dropdownItems = {
    FACILITATOR: [
        "**Input Supply (VIS)**",
        "Seeds, fertilizers, pesticides, machinery Financial services (credit, insurance) Extension services and training.", 
      
        "",
        
        "**Production (VPR)**",
        "Farming activities (planting, irrigating, tending crops/livestock) Harvesting",
        "",
        
        "**Post-Harvest Handling (VPH)**",
        " Cleaning, sorting, grading Primary storage Packaging", 
        "",
        
        "**Processing (VPR)**",
        "Milling, drying, canning, juicing, meat processing Adding preservatives, branding, or recipes", 
        "",
        
        "**Distribution and Marketing (VDM)**",
        "Transportation Wholesaling Retailing Market access platforms",
        "",
        
        "**Consumption (VCO)**",
        "Households Restaurants Institutions (schools, hospitals)",
        "",
        
        "**Support Services (VSS) (Cross-cutting)**",
        "(Cross-cutting) Research and development Infrastructure (roads, electricity, water) ICT and digital tools Policy and regulatory frameworks",
    ],

    PURPOSE: [
        "Funding", 
        "Training", 
        "Resourcing", 
        "Market", 
        "Internship", 
        "Research", 
        "Innovation", 
        "M&E", 
        "Assessment", 
        "Evaluations", 
        "Impact", 
        "EIA", 
        "Development", 
        "Regulation"
    ]
};
const language = {

    FACILITATOR: [
   // South Africa
  "Afrikaans" , 
  "English",
  "isiNdebele",
  "Sepedi",
  "Setswana",
  "Sesotho",
  "isiSwati",
  "Xitsonga",
  "isiZulu",
  
  // Namibia
  "Oshiwambo",
  "German",
  "Nama/Damara",
  "Herero",
  
  // Kenya
  "Swahili",
  
  // Botswana
  "Setswana",
  
  // Zimbabwe
  "Shona",
  "Ndebele",
  
  // Mozambique
  "Portuguese",
  "Emakhuwa",
  "Xichangana",
  
  // Default from dropdownItems.LANGUAGE
  "French",
  "Kiswahili"

    ],
    ORGANIZATION: [
 "Association (ASS)", "Cooperative (COO)", "Community (COM)", "Contact (CON)", "Development Partner (DEP)", "Education (EDU)", "Inputs Supplier (IPS)", "Institution (INS)", "Investor (INV)", "Offtake Partner (OFP)", "Service Provider (SER)", "Offtake Partner (OFP)"
  ]

};
const SMMEsOptions = [
  {
    "heading": "Smallholder Commercial Farms",
    "items": [
      {
        "label": "Small-scale farms operating for profit. Use improved inputs, some mechanization, and sell surplus to local markets. Often family-run but may hire seasonal labor. Example: A 5-hectare maize farm using hybrid seeds and selling to a local mill.",
        "value": "ESC"
      }
    ]
  },
  {
    "heading": "Medium-Scale Farms",
    "items": [
      {
        "label": "Larger landholding than smallholders (e.g., 10–100 hectares). Often mechanized and more capitalized. Supply supermarkets, processors, or export markets. Example: A 50-hectare rice farm with irrigation and a tractor, selling to a national rice brand.",
        "value": "EMS"
      }
    ]
  },
  {
    "heading": "Farmer Cooperatives / Producer Organizations",
    "items": [
      {
        "label": "Groups of farmers who pool resources to gain market power. May own equipment, storage, or transport collectively. Can register as SMEs and operate commercially. Example: A cooperative of 100 tomato farmers owning a cold storage unit.",
        "value": "EFC"
      }
    ]
  },
  {
    "heading": "Contract Farming SMEs",
    "items": [
      {
        "label": "Farmers or farm groups under formal agreements to supply crops/livestock to processors or exporters. Often receive inputs and training from buyers. Example: Poultry farmers supplying eggs to a food company under a contract.",
        "value": "ECF"
      }
    ]
  },
  {
    "heading": "Niche or Specialized Farms",
    "items": [
      {
        "label": "Farms focused on high-value or specialized production: Organic farms, Horticulture farms (vegetables, flowers, herbs), Aquaculture enterprises, Livestock or poultry SMEs, Beekeeping and honey production. Example: A small farm producing organic herbs for export.",
        "value": "ENS"
      }
    ]
  },
  {
    "heading": "Agri-Farmers with Integrated Operations",
    "items": [
      {
        "label": "These SMEs farm and also manage part of the value chain, such as: On-farm processing (e.g., dairy to yogurt), Direct-to-consumer sales (farm shops, online orders). Example: A mushroom farmer selling pre-packed mushrooms to urban grocers.",
        "value": "EAE"
      }
    ]
  },
  {
    "heading": "Youth or Women-led Farming Startups",
    "items": [
      {
        "label": "Often tech-savvy and innovative. Use climate-smart or digital farming tools. May focus on urban/peri-urban agriculture. Example: A woman-led hydroponic vegetable farm near a city.",
        "value": "EYW"
      }
    ]
  },
]
Modal.setAppElement("#root"); // Replace '#root' with the ID of your root element
const initialReportSelections = {
    COUNTRY: "-",
    REGION: "-",
    DISTRICT: "-",
    MUNICIPALITY: "-",
    SMMEs: "-", // Changed from SMMEsOptions[0].items[0]
    "VALUE CHAIN": "-",
     "TYPE OF FARMING": "-", // Add this line
    PROJECT: "-",
    "USER TYPE": "-" // Changed from "View more"
  };

const Dropdown1 = ({ label, items, type, isProjectDropdown, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedCircles, setSelectedCircles] = useState({});
    
    // Scroll related states
    const contentRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    const [thumbHeight, setThumbHeight] = useState(40);
    const [isDragging, setIsDragging] = useState(false);
    const [startY, setStartY] = useState(0);
    const [startScrollTop, setStartScrollTop] = useState(0);
    const thumbRef = useRef(null);

    const toggleCircle = (item) => {
        setSelectedCircles((prev) => ({
            ...prev,
            [item]: !prev[item],
        }));
    };

    const handleSelect = (item) => {
        setSelectedItems(prev => {
            if (prev.includes(item)) {
                return prev.filter(i => i !== item);
            } else {
                return [...prev, item];
            }
        });
        
        if (typeof onChange === "function") {
            onChange(type, item);
        }
    };

    // Calculate thumb height based on content height
    useEffect(() => {
        const content = contentRef.current;
        if (!content) return;

        const updateThumbHeight = () => {
            const { scrollHeight, clientHeight } = content;
            const visibleRatio = clientHeight / scrollHeight;
            setThumbHeight(Math.max(visibleRatio * clientHeight, 20));
        };

        updateThumbHeight();
        window.addEventListener("resize", updateThumbHeight);
        return () => window.removeEventListener("resize", updateThumbHeight);
    }, [isOpen, items]);

    // Handle scroll events
    const handleScroll = () => {
        const content = contentRef.current;
        if (!content) return;

        const { scrollTop, scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        const scrollRatio = scrollTop / maxScrollTop;
        const trackHeight = content.clientHeight - thumbHeight;
        setScrollTop(scrollRatio * trackHeight);
    };

    // Mouse down on thumb
    const handleThumbMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setIsDragging(true);
        setStartY(e.clientY);
        setStartScrollTop(contentRef.current.scrollTop);

        document.addEventListener("mousemove", handleThumbMouseMove);
        document.addEventListener("mouseup", handleThumbMouseUp);
        document.body.style.cursor = "grabbing";
    };

    // Mouse move when dragging thumb
    const handleThumbMouseMove = (e) => {
        if (!isDragging) return;

        const deltaY = e.clientY - startY;
        const content = contentRef.current;
        const { scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        const trackHeight = clientHeight - thumbHeight;

        const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
        const newScrollTop = Math.min(
            Math.max(0, startScrollTop + scrollDelta),
            maxScrollTop
        );

        content.scrollTop = newScrollTop;
    };

    // Mouse up when dragging thumb
    const handleThumbMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener("mousemove", handleThumbMouseMove);
        document.removeEventListener("mouseup", handleThumbMouseUp);
        document.body.style.cursor = "";
    };

    // Click on track to jump to position
    const handleTrackClick = (e) => {
        const content = contentRef.current;
        if (!content || e.target === thumbRef.current) return;

        const track = e.currentTarget;
        const trackRect = track.getBoundingClientRect();
        const clickPosition = e.clientY - trackRect.top;
        const thumbCenter = thumbHeight / 2;
        const scrollRatio =
            (clickPosition - thumbCenter) / (trackRect.height - thumbHeight);

        const { scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        content.scrollTop = scrollRatio * maxScrollTop;
    };

    // Button scroll handlers
    const handleButtonScroll = (direction) => {
        if (contentRef.current) {
            contentRef.current.scrollBy({
                top: direction === 'up' ? -50 : 50,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="flex flex-col w-full relative">
            {/* Button showing selected items */}
            <span className="text-[6px] md:text-[20px] md:mb-1 font-extrabold">
        {isProjectDropdown ? "" : "LANGUAGE"}
    </span>
            <div className="flex relative z-20 w-fit">
                <button
                    onClick={() => {
                        if (isProjectDropdown && selectedItems.includes("Funding")) {
                            window.location.href = "/funding";
                        } else {
                            setIsOpen(prev => !prev);
                        }
                    }}
                    className={`xl:w-[250px] lg:w-[140px] md:w-[55px] w-[80px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}
                >
                 <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">
    {selectedItems.length > 0 ? selectedItems[0] : "-"}
</span>
                </button>

                <div
                    className="w-[20px] h-[15px] md:h-[53px] md:w-[50px] bg-[#FDBB26] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                    onClick={() => setIsOpen(prev => !prev)}
                >
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                        alt="expand"
                        className="w-2 h-[10px] md:w-6 md:h-[24px]"
                    />
                </div>
            </div>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        className="absolute top-full mt-1 left-0 z-[100] md:w-[280px] w-[100px] border-[1px] border-[#979797]/80 rounded-[5px] bg-[#142B24]  shadow-lg p-2"
                    >
                      

                        <div className="custom-scroll-area">
                            <ul
                                className="custom-scroll-content"
                                ref={contentRef}
                                onScroll={handleScroll}
                            >
                            <li className="flex items-center justify-end mb-2">
  
    <img
        src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758380484/Export_1_yad3hi.png"
        alt="icon"
        className="md:w-[30px] md:h-[30px] h-[7px] w-[7px] cursor-pointer"
        onClick={(e) => {
            e.stopPropagation(); // Prevent the li onClick from firing
            setIsOpen(false); // Close the dropdown
        }}
    />
</li>
                                
                                {items.map((item, index) => (
                                    <li
                                        key={index}
                                        className={`flex items-center justify-between md:px-3 px-1 md:mt-1 py-1 rounded-md cursor-pointer ${
                                            selectedItems.includes(item) ? "bg-[]" : ""
                                        }`}
                                        onClick={() => handleSelect(item)}
                                    >
                                        <span className="text-white text-[4px] md:text-[18px]">
                                            {item}
                                        </span>
                                        <div
                                            className={`w-2 h-2 md:w-[25px] md:h-[25px] rounded-full ${
                                                selectedItems.includes(item) ? "bg-[#FFBD26]" : "bg-gray-200"
                                            }`}
                                        ></div>
                                    </li>
                                ))}
                            </ul>
                            <div className="custom-scroll-track" onClick={handleTrackClick}>
                                <div
                                    ref={thumbRef}
                                    className="custom-scroll-thumb"
                                    style={{
                                        height: `${thumbHeight}px`,
                                        top: `${scrollTop}px`,
                                        cursor: isDragging ? "grabbing" : "grab",
                                    }}
                                    onMouseDown={handleThumbMouseDown}
                                ></div>
                            </div>
                        </div>

                       
                    </motion.div>
                )}
            </AnimatePresence>
            <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
                {isProjectDropdown
                    ? "Select type of Produce"
                    : `Select  ${type === "FACILITATOR" ? "Language" : label}`}
            </p>

            <style jsx>{`
    .custom-scroll-area {
        position: relative;
        max-height: 250px;
        display: flex;
        overflow: hidden;
    }

    .custom-scroll-content {
        flex: 1;
        overflow-y: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;
        padding-right: 4px;
    }

    .custom-scroll-content::-webkit-scrollbar {
        display: none;
    }

    .custom-scroll-track {
        width: 14px;
        background: #e7ebeb;
        border-radius: 3px;
        position: relative;
        margin-left: 4px;
        cursor: pointer;
    }

    .custom-scroll-thumb {
        width: 100%;
        background: #979797;
        border-radius: 3px;
        position: absolute;
        right: 0;
        transition: background 0.2s;
    }

    .custom-scroll-thumb:hover {
        background: #444;
    }

    /* Mobile-specific styles */
    @media (max-width: 768px) {
        .custom-scroll-track {
            width: 10px; /* Changed from 4px to 10px as requested */
            margin-left: 2px;
        }
        
        .custom-scroll-area {
            max-height: 150px;
            width: 100%;
        }
        
        /* Optional: Make thumb slightly narrower on mobile */
        .custom-scroll-thumb {
            width: 8px;
            right: 1px;
        }
    }
`}</style>
        </div>
    );
};
const languages = [
    "Owned",
    "Commonage",
    "Community Owned",
    "Municipal Land",
    "House with a plot",
    "Urban lot",
    "Community Food garden allocation",
    "No Land Yet",
];
const languages1 = [
    "Leased",
    "Community Leased",
    "Road side vacant land",
    "Village / Local/ Tribunal Authority allocation",
];


  const RegisterAsFarm = (  onFormDataChange,  ) => {
    const [registrationData, setRegistrationData] = useState(null); // Define state for registration data
 // In RegisterAsFarm component, update the initial state:
const [membershipData, setMembershipData] = useState({
  selected: [],
  custom: [],
  customInputBoxes: [],
  inputs: {},
  organizationName: '',
  membershipNumber: '',
  membershipType: '',
  membershipDate: ''
});
    
// Add this early in your component
const [orgFormData, setOrgFormData] = useState({
  cooperativeName: "",
  registrationNumber: "",
  members: "",
  mobileNumber: "",
  physicalAddress: "",
  chairFirstName: "",
  chairSurname: "",
  secretaryFirstName: "",
  secretarySurname: "",
  email: "",
  password: "",
});
    const [selected, setSelected] = useState(null); // <-- initially nothing selected
    const [selected1, setSelected1] = useState(null); // <-- initially nothing selected
    const [selectedBox, setSelectedBox] = useState(null);
    const keys = Object.keys(dropdownItems);
    const navigate = useNavigate();

    const handleBoxClick = (index) => {
        setSelectedBox(index);
    };
    const setLandSizes = (newSizes) => {
        console.log("New sizes: ", newSizes);
    };
    const [isSaveModalOpen, setIsSaveModalOpen] = useState(false); // Save modal state
    const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false); // Registration modal state
    // Save Button Click Handler
    const [formData, setFormData] = useState({
      firstName: "",
      surname: "",
      dateOfBirth: "",
      typeOfId: "",
      idNumber: "",
      mobile: "",
      email: "",
      password: "",
      whatsapp: "",
      physicalAddress: "",
      postalCode: "",
  });
 
    
  const handleSaveClick = () => {
    const dataToSave = {
      formData,
      orgFormData,
      dropdownSelections,
      reportSelections,
      selectedLanguage,
      landData,
      selectedSkills,
      membershipData,
      groupExperience,
      dataPermissions,
      selectedType,
      selectedOption,
      selectedCategories,
      selectedChallenges,
      vision,
      selectedS,
      selectedQ,
      location,
  profileImage: profileImage ? {
  url: profileImage.url || null,
  previewUrl: profileImage.previewUrl || null,
  cloudinaryUrl: profileImage.cloudinaryUrl || null
} : null,
      productImages,
      certificatesUrls,
      idDocumentUrl,
      agreed,
      race,
      gender,
      disability,
      orgType
    };
    
    try {
      localStorage.setItem('farmRegistrationData', JSON.stringify(dataToSave));
      setIsSaveModalOpen(true);
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };
  const [certificates, setCertificates] = useState(() => {
    // Initialize with 4 boxes, first one with default image
    return [
      { 
        title: "Business Registration", 
        img: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754931680/image_2148_prvz9v.png",
        bg: "#D9D9D9" 
      },
      { 
        title: "Trade Certificate", 
        img: null, 
        bg: "#D9D9D9" 
      },
      { 
        title: "Business License", 
        img: null, 
        bg: "#D9D9D9" 
      },
      { 
        title: "Health Certificate", 
        img: null, 
        bg: "#D9D9D9" 
      }
    ];
  });
  const clearAllFormData = () => {
    // Reset all form states to their initial values
    setFormData({
      firstName: "",
      surname: "",
      dateOfBirth: "",
      typeOfId: "",
      idNumber: "",
      mobile: "",
      email: "",
      password: "",
      whatsapp: "",
      physicalAddress: "",
      postalCode: "",
    });
  
    setOrgFormData({
      cooperativeName: "",
      registrationNumber: "",
      members: "",
      mobileNumber: "",
      physicalAddress: "",
      chairFirstName: "",
      chairSurname: "",
      secretaryFirstName: "",
      secretarySurname: "",
      email: "",
      password: "",
    });
  
    // Clear image states
    if (profileImage?.previewUrl) {
      URL.revokeObjectURL(profileImage.previewUrl);
    }
    productImages.forEach(img => {
      if (img.previewUrl) {
        URL.revokeObjectURL(img.previewUrl);
      }
    });
    setProfileImage(null);
    setProductImages([]);
  
    // Clear other states
    setDropdownSelections({
      user_type: dropdownItems.FACILITATOR[0],
      user_purpose: dropdownItems.PURPOSE[0],
    });
    setReportSelections(initialReportSelections);
    setSelectedLanguage(null);
    setLandData({
      type1: { type: "", size: "", unit: "Hectare", hasLandSize: false },
      type2: { type: "", size: "", unit: "Hectare", hasLandSize: false },
      erfNumber: ''
    });
    setSelectedSkills([]);
    setMembershipData({ selected: [], custom: [], customInputBoxes: [], inputs: {} });
    setGroupExperience([]);
    setDataPermissions([]);
    setFocusSelected([]);
    setSelectedType("");
    setSelectedOption("Maize");
    setSelectedCategories([]);
    setSelectedChallenges([]);
    setVision("");
    setSelectedS("Agri");
    setSelectedQ("Business Administration");
    setLocation(null);
    setCertificatesUrls([]);
    setIdDocumentUrl("");
    setAgreed(false);
    setRace("");
    setGender("");
    setDisability("");
    setOrgType("COOPERATIVE 1");
  
    // Clear from localStorage
    localStorage.removeItem('farmRegistrationData');
    
    // Close the modal
    setIsDeleteModalOpen(false);
  };
  
      const [isDropdownOpen, setIsDropdownOpen] = useState(false);
      const [dropdownOptions, setDropdownOptions] = useState([
        "Physical Disability",
        "Visual Impairment",
        "Hearing Impairment",
        "Intellectual Disability",
        "Mental Health Condition"
      ]);
      const [showCelebration, setShowCelebration] = useState(false);
const person = [ 
  "Male", "Female", "Youth ","Physical ",
];
  // Check for empty gender/disability
  const handleGenderChange = (val) => {
    // Define the onGenderChange function
    const onGenderChange = (val) => {
      console.log("Gender changed to:", val);
    };
    onGenderChange(val);
    if (!val) {
      setFieldErrors((prev) => ({ ...prev, gender: "Please select gender." }));
    } else {
      setFieldErrors((prev) => {
        const { gender, ...rest } = prev;
        return rest;
      });
    }
  };
      const dropdownRef = useRef(null);
        const [isOpen, setIsOpen] = useState(false);
        const [fieldErrors, setFieldErrors] = useState({});
 
      const handleSelect = (option) => {
        onFormDataChange((prev) => ({ ...prev, typeOfId: option }));
        setIsOpen(false); // Close dropdown after selection
      };
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [showRecovery, setShowRecovery] = useState(false);
    const [showNavWarning, setShowNavWarning] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [lastSaved, setLastSaved] = useState(null);
    const [navTarget, setNavTarget] = useState(null);
   

    const handleConfirmNavigation = () => {
      setShowNavWarning(false);
      navigate(navTarget);
    };
    const handleRestoreSession = () => {
      const savedData = JSON.parse(localStorage.getItem('farmRegistrationData'));
      if (savedData) {
        setFormData(savedData.formData || {});
        setOrgFormData(savedData.orgFormData || {});
        setDropdownSelections(savedData.dropdownSelections || {});
        setReportSelections(
            savedData.reportSelections || initialReportSelections,
        );
        setSelectedLanguage(savedData.selectedLanguage || null);
        setLandType1(savedData.landType1 || "");
        setLandType2(savedData.landType2 || "");
        setErfNumber(savedData.erfNumber || "");
        setSelectedSkills(savedData.selectedSkills || []);
        setSelectedMembership(savedData.selectedMembership || "");
     
        setFocusSelected(savedData.focusSelected || []);
        setSelectedType(savedData.selectedType || "");
        setSelectedOption(savedData.selectedOption || "Maize");
        setSelectedCategories(savedData.selectedCategories || []);
        setSelectedChallenges(savedData.selectedChallenges || []);
        setVision(savedData.vision || "");
        setSelectedS(savedData.selectedS || "Agri");
        setSelectedQ(savedData.selectedQ || "Business Administration");
        setLocation(savedData.location || null);
    }
      setShowRecovery(false);
    };  
    const handleDismissSession = () => {
      localStorage.removeItem('farmRegistrationData');
      setShowRecovery(false);
    };
    const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Edit modal state
    const [loginEmail, setLoginEmail] = useState(""); // Email input state
    const [loginPassword, setLoginPassword] = useState(""); // Password input state
    const [loginError, setLoginError] = useState(null); // Login error state
    const [customInputBoxes, setCustomInputBoxes] = useState([]);

    console.log('Custom input boxes:', customInputBoxes);
    const handleLogin = async () => {
      try {
        setLoading(true);
        setLoginError(null);
        
        const userCredential = await signInWithEmailAndPassword(
          auth,
          loginEmail,
          loginPassword
        );
        
        // Clear fields and close modal
        setLoginEmail("");
        setLoginPassword("");
        setIsLoggedIn(true);
        setLoading(false); // Reset loading state here
        setIsEditModalOpen(false);
        
      } catch (error) {
        setLoading(false);
        // ... error handling remains the same ...
      }
    };
    // Close Save Modal
    const closeSaveModal = () => {
        setIsSaveModalOpen(false);
    };
    const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);
const [adminEmail, setAdminEmail] = useState("");
const [adminPassword, setAdminPassword] = useState("");
const [adminError, setAdminError] = useState("");
const handleAdminLogin = async () => {
  // Define valid admin credentials (email and password pairs)
  const validAdmins = [
    { email: "oyierallan@yahoo.com", password: "123@*Agulu" },
    { email: "allan.oyier@farmnet.africa", password: "123@*Agulu" },
    { email: "farmnetafr@gmail.com", password: "123@*Agulu" },
    { email: "oyiergweth@gmail.com", password: "123@*Agulu" }
  ];

  // Trim inputs to remove accidental whitespace
  const enteredEmail = adminEmail.trim();
  const enteredPassword = adminPassword.trim();

  // Find if any admin matches both email AND password
  const isValidAdmin = validAdmins.some(
    admin => 
      admin.email === enteredEmail && 
      admin.password === enteredPassword
  );

  if (isValidAdmin) {
    // Successful login - clear any previous errors and navigate
    setAdminError("");
    navigate("/Adminportal");
  } else {
    // Failed login - show appropriate error message
    const emailExists = validAdmins.some(admin => admin.email === enteredEmail);
    
    if (!enteredEmail || !enteredPassword) {
      setAdminError("Please enter both email and password");
    } else if (!emailExists) {
      setAdminError("Invalid admin credentials");
    } else {
      setAdminError("Incorrect password");
    }
  }
};
    // Close Registration Modal
    const closeRegisterModal = () => {
        setIsRegisterModalOpen(false);
    };
      const [isSelected] = useState();
    
      const [certificatesUrls, setCertificatesUrls] = useState(
        certificates.map(cert => ({
          title: cert.title,
          url: cert.img || '',
          previewUrl: cert.img || '',
          cloudinaryUrl: cert.img || '',
          documentType: cert.title,
          type: 'certificate'
        }))
      );
      
    const [idDocumentUrl, setIdDocumentUrl] = useState("");
    const [dropdownSelections, setDropdownSelections] = useState({
        user_type: dropdownItems.FACILITATOR[0],
        user_purpose: dropdownItems.PURPOSE[0],
    });
    const [landType1, setLandType1] = useState("");
    const [landType2, setLandType2] = useState("");
    const [erfNumber, setErfNumber] = useState("");
    const [productBoxValues, setProductBoxValues] = useState(Array(8).fill({
      minOrder: 0,
      minOrderUnit: 'Kg',
      size: 'Regular',
      farmGatePrice: 0,
      farmGatePriceUnit: 'Kg'
    }));
    
    const [selectedS, setSelectedS] = useState("Agri"); // initial SETA
    const [selectedQ, setSelectedQ] = useState("Business Administration"); // initial Qualification
    const [showDropdownError, setShowDropdownError] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login status

    const handleDropdownSave = (data) => {
        // Log all values from the dropdowns in registration page
        console.log(" SETA and Qualification:", data);
        // data = { SETA: "Bank", QUALIFICATIONS: "IT Technical Support" }
    };
    const handleBackgroundSave = (data) => {
      console.log("Received land data:", data);
      setLandData(data); // Update local state
      
      // Update Firestore if user is logged in
      if (auth.currentUser) {
        const userRef = doc(db, "registrations", auth.currentUser.uid);
        updateDoc(userRef, {
          landData: data
        }).catch(error => {
          console.error("Error updating land data:", error);
        });
      }
    };
    
    const handleDropdownChange = (type, value) => {
      // Map dropdown type to your desired object keys
      const keyMap = {
        FACILITATOR: "user_type", // This is where language is stored
        PURPOSE: "user_purpose",
      };
    
      const mappedKey = keyMap[type];
    
      setDropdownSelections((prev) => ({
        ...prev,
        [mappedKey]: value,
      }));
    
      // Log for debugging
      console.log("Dropdown selection updated:", {
        type: type,
        value: value,
        storedAs: mappedKey
      });
    };
    const [selectedChallenges, setSelectedChallenges] = useState([]);
    const [vision, setVision] = useState("");

// In RegisterAsFarm.jsx - Update the handleIndustrySave function
const handleIndustrySave = (data) => {
  console.log("Industry Activity Survey:", data);
  setSelectedChallenges(data.selectedChallenges); // Store full challenge objects
  setVision(data.vision);
};
    const [challengeStats, setChallengeStats] = useState({
        'ACCESS TO FINANCE': 0,
        'COMPLIANCE': 0,
        'MARKET ACCESS': 0,
        'SKILL GAPS': 0,
        'TECHNOLOGY': 0,
        'CASH FLOW': 0,
        'MENTORSHIP': 0,
        'INSTABILITY': 0,
        'INNOVATION': 0,
        'INFORMATION ACCESS': 0,
        'SECURITY': 0,
        'OTHERS': 0
      });
      

const [groupExperience, setGroupExperience] = useState([]);
const handleGroupExperienceSave = (areas) => {
  console.log("Areas of Focus saved:", areas);
  setGroupExperience(areas);
  setHasUnsavedChanges(true);
};
const [dataPermissions, setDataPermissions] = useState([]);
    const [focusSelected, setFocusSelected] = useState([]);
    const [selectedType, setSelectedType] = useState("farmer");
    const [showBackgroundError, setShowBackgroundError] = useState(false);
    // When the user clicks Register
    const getRegionName = (regionData) => {
      if (!regionData) {
        console.log("No region data provided");
        return null;
      }
      
      // If it's a string, check if it matches any region name
      if (typeof regionData === 'string') {
        const found = Object.keys(regionMap).find(key => 
          key.toLowerCase() === regionData.toLowerCase()
        );
        return found || null;
      }
      
      // If it's an object with value property
      if (regionData.value) {
        return Object.keys(regionMap).find(key => 
          regionMap[key] === regionData.value
        ) || null;
      }
      
      // If it's an object with name property
      if (regionData.name) {
        return Object.keys(regionMap).find(key => 
          key.toLowerCase() === regionData.name.toLowerCase()
        ) || null;
      }
      
      console.log("Could not resolve region from:", regionData);
      return null;
    };
    const regionMap = {
        "Gauteng": "01",
        "Eastern Cape": "02", 
        "Limpopo": "03",
        "KwaZulu-Natal": "04",
        "Mpumalanga": "05",
        "Western Cape": "06",
        "North West": "07",
        "Northern Cape": "08",
        "Free State": "09"
      };
     // Replace separate states with a single landData state
const [landData, setLandData] = useState({
  type1: { type: "", size: "", unit: "Hectare", hasLandSize: false },
  type2: { type: "", size: "", unit: "Hectare", hasLandSize: false },
  erfNumber: ''
});
      
      const [isPDFReady, setIsPDFReady] = useState(false);
const pdfGeneratorRef = useRef(null);
// Add this near the top of your RegisterAsFarm component
const generatePDF = async () => {
    try {
      if (pdfGeneratorRef.current) {
        await pdfGeneratorRef.current.generatePDF();
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error generating PDF:", error);
      return false;
    }
  };
  console.log('Passing membership data to document page:', {
    selected: membershipData.selected,
    custom: membershipData.customInputBoxes,
    customInputBoxes: customInputBoxes,
    inputs: membershipData.inputs || {}
  });
  const [customMembership, setCustomMembership] = useState("");
const [userLocation, setUserLocation] = useState(null);
const challengesData = [
    {
      id: 1, // Added unique ID
      title: "Limited Access to Finance",
      code: "ACCESS TO FINANCE",
      description: "Many farmers lack access to affordable credit and insurance.",
      solution: "Solution: Develop inclusive agricultural financing, microloans, and mobile banking services tailored to smallholders."
    },
    {
      id: 2,
      title: "Poor Infrastructure",
      code: "COMPLIANCE",
      description: "Inadequate roads, storage, and market facilities hinder distribution and increase post-harvest losses.",
      solution: "Solution: Invest in rural infrastructure, including roads, warehouses, and market access points."
    },
    {
      id: 3,
      title: "Low Access to Technology and Inputs",
      code: "MARKET ACCESS",
      description: "Limited availability of quality seeds, fertilizers, and modern tools.",
      solution: "Solution: Encourage public-private partnerships to improve input supply chains and subsidize access for small-scale farmers."
    },
    {
      id: 4,
      title: "Climate Change & Unpredictable Weather",
      code: "SKILL GAPS",
      description: "Droughts, floods, and changing weather patterns disrupt farming cycles.",
      solution: "Solution: Promote climate-smart agriculture, drought-resistant seeds, and improved weather forecasting tools."
    },
    {
      id: 5,
      title: "Market Access and Price Volatility",
      code: "TECHNOLOGY",
      description: "Farmers struggle to connect with profitable markets and face unstable prices.",
      solution: "Solution: Support farmer cooperatives, develop value chains, and use digital platforms to connect farmers with buyers."
    },
    {
      id: 6,
      title: "Youth Disinterest in Agriculture",
      code: "SKILL GAPS",
      description: "Agriculture is seen as unprofitable and labor-intensive.",
      solution: "Solution: Promote agribusiness, use of technology, and access to land and finance for young farmers."
    },
    {
      id: 7,
      title: "Pests and Diseases",
      code: "INSTABILITY",
      description: "Crop and livestock pests can wipe out harvests and income.",
      solution: "Solution: Increase research on pest control, and provide early warning systems and access to effective pesticides or biological controls."
    },
    {
      id: 8,
      title: "Land Tenure Insecurity",
      code: "INSTABILITY",
      description: "Many farmers work without formal land rights, discouraging long-term investment.",
      solution: "Solution: Implement land reforms and promote secure, documented land ownership."
    },
    {
      id: 9,
      title: "Lack of skills and technical know-how",
      code: "SKILL GAPS",
      description: "Limits smallholder farmers' productivity and income potential by preventing them from adopting modern, efficient farming practices.",
      solution: "Solution: targeted training, access to extension services, and digital tools tailored to their needs."
    },
    {
      id: 10,
      title: "Crime and insecurity",
      code: "SECURITY",
      description: "Disrupt smallholder farmers' activities by threatening their safety, crops, and livestock, leading to reduced productivity and investment.",
      solution: "Solution: Strengthened rural security, community policing, and support systems to protect livelihoods."
    },
    {
      id: 11,
      title: "Lack of information",
      code: "INFORMATION ACCESS",
      description: "Prevents smallholder farmers from making informed decisions about markets, weather, and best practices, leading to lower yields and income.",
      solution: "Solution: improved access to timely, relevant agricultural information through mobile platforms and extension services."
    },
    {
      id: 12,
      title: "Others",
      code: "OTHERS",
      description: "",
      solution: ""
    }
  ];
  // Update the handleRegister function to include PDF generation
  // Initialize idDocumentUrl at the top of your component with other state
// Add these functions to handle image uploads properly
const uploadProfileImageToCloudinary = async (file) => {
  try {
    if (!file) return null;
    
    const uploadResult = await uploadToCloudinary(file, {
      folder: 'profile-images',
      userId: auth.currentUser?.uid
    });
    
    return uploadResult.url;
  } catch (error) {
    console.error("Profile image upload error:", error);
    throw new Error("Failed to upload profile image");
  }
};

const uploadBackgroundImageToCloudinary = async (file) => {
  try {
    if (!file) return null;
    
    const uploadResult = await uploadToCloudinary(file, {
      folder: 'background-images',
      userId: auth.currentUser?.uid
    });
    
    return uploadResult.url;
  } catch (error) {
    console.error("Background image upload error:", error);
    throw new Error("Failed to upload background image");
  }
};
const [isImageEditorOpen, setIsImageEditorOpen] = useState(false);
const [currentEditingImage, setCurrentEditingImage] = useState(null);
const [currentImageType, setCurrentImageType] = useState(null); // 'profile' or 'background'
const [currentImageFile, setCurrentImageFile] = useState(null);

// Update your handleRegister function
const handleRegister = async () => {
  if (!validateForm()) {
    setRegistrationError("Please fill all required fields correctly");
    return;
  }

  setLoading(true);
  setRegistrationError(null);

  try {
    const selectedChallengeObjects = challengesData.filter(challenge => 
      selectedChallenges.includes(challenge.id)
    );

    // Check if email exists (new registrations only)
    if (!isLoggedIn) {
      const methods = await fetchSignInMethodsForEmail(auth, formData.email);
      if (methods.length > 0) throw new Error("auth/email-already-in-use");
    }
    if (selectedChallenges.length > 0) {
        const statsRef = doc(db, "stats", "challenges");
        const updates = {};
        
        selectedChallenges.forEach(challengeId => {
          const challenge = challengesData.find(c => c.id === challengeId);
          if (challenge) {
            updates[challenge.code] = increment(1);
          }
        });
  
        await updateDoc(statsRef, updates);
        console.log("Challenge stats updated successfully");
      }
  
    // Generate registration number
    const regNumber = generateRegistrationNumber({
      COUNTRY: reportSelections.COUNTRY,
      REGION: reportSelections.REGION,
      DISTRICT: reportSelections.DISTRICT, 
      MUNICIPALITY: reportSelections.MUNICIPALITY,
      SMMEs: reportSelections.SMMEs?.value || "",
      "USER TYPE": reportSelections["USER TYPE"],
      selectedType: selectedType // Add this line
    }, selectedCountry);
 // Define regionName and smmeType before using them
 // After successful registration, update the stats
 const regionName = getRegionName(reportSelections.REGION, reportSelections.COUNTRY);
 const smmeType = typeof reportSelections.SMMEs === 'object' 
   ? reportSelections.SMMEs.value 
   : reportSelections.SMMEs;
 
 // Calculate land size totals
 const landSize1 = landData.type1?.size ? parseFloat(landData.type1.size) : 0;
 const landSize2 = landData.type2?.size ? parseFloat(landData.type2.size) : 0;
 const totalLandSize = landSize1 + landSize2;
 const updateStats = async (country, region, smmeType, landSize) => {
  const statsRef = doc(db, "stats", "registrations");
  
// In the handleRegister function, modify the stats update logic:

if (reportSelections.COUNTRY && regionName && smmeType) {
  const statsRef = doc(db, "stats", "registrations");
  
  await runTransaction(db, async (transaction) => {
    const statsDoc = await transaction.get(statsRef);
    const statsData = statsDoc.exists() ? statsDoc.data() : {};
    
    // Initialize country data if not exists
    if (!statsData[reportSelections.COUNTRY]) {
      statsData[reportSelections.COUNTRY] = {};
    }
    
    // Initialize region data if not exists
    if (!statsData[reportSelections.COUNTRY][regionName]) {
      statsData[reportSelections.COUNTRY][regionName] = {
        total: 0,
        landSizeTotal: 0,
        bySmmetype: {}
      };
    }
    
    // Update counts
    statsData[reportSelections.COUNTRY][regionName].total += 1;
    statsData[reportSelections.COUNTRY][regionName].landSizeTotal += totalLandSize;
    
    // Initialize SMME type if not exists
    if (!statsData[reportSelections.COUNTRY][regionName].bySmmetype[smmeType]) {
      statsData[reportSelections.COUNTRY][regionName].bySmmetype[smmeType] = {
        count: 0,
        landSizeTotal: 0
      };
    }
    
    // Update SMME type counts
    statsData[reportSelections.COUNTRY][regionName].bySmmetype[smmeType].count += 1;
    statsData[reportSelections.COUNTRY][regionName].bySmmetype[smmeType].landSizeTotal += totalLandSize;
    
    transaction.set(statsRef, statsData);
  });
}
};
 if (reportSelections.COUNTRY && regionName && smmeType) {
   await updateStats(reportSelections.COUNTRY, regionName, smmeType, totalLandSize);
   console.log("Stats updated successfully");
 }
 

if (reportSelections.COUNTRY && regionName && smmeType) {
  const statsRef = doc(db, "stats", "registrations");
  
  // Calculate land size totals
  const landSize1 = landData.type1?.size ? parseFloat(landData.type1.size) : 0;
  const landSize2 = landData.type2?.size ? parseFloat(landData.type2.size) : 0;
  const totalLandSize = landSize1 + landSize2;
  const hasLandSize = totalLandSize > 0;

  // Create update object
  const updates = {
    [regionName]: {
      total: increment(1),
      landSizeTotal: hasLandSize ? increment(totalLandSize) : increment(0),
      bySmmetype: {
        [smmeType]: {
          count: increment(1),
          landSizeTotal: hasLandSize ? increment(totalLandSize) : increment(0)
        }
      }
    }
  };

  // Use transaction to prevent race conditions
  try {
    await runTransaction(db, async (transaction) => {
      const statsDoc = await transaction.get(statsRef);
      
      if (statsDoc.exists()) {
        // Merge updates with existing data
        const existingData = statsDoc.data();
        const existingRegion = existingData[regionName] || {};
        const existingSmmetype = existingRegion.bySmmetype?.[smmeType] || {};
        
        // Ensure all required fields exist
        updates[regionName] = {
          total: existingRegion.total ? increment(1) : increment(1),
          landSizeTotal: existingRegion.landSizeTotal 
            ? (hasLandSize ? increment(totalLandSize) : increment(0))
            : (hasLandSize ? increment(totalLandSize) : increment(0)),
          bySmmetype: {
            [smmeType]: {
              count: existingSmmetype.count ? increment(1) : increment(1),
              landSizeTotal: existingSmmetype.landSizeTotal 
                ? (hasLandSize ? increment(totalLandSize) : increment(0))
                : (hasLandSize ? increment(totalLandSize) : increment(0))
            }
          }
        };
      }
      
      transaction.set(statsRef, updates, { merge: true });
    });
    
    console.log("Stats updated successfully");
  } catch (error) {
    console.error("Transaction failed: ", error);
  }
}

    let uid;
    if (isLoggedIn) {
      uid = auth.currentUser.uid;
    } else {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );
      uid = userCredential.user.uid;
    
      await updateProfile(userCredential.user, {
        displayName: `${formData.firstName} ${formData.surname}`
      });
    }
    let profileImageUrl = '';
    let backgroundImageUrl = '';
    if (profileImage?.file) {
      profileImageUrl = await uploadProfileImageToCloudinary(profileImage.file);
    } else if (profileImage?.url) {
      profileImageUrl = profileImage.url; // Use existing URL if no file
    }

    // Upload background image if it exists
    if (backgroundImageFile) {
      backgroundImageUrl = await uploadBackgroundImageToCloudinary(backgroundImageFile);
    }
    const userData = {
      uid,
      firstName: formData.firstName, 
      registrationNumber: regNumber,
      registrationDate: new Date().toISOString(),
      personalInfo: { 
        ...formData,
        race: race || "",
        gender: gender || "", 
        disability: disability || ""
      },
      referralData: {
        referralCode: referralCodeInput.trim() || "",
        referredBy: referralCodeInput.trim() || "",
        referralDate: new Date().toISOString(),
        hasReferral: !!referralCodeInput.trim()
      },
      promotionData: {
        selectedType: selectedPromotionType || "ADVERTISEMENT", // Default to ADVERTISEMENT
        advertisementCards: advertisementCards.map(card => ({
          title: card.title,
          description: card.description,
          mainImage: card.cloudinaryUrl || card.mainImage,
          badgeImage: card.badgeImage,
          bgColor: card.bgColor || '#D9D9D9',
          type: 'ADVERTISEMENT'
        })),
        promoCards: promoCards.map(card => ({
          title: card.title,
          description: card.description,
          mainImage: card.cloudinaryUrl || card.mainImage,
          badgeImage: card.badgeImage,
          bgColor: card.bgColor || '#D9D9D9',
          type: 'PROMOTION'
        })),
        selectedAt: new Date().toISOString()
      },
      
      marketingData: {
        advertisements: await prepareAdvertisementData(advertisementCards, 'ADVERTISEMENT'),
        promotions: await prepareAdvertisementData(promoCards, 'PROMOTION'),
        lastUpdated: new Date().toISOString()
      },
      countryData: {
        name: selectedCountry.name || "South Africa",
        code: selectedCountry.code || "27",
        flag: selectedCountry.flag || "🇿🇦"
      },
      
      // LANGUAGE DATA - Fixed
      languageData: {
        selected: selectedLanguage || "",
        timestamp: new Date().toISOString()
      },
      
      // FARMING TYPE DATA - Fixed
      farmingTypeData: {
        type: reportSelections["TYPE OF FARMING"] || "",
        selectedAt: new Date().toISOString()
      },
      
      // USER TYPE DATA - Fixed
      userTypeData: {
        type: typeof reportSelections["USER TYPE"] === 'object' 
          ? reportSelections["USER TYPE"].name || reportSelections["USER TYPE"].value 
          : reportSelections["USER TYPE"] || "",
        code: typeof reportSelections["USER TYPE"] === 'object' 
          ? reportSelections["USER TYPE"].value 
          : "",
        selectedAt: new Date().toISOString()
      },
    
      profileImage: profileImageUrl ? {
        url: profileImageUrl,
        cloudinaryUrl: profileImageUrl,
        documentType: 'Profile Image'
      } : null,
      backgroundImage: backgroundImageUrl,
      aboutSection: {
        aboutText: aboutText || "",
        tagline: tagline || "",
        lastUpdated: new Date().toISOString()
      },
      personData: {
        selectedGenders: selectedGenders || [],
        disabilities: disabilities || []
      },
      
      organizationInfo: {
        ...orgFormData,
        typeOfOrganization: orgType || "COOPERATIVE 1",
        orgType: orgType || "",
        certificates: certificatesUrls.map(cert => ({
          url: cert.url || cert.previewUrl || cert.cloudinaryUrl || '',
          type: cert.documentType || cert.type || 'Unknown',
          documentType: cert.documentType || cert.type || 'Unknown'
        })),
      },
  certificates: certificatesUrls.map(cert => ({
  title: cert.title || cert.documentType,
  url: cert.cloudinaryUrl || cert.url,
  documentType: cert.documentType || 'certificate',
  type: cert.type || 'certificate'
})),
selectedProductType: selectedProduct || "PRODUCTS",
      // ADD PRODUCTS AND SERVICES DATA HERE
      productsData: {
        products: products.map(product => ({
          id: product.id || generateId(),
          category: product.category || "",
          items: product.items.filter(item => item.name && item.name.trim() !== "").map(item => ({
            name: item.name || "",
            imageUrl: item.imageUrl || item.image || "",
            cloudinaryUrl: item.cloudinaryUrl || "", // Add Cloudinary URL
            cloudinaryData: item.cloudinaryData || null,
            createdAt: new Date().toISOString()
          })),
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        })).filter(product => product.items.length > 0),
        
        services: services.map(service => ({
          id: service.id || generateId(),
          category: service.category || "",
          items: service.items.filter(item => item.name && item.name.trim() !== "").map(item => ({
            name: item.name || "",
            imageUrl: item.imageUrl || item.image || "",
            cloudinaryUrl: item.cloudinaryUrl || "", // Add Cloudinary URL
            cloudinaryData: item.cloudinaryData || null,
            createdAt: new Date().toISOString()
          })),
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        })).filter(service => service.items.length > 0),
        
        // ADD BAKES DATA HERE
        bakes: bakes.map(bake => ({
          id: bake.id || generateId(),
          category: bake.category || "",
          items: bake.items.filter(item => item.name && item.name.trim() !== "").map(item => ({
            name: item.name || "",
            imageUrl: item.imageUrl || item.image || "",
            cloudinaryUrl: item.cloudinaryUrl || "", // Ensure Cloudinary URL is saved
            cloudinaryData: item.cloudinaryData || null,
            createdAt: new Date().toISOString()
          })),
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        })).filter(bake => bake.items.length > 0),
        
        lastUpdated: new Date().toISOString()
      },
      
      
      dropdownSelections: dropdownSelections || {},
      reportSelections: validatedReportSelections,
      language: selectedLanguage || "",
      landData: {
        type1: landData.type1 || { type: "", size: "", unit: "", hasLandSize: false },
        type2: landData.type2 || { type: "", size: "", unit: "", hasLandSize: false },
        erfNumber: landData.erfNumber || ""
      },
      profingSkills: selectedSkills || [],
      membershipData: {
        selected: membershipData.selected,
        custom: membershipData.custom,
        customInputBoxes: membershipData.customInputBoxes,
        inputs: membershipData.inputs,
        organizationName: membershipData.organizationName,
        membershipNumber: membershipData.membershipNumber,
        membershipType: membershipData.membershipType,
        membershipDate: membershipData.membershipDate
      },
      groupExperience: groupExperience || [], 
      dataPermissions: dataPermissions || [],
    
      sectionD: { 
        focusSelected: focusSelected || [], 
        selectedType: selectedType || "", 
        selectedOption: selectedOption || "Maize", 
        selectedCategories: selectedCategories || [] 
      },
      industry: { 
        selectedChallenges: selectedChallengeObjects,
        vision: vision 
      },
      setaQualification: { 
        selectedS: selectedS || "Agri", 
        selectedQ: selectedQ || "Business Administration" 
      },
      location: location || null,
      status: "active",
      lastUpdated: new Date().toISOString()
    };
 // After successful registration, update the stats
if (reportSelections.COUNTRY && reportSelections.REGION && reportSelections.SMMEs) {
  const countryName = typeof reportSelections.COUNTRY === 'object' 
    ? reportSelections.COUNTRY.name 
    : reportSelections.COUNTRY;
  
  const regionName = typeof reportSelections.REGION === 'object'
    ? reportSelections.REGION.name
    : reportSelections.REGION;

  const smmeType = typeof reportSelections.SMMEs === 'object'
    ? reportSelections.SMMEs.value
    : reportSelections.SMMEs;

  if (countryName && regionName && smmeType) {
    const statsRef = doc(db, "stats", "registrations");
    
    // Create the update object
    const updates = {
      // Initialize the region structure if it doesn't exist
      [regionName]: {
        total: increment(1),
        landSizeCount: (landData.type1?.size > 0 || landData.type2?.size > 0) ? increment(1) : 0,
        bySmmetype: {
          [smmeType]: {
            count: increment(1),
            landSizeCount: (landData.type1?.size > 0 || landData.type2?.size > 0) ? increment(1) : 0
          }
        }
      }
    };

    // Use setDoc with merge: true to create the document if it doesn't exist
    await setDoc(statsRef, updates, { merge: true });
    console.log("Stats updated successfully");
  }
}

//   // Update stats with land size information
//   if (reportSelections.COUNTRY && reportSelections.REGION && reportSelections.SMMEs) {
    
//    // Before saving to Firestore, ensure land data is properly structured
// const landSize1 = landData.type1?.size ? parseFloat(landData.type1.size) : 0;
// const landSize2 = landData.type2?.size ? parseFloat(landData.type2.size) : 0;
// const totalLandSize = landSize1 + landSize2;
// const hasLandSize = totalLandSize > 0;

// // Update the stats document
// const statsRef = doc(db, "stats", "registrations");
// await updateDoc(statsRef, {
//   [regionName]: {
//     total: increment(1),
//     landSizeCount: hasLandSize ? increment(1) : 0,
//     landSizeTotal: hasLandSize ? increment(totalLandSize) : 0,
//     bySmmetype: {
//       [smmeType]: {
//         count: increment(1),
//         landSizeCount: hasLandSize ? increment(1) : 0,
//         landSizeTotal: hasLandSize ? increment(totalLandSize) : 0
//       }
//     }
//   }
// }, { merge: true });
//   }
    // Save to Firestore
    const docRef = doc(db, "registrations", uid);

    await setDoc(docRef, userData);
 
    setRegistrationNumber(regNumber);
    setIsModalOpen(true);
    setShowCelebration(!isLoggedIn); // Only show celebration for new registrations
    
    
    // Send email
    // Send email
    if (formData.email) {
      await sendRegistrationEmail({
        user_name: `${formData.firstName} ${formData.surname}`,
        registration_number: regNumber,
        user_email: formData.email,
        user_type: dropdownSelections.user_type,
        name: `${formData.firstName} ${formData.surname}`,
        email: formData.email,
        isUpdate: isLoggedIn
      });
    }
  } catch (error) {
    console.error("Registration error:", {
      name: error.name,
      message: error.message,
      stack: error.stack,
      code: error.code
    });
    
    let errorMessage = "Registration failed. Please try again.";
    
    if (error.code === 'auth/email-already-in-use') {
      errorMessage = "Email already in use.";
    } else if (error.code === 'auth/weak-password') {
      errorMessage = "Password should be at least 6 characters.";
    } else if (error.message.includes('upload files')) {
      errorMessage = error.message;
    }
    
    setRegistrationError(errorMessage);
  } finally {
    setLoading(false);
  }
};
const uploadAdvertisementImageToCloudinary = async (file, folderName = 'advertisements') => {
  try {
    if (!file) return null;
    
    const uploadResult = await uploadToCloudinary(file, {
      folder: `${folderName}/${auth.currentUser?.uid || 'temp'}`,
      userId: auth.currentUser?.uid
    });
    
    return uploadResult.url;
  } catch (error) {
    console.error("Advertisement image upload error:", error);
    throw new Error("Failed to upload advertisement image");
  }
};
const prepareAdvertisementData = (cards, type) => {
  return cards.map(card => ({
    title: card.title,
    description: card.description,
    mainImage: card.mainImage, // Already the Cloudinary URL
    badgeImage: card.badgeImage,
    bgColor: card.bgColor || '#D9D9D9',
    type: type,
    createdAt: new Date().toISOString()
  }));
};
const [uploadingImages, setUploadingImages] = useState({});
const handleResetPassword = async () => {
  try {
    setForgotPasswordError("");
    
    if (!newPassword || !confirmPassword) {
      setForgotPasswordError("Please enter and confirm your new password");
      return;
    }

    if (newPassword.length < 6) {
      setForgotPasswordError("Password must be at least 6 characters");
      return;
    }

    if (newPassword !== confirmPassword) {
      setForgotPasswordError("Passwords do not match");
      return;
    }

    // Get the current user
    const user = auth.currentUser;
    
    if (!user) {
      setForgotPasswordError("No user found. Please try logging in again.");
      return;
    }

    // Update the password
    await updatePassword(user, newPassword);
    
    setForgotPasswordStep(1);
    setForgotPasswordSuccess("Password has been reset successfully!");
    setIsForgotPasswordModalOpen(false);
    
    // Clear form
    setForgotPasswordEmail("");
    setVerificationCode("");
    setNewPassword("");
    setConfirmPassword("");

    // Reopen the edit modal
    setIsEditModalOpen(true);
  } catch (error) {
    console.error("Password reset error:", error);
    setForgotPasswordError(error.message || "Failed to reset password. Please try again.");
  }
};
const [isForgotPasswordModalOpen, setIsForgotPasswordModalOpen] = useState(false);
const [isForgotPasswordModalOpen1, setIsForgotPasswordModalOpen1] = useState(false);

const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
const [verificationCode, setVerificationCode] = useState("");
const [newPassword, setNewPassword] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
const [forgotPasswordStep, setForgotPasswordStep] = useState(1); // 1 = email, 2 = code, 3 = new password
const [forgotPasswordError, setForgotPasswordError] = useState("");
const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState("");

const handleForgotPassword = async () => {
  try {
    setForgotPasswordError("");
    if (!forgotPasswordEmail) {
      setForgotPasswordError("Please enter your email address");
      return;
    }

    // Send the password reset email
    await sendPasswordResetEmail(auth, forgotPasswordEmail);
    
    setForgotPasswordStep(2); // Move to success message step
    setForgotPasswordSuccess("Password reset link has been sent to your email");
  } catch (error) {
    console.error("Password reset error:", error);
    
    // Show success message even if email doesn't exist (for security)
    setForgotPasswordStep(2);
    setForgotPasswordSuccess("If an account exists, a password reset link has been sent");
    
    // Don't show the actual error to users
    setForgotPasswordError("");
  }
};
      // Add this temporary test function somewhere in your component
      const testFirestoreConnection = async () => {
        try {
          const testDocRef = doc(db, "test_collection", "test_doc_" + Date.now());
          await setDoc(testDocRef, {
            test: true,
            timestamp: new Date().toISOString()
          });
          return true;
        } catch (error) {
          console.error("Detailed Firestore connection error:", error);
          return false;
        }
      };
  // Check if Firebase is initialized
console.log("Firebase app:", app?.name); 
console.log("Firestore instance:", db);
console.log("Auth instance:", auth);

// Check authentication state
auth.onAuthStateChanged((user) => {
  console.log("Auth state changed:", user ? "Logged in" : "Logged out");
});
  // Call it somewhere, like in a useEffect or button click
    const handleFocusSave = (data) => {
        console.log("Areas of Focus:", data);
        // {
        //   cooperativeName: ...,
        //   typeOfFocus: ...,
        //   selectedAreas: [...],
        //   selectedDisabilityType: ...
        // }
    };
    // Save User Data to Firestore
    // Add this helper function to normalize region data
    const getRegionMap = (country) => {
  const countryMappings = {
    'South Africa': {
      "Gauteng": "01",
      "Eastern Cape": "02",
      "Limpopo": "03",
      "KwaZulu-Natal": "04",
      "Mpumalanga": "05",
      "Western Cape": "06",
      "North West": "07",
      "Northern Cape": "08",
      "Free State": "09"
    },
    'Kenya': {
      "Mombasa": "1",
      "Kwale": "2",
      "Kilifi": "3",
      "Tana River": "4",
      "Lamu": "5",
      "Taita Taveta": "6",
      "Garissa": "7",
      "Wajir": "8",
      "Mandera": "9",
      "Marsabit": "10",
      "Isiolo": "11",
      "Meru": "12",
      "Tharaka-Nithi": "13",
      "Embu": "14",
      "Kitui": "15",
      "Machakos": "16",
      "Makueni": "17",
      "Nyandarua": "18",
      "Nyeri": "19",
      "Kirinyaga": "20",
      "Murang'a": "21",
      "Kiambu": "22",
      "Turkana": "23",
      "West Pokot": "24",
      "Samburu": "25",
      "Trans Nzoia": "26",
      "Uasin Gishu": "27",
      "Elgeyo-Marakwet": "28",
      "Nandi": "29",
      "Baringo": "30",
      "Laikipia": "31",
      "Nakuru": "32",
      "Narok": "33",
      "Kajiado": "34",
      "Kericho": "35",
      "Bomet": "36",
      "Kakamega": "37",
      "Vihiga": "38",
      "Bungoma": "39",
      "Busia": "40",
      "Siaya": "41",
      "Kisumu": "42",
      "Homa Bay": "43",
      "Migori": "44",
      "Kisii": "45",
      "Nyamira": "46",
      "Nairobi City": "47"
    },
    'Namibia': {
      "Erongo": "08",
      "Hardap": "12",
      "Kavango East": "06",
      "Kavango West": "14",
      "Khomas": "11",
      "Kunene": "01",
      "Ohangwena": "04",
      "Omaheke": "10",
      "Omusati": "02",
      "Oshana": "03",
      "Oshikoto": "05",
      "Otjozondjupa": "09",
      "Zambezi": "07",
      "Karas": "013"
    },
    'Zambia': {
      "Western": "1",
      "Central": "2",
      "Eastern": "3",
      "Luapula": "4",
      "Northern": "5",
      "North-Western": "6",
      "Southern": "7",
      "Copperbelt": "8",
      "Lusaka": "9",
      "Muchinga": "10"
    },
    'Burundi': {
      "Buhumuza": "01",
      "Bujumbura": "02",
      "Burunga": "03",
      "Butanyerera": "04",
      "Gitega": "05"
    },
    'Rwanda': {
      "City of Kigali": "01",
      "Eastern": "02",
      "Northern": "03",
      "Southern": "04",
      "Western": "05"
    },
    'Uganda': {
      "Northern": "01",
      "Eastern": "02",
      "Central": "03",
      "Western": "04"
    },
    'Malawi': {
      "Northern": "01",
      "Central": "02",
      "Southern": "03"
    },
    'Angola': {
      "Bengo": "01",
      "Benguela": "02",
      "Bié": "03",
      "Cabinda": "04",
      "Cuando Cubango": "05",
      "Cuanza Norte": "07",
      "Cuanza Sul": "08",
      "Cunene": "09",
      "Huambo": "10",
      "Huíla": "11",
      "Luanda": "13",
      "Lunda Norte": "14",
      "Lunda Sul": "15",
      "Malanje": "16",
      "Moxico": "17",
      "Namibe": "19",
      "Uíge": "20",
      "Zaire": "21"
    },
    'Burkina Faso': {
      "Boucle du Mouhoun": "01",
      "Cascades": "02",
      "Centre": "03",
      "Centre-Est": "04",
      "Centre-Nord": "05",
      "Centre-Ouest": "06",
      "Centre-Sud": "07",
      "Est": "08",
      "Hauts-Bassins": "09",
      "Nord": "10",
      "Plateau-Central": "11",
      "Sahel": "12",
      "Sud-Ouest": "13"
    },
    'Eswatini': {
      "Hhohho": "01",
      "Manzini": "02",
      "Lubombo": "03",
      "Shiselweni": "04"
    },
    'Lesotho': {
      "Berea": "01",
      "Butha-Buthe": "02",
      "Leribe": "03",
      "Mafeteng": "04",
      "Maseru": "05",
      "Mohale's Hoek": "06",
      "Mokhotlong": "07",
      "Qacha's Nek": "08",
      "Quthing": "09",
      "Thaba-Tseka": "10"
    },
    'Tanzania': {
      "Arusha": "01",
      "Dar es Salaam": "02",
      "Dodoma": "03",
      "Geita": "04",
      "Iringa": "05",
      "Kagera": "06",
      "Katavi": "07",
      "Kigoma": "08",
      "Kilimanjaro": "09",
      "Lindi": "10",
      "Manyara": "11",
      "Mara": "12",
      "Mbeya": "13",
      "Mjini Magharibi (Zanzibar Urban/West)": "14",
      "Morogoro": "15",
      "Mtwara": "16",
      "Mwanza": "17",
      "Njombe": "18",
      "Pemba North": "19",
      "Pemba South": "20",
      "Pwani (Coast)": "21",
      "Rukwa": "22",
      "Ruvuma": "23",
      "Shinyanga": "24",
      "Simiyu": "25",
      "Singida": "26",
      "Songwe": "27",
      "Tabora": "28",
      "Tanga": "29"
    },
    'Cameroon': {
      "Adamawa": "01",
      "Centre": "02",
      "East": "03",
      "Far North": "04",
      "Littoral": "05",
      "North": "06",
      "North-West": "07",
      "West": "08",
      "South": "09",
      "South-West": "10"
    },
'Democratic Republic of the Congo': {
  "Bas-Uele": "01",
  "Equateur": "02",
  "Haut-Katanga": "03",
  "Haut-Lomami": "04",
  "Haut-Uele": "05",
  "Ituri": "06",
  "Kasai": "07",
  "Kasai-Central": "08",
  "Kasai-Oriental": "09",
  "Kinshasa": "10",
  "Kongo-Central": "11",
  "Kwango": "12",
  "Kwilu": "13",
  "Lomami": "14",
  "Lualaba": "15",
  "Mai-Ndombe": "16",
  "Maniema": "17",
  "Mongala": "18",
  "Nord-Kivu": "19",
  "Nord-Ubangi": "20",
  "Sankuru": "21",
  "Sud-Kivu": "22",
  "Sud-Ubangi": "23",
  "Tanganyika": "24",
  "Tshopo": "25",
  "Tshuapa": "26"
},
'Congo (Kinshasa/DRC)': { // Add this as an alias
  "Bas-Uele": "01",
  "Equateur": "02",
  "Haut-Katanga": "03",
  "Haut-Lomami": "04",
  "Haut-Uele": "05",
  "Ituri": "06",
  "Kasai": "07",
  "Kasai-Central": "08",
  "Kasai-Oriental": "09",
  "Kinshasa": "10",
  "Kongo-Central": "11",
  "Kwango": "12",
  "Kwilu": "13",
  "Lomami": "14",
  "Lualaba": "15",
  "Mai-Ndombe": "16",
  "Maniema": "17",
  "Mongala": "18",
  "Nord-Kivu": "19",
  "Nord-Ubangi": "20",
  "Sankuru": "21",
  "Sud-Kivu": "22",
  "Sud-Ubangi": "23",
  "Tanganyika": "24",
  "Tshopo": "25",
  "Tshuapa": "26"
},
    'Ethiopia': {
      "Addis Ababa": "01",
      "Afar": "02",
      "Amhara": "03",
      "Benishangul-Gumuz": "04",
      "Dire Dawa": "05",
      "Gambela": "06",
      "Harari": "07",
      "Oromia": "08",
      "Sidama": "09",
      "Somali": "10",
      "Southern Nations (SNNPR)": "11",
      "Tigray": "12"
    },
  'Côte d\'Ivoire (Ivory Coast)': {
      "Abidjan": "1",
      "Yamoussoukro": "2",
      "Bas-Sassandra": "3",
      "Comoé": "4",
      "Denguélé": "5",
      "Gôh-Djiboua": "6",
      "Lacs": "7",
      "Lagunes": "8",
      "Montagnes": "9",
      "Sassandra-Marahoué": "10",
      "Savanes": "11",
      "Vallée du Bandama": "12",
      "Woroba": "13",
      "Zanzan": "14"
    },
    'Ghana': {
      "WESTERN": "1",
      "CENTRAL": "2",
      "GREATER ACCRA": "3",
      "VOLTA": "4",
      "EASTERN": "5",
      "ASHANTI": "6",
      "WESTERN NORTH": "7",
      "AHAFO": "8",
      "BONO": "9",
      "BONO EAST": "10",
      "OTI": "11",
      "NORTHERN": "12",
      "SAVANNAH": "13",
      "UPPER WEST": "14",
      "NORTH EAST": "15",
      "UPPER EAST": "16"
    },
    'Mozambique': {
      "Cabo Delgado": "1",
      "Gaza": "2",
      "Inhambane": "3",
      "Manica": "4",
      "Maputo City": "5",
      "Maputo": "6",
      "Nampula": "7",
      "Niassa": "8",
      "Sofala": "9",
      "Tete": "10",
      "Zambezia": "11"
    },
    'Nigeria': {
      "North Central (NC)": "1",
      "North East (NE)": "2",
      "North West (NW)": "3",
      "South East (SE)": "4",
      "South South (SS)": "5",
      "South West (SW)": "6"
    },
    // ... other country mappings ...
    'Senegal': {
      "Dakar": "01",
      "Diourbel": "02",
      "Fatick": "03",
      "Kaffrine": "04",
      "Kaolack": "05",
      "Kedougou": "06",
      "Kolda": "07",
      "Louga": "08",
      "Matam": "09",
      "Saint-Louis": "10",
      "Sedhiou": "11",
      "Tambacounda": "12",
      "Thies": "13",
      "Ziguinchor": "14"
    },
  };
 // Handle case where country might be "Congo (Kinshasa/DRC)"
 const normalizedCountry = country === "Congo (Kinshasa/DRC)" 
 ? "Democratic Republic of the Congo" 
 : country;

if (!countryMappings[normalizedCountry]) {
 return {
   "-": "No regions available"
 };
}



  return {
    ...countryMappings[country],
  };
  
};
const getRegionCode = (regionName, countryName) => {
  const regionMap = getRegionMap(countryName);
  return regionMap[regionName] || null;
};

// Update the handleReportDropdownChange function
const uploadMarketingImageToCloudinary = async (file, folderName = 'marketing') => {
  try {
    if (!file) return null;
    
    const uploadResult = await uploadToCloudinary(file, {
      folder: `${folderName}/${auth.currentUser?.uid || 'temp'}`,
      userId: auth.currentUser?.uid
    });
    
    return uploadResult.url;
  } catch (error) {
    console.error("Marketing image upload error:", error);
    throw new Error("Failed to upload marketing image");
  }
};
    const saveUserData = async (uid, regNumber) => {
        try {
          console.log("Attempting to save user data to Firestore...");
          
          if (!uid) throw new Error("No user ID provided");
          if (!regNumber) throw new Error("No registration number provided");
          
          // Prepare the user payload
          const userPayload = {
            uid,
            registrationNumber: regNumber,
            personalInfo: { 
              ...formData, 
              race: race || "", 
              gender: gender || "", 
              disability: disability || "",
              profileImage: {
                url: profileImage?.url || '',
                previewUrl: profileImage?.previewUrl || '',
                cloudinaryUrl: profileImage?.cloudinaryUrl || '',
                documentType: 'Profile Image'
              }
          
            },
            organizationInfo: { 
              ...orgFormData,
              typeOfOrganization: orgType, // Add this line
              orgType: orgType || "",
    certificates: certificatesUrls.map(cert => ({
  url: cert.url || '',
  previewUrl: cert.previewUrl || cert.url || '',
  cloudinaryUrl: cert.cloudinaryUrl || cert.url || '',
  documentType: cert.documentType || cert.type || 'Unknown',
  type: cert.type || 'certificate',
  file: cert.file // if needed
})),
              idDocument: idDocumentUrl || "",
              productImages: productImages.map(img => img.url || img.previewUrl).filter(Boolean) || []
            },
            dropdownSelections: dropdownSelections || {},
            reportSelections: {
              COUNTRY: reportSelections.COUNTRY?.name || reportSelections.COUNTRY || "--",
              REGION: typeof reportSelections.REGION === 'object'
          ? reportSelections.REGION
          : { name: reportSelections.REGION, value: getRegionCode(reportSelections.REGION, reportSelections.COUNTRY) },
              DISTRICT: reportSelections.DISTRICT?.name || reportSelections.DISTRICT || "--",
              MUNICIPALITY: reportSelections.MUNICIPALITY || "--",
              SMMEs: reportSelections.SMMEs?.value || reportSelections.SMMEs || "--",
              "VALUE CHAIN": reportSelections["VALUE CHAIN"] || "--",
              PROJECT: reportSelections.PROJECT || "--",
              "USER TYPE": reportSelections["USER TYPE"] || "--"
            },
            language: selectedLanguage || "",
            landData: {
              type1: landType1 || "",
              type2: landType2 || "",
              erfNumber: erfNumber || ""
            },
            profingSkills: selectedSkills || [],
            membershipData: {
              selected: membershipData.selected || [],
              custom: membershipData.custom || [],
              customInputBoxes: membershipData.customInputBoxes || [],
              inputs: membershipData.inputs || {},
              organizationName: membershipData.organizationName || '',
              membershipNumber: membershipData.membershipNumber || '',
              membershipType: membershipData.membershipType || '',
              membershipDate: membershipData.membershipDate || ''
            },
            groupExperience: groupExperience || [],
            dataPermissions: dataPermissions || [],
            sectionD: { 
              focusSelected: focusSelected || [], 
              selectedType: selectedType || "", 
              selectedOption: selectedOption || "", 
              selectedCategories: selectedCategories || [] 
            },
            industry: { 
              selectedChallenges: selectedChallenges || [], 
              vision: vision || "" 
            },
            setaQualification: { 
              selectedS: selectedS || "", 
              selectedQ: selectedQ || "" 
            },
            location: location || null,
            registrationDate: new Date().toISOString(),
            status: "active",
            lastUpdated: new Date().toISOString()
          };
      
          console.log("User payload to save:", userPayload);
      
          // Save to Firestore with timeout
          const docRef = doc(db, "registrations", uid);
          await setDoc(docRef, userPayload);
          
          console.log("User data saved successfully to Firestore");
          return true;
        } catch (error) {
          console.error("Detailed Firestore save error:", {
            errorCode: error.code,
            errorMessage: error.message,
            errorStack: error.stack
          });
          
          if (error.code === 'permission-denied') {
            setRegistrationError("Database permission denied. Please contact support.");
          } else if (error.code === 'unavailable') {
            setRegistrationError("Network error. Please check your internet connection.");
          } else {
            setRegistrationError("Failed to save data: " + (error.message || "Unknown error"));
          }
          
          return false;
        }
      };
      const [isExpanded, setIsExpanded] = useState(false);

const toggleExpand = () => {
  setIsExpanded(!isExpanded);
};
    // Update Existing User Data
    const updateUserDetails = async () => {
        const user = auth.currentUser; // Get the currently logged-in user
        if (user) {
            const userDocRef = doc(db, "registrations", user.uid); // Reference to the user's document in Firestore
            const updatedPayload = {
                personalInfo: { ...formData },
                organizationInfo: { ...orgFormData },
                dropdownSelections,
                reportSelections,
                language: selectedLanguage,
                landData: { 
    landType1, landType2,
  erfNumber 
},
                background: { landType1, landType2, erfNumber },
                profingSkills: selectedSkills,
                membership: selectedMembership,
                groupExperience: groupExperience || [],
                dataPermissions: dataPermissions || [],
                sectionD: {
                    focusSelected,
                    selectedType,
                    selectedOption,
                    selectedCategories,
                },
                industry: { selectedChallenges, vision },
                setaQualification: { selectedS, selectedQ },
                location,
                updatedAt: new Date().toISOString(), // Add a timestamp for updates
            };

            // Save updated data to Firestore
            await setDoc(userDocRef, updatedPayload, { merge: true }); // Merge updated data with existing document
            console.log("User details updated successfully.");
        } else {
            console.error("No logged-in user found.");
            throw new Error("User not logged in.");
        }
    };
  
    const [selectedOption, setSelectedOption] = useState("Maize");
    const [selectedCategories, setSelectedCategories] = useState([]);
    const { selectedCountry, setSelectedCountry } = useCountry();
// Update the navigation handler
const handleViewRegistration = () => {
  const selectedChallengeObjects = challengesData.filter(challenge => 
    selectedChallenges.includes(challenge.id)
  );
  const processedMembershipData = {
    selected: membershipData.selected.map(item => {
      if (typeof item === 'string') return item;
      return item.label || item.value || 'Membership';
    }),
    custom: membershipData.custom || [],
    customInputBoxes: membershipData.customInputBoxes || []
  };
  const formattedProfileImage = profileImage ? {
    url: profileImage.url || '',
    previewUrl: profileImage.previewUrl || profileImage.url || '',
    cloudinaryUrl: profileImage.cloudinaryUrl || profileImage.url || '',
    documentType: 'Profile Image',
    file: profileImage.file // if needed for upload
  } : null;
  navigate('/document', {
    state: {
      personalInfo: formData,
      organizationInfo: orgFormData,
      dropdownSelections,
      reportSelections: {
           COUNTRY: reportSelections.COUNTRY || "--",
    REGION: reportSelections.REGION || "--",
    DISTRICT: reportSelections.DISTRICT || "--",
    MUNICIPALITY: reportSelections.MUNICIPALITY || "--",
    SMMEs: reportSelections.SMMEs || "--",
    "VALUE CHAIN": reportSelections["VALUE CHAIN"] || "--",
    PROJECT: reportSelections.PROJECT || "--",
    "USER TYPE": reportSelections["USER TYPE"] || "--"
      },
      selectedLanguage,
      landData,
      selectedSkills,
      membershipData: {
        selected: membershipData.selected,
        custom: membershipData.custom,
        customInputBoxes: membershipData.customInputBoxes,
        inputs: membershipData.inputs,
        organizationName: membershipData.organizationName,
        membershipNumber: membershipData.membershipNumber,
        membershipType: membershipData.membershipType,
        membershipDate: membershipData.membershipDate
      },
      groupExperience,
      dataPermissions,

      focusSelected,
      sectionD: {
        selectedType,
        selectedOption,
        selectedCategories
      },
      industry: { 
        selectedChallenges: selectedChallengeObjects,
        vision: vision
      },
      setaQualification: {
        selectedS,
        selectedQ
      },
      location: userLocation,
      registrationNumber,
      idDocumentUrl,
      profileImage: formattedProfileImage,
  productBoxValues: productBoxValues,
      productImages: productImages.map(img => ({
        url: img.url,
        previewUrl: img.previewUrl,
        cloudinaryUrl: img.cloudinaryUrl,
        file: img.file,
        documentType: img.documentType // Make sure this is included
      })),
      certificatesUrls: certificatesUrls.map(cert => ({
        url: cert.url || cert.previewUrl || cert.cloudinaryUrl || '',
        type: cert.documentType || cert.type || 'Unknown',
        documentType: cert.documentType || cert.type || 'Unknown'
      })),
      formData,
      orgType
    }
  });
};
    const handleSectionDSave = (data) => {
        // data = { typeOfOrganization: ..., categories: [...] }
        console.log("Section D Industry Interest:", data);
    };


    // ProfingSkils state
    console.log('Passing productBoxValues to PDF:', productBoxValues);
const [showProfileSections, setShowProfileSections] = useState(false);

const [profileImage, setProfileImage] = useState({
  file: null,
  url: '',
  previewUrl: '',
  cloudinaryUrl: '',
  documentType: 'Profile Image'
});

    const [productImages, setProductImages] = useState([]);
    const [agreed, setAgreed] = useState(false);
    const [showAgreementError, setShowAgreementError] = useState(false); // State for showing error
    const [selectedSkills, setSelectedSkills] = useState([]);
    const [selectedMembership, setSelectedMembership] = useState(""); // e.g. "AFASA" or "Others"
    // In RegisterAsFarm:
    

    // Update the handleMembershipSave function to ensure consistent structure
   // In RegisterAsFarm.jsx
  // Update the handleMembershipSave function
// Update the handleMembershipSave function to handle custom inputs
const handleMembershipSave = (data) => {
  console.log('Full membership data saved:', data);
  
  setMembershipData({
    selected: data.selected || [],
    custom: data.custom || [],
    customInputBoxes: data.customInputBoxes || [],
    inputs: data.inputs || {},
    organizationName: data.organizationName || '',
    membershipNumber: data.membershipNumber || '',
    membershipType: data.membershipType || '',
    membershipDate: data.membershipDate || ''
  });
  
  setHasUnsavedChanges(true);
};
    const handleProfingSkillsSave = (skills) => {
        // Example: log with cooperative name and type if you have them
        const data = {
            PersonalSkillsTrainingandQualifications:
                "PersonalSkillsTrainingandQualifications", // replace/fetch as needed
            typeOfProfingSkill: "Personal Skills Training and Qualifications",
            selectedSkills: skills,
        };
        console.log("Profing Skills:", data);
    };
    const [selectedLocation, setSelectedLocation] = useState(null);

    // Add your main save handler (use the same function as your Register button)
    const [savedLocation, setSavedLocation] = useState(null);
const SMMEsOptions = [
  {
    heading: "Agriculture and Agribusiness",
    items: [
      { label: "Smallholder farms", value: "SMF" },
      { label: "Agro-processing", value: "AGP" },
      { label: "Agri-input suppliers", value: "AIP" },
      { label: "Horticulture businesses", value: "HCB" },
      { label: "Poultry", value: "POF" },
      { label: "Fish farms", value: "FIF" },
      { label: "Agri-tech startups", value: "ATC" }
    ]
  },
  {
    heading: "Manufacturing and Processing",
    items: [
      { label: "Textile and garment production", value: "TGP" },
      { label: "Furniture making and carpentry", value: "FPC" },
      { label: "Metal fabrication", value: "MEF" },
      { label: "Soap and detergent production", value: "SDP" },
      { label: "Food and beverage processing", value: "FBP" }
    ]
  },
  {
    heading: "Retail and Trade",
    items: [
      { label: "Small shops (dukas/spazas)", value: "SDS" },
      { label: "Market vendors", value: "MAV" },
      { label: "Wholesalers and distributors", value: "WHD" },
      { label: "Online retail platforms", value: "ORP" }
    ]
  },
  {
    heading: "Services",
    items: [
      { label: "Transport and logistics", value: "TRL" },
      { label: "Repair services", value: "RPS" },
      { label: "Beauty and personal care", value: "BPC" },
      { label: "Laundry and dry cleaning", value: "LDC" },
      { label: "Hospitality", value: "HOS" },
      { label: "Event planning and catering", value: "EPC" }
    ]
  },
  {
    heading: "Technology and Innovation (Tech SMEs)",
    items: [
      { label: "Fintech", value: "FIT" },
      { label: "Healthtech", value: "HET" },
      { label: "Edtech", value: "EDT" },
      { label: "Software and app development", value: "SAD" },
      { label: "E-commerce and logistics tech", value: "ECL" }
    ]
  },
  {
    heading: "Construction and Real Estate",
    items: [
      { label: "Small construction firms", value: "SCF" },
      { label: "Real estate agents and developers", value: "RAD" },
      { label: "Hardware and building material suppliers", value: "HBM" }
    ]
  },
  {
    heading: "Creative and Cultural Industries",
    items: [
      { label: "Art and crafts production", value: "ACP" },
      { label: "Music and film production", value: "MFP" },
      { label: "Fashion and design businesses", value: "FDB" },
      { label: "Photography and videography services", value: "PVS" }
    ]
  },
  {
    heading: "Health and Wellness",
    items: [
      { label: "Private clinics and pharmacies", value: "PCP" },
      { label: "Fitness centers and gyms", value: "FCG" },
      { label: "Traditional medicine practitioners", value: "TMP" },
      { label: "Health product distributors", value: "HPD" }
    ]
  },
  {
    heading: "Education and Training",
    items: [
      { label: "Private schools and daycares", value: "PSD" },
      { label: "Vocational training centers", value: "VTC" },
      { label: "Tutoring services", value: "TUS" },
      { label: "Edtech startups", value: "EDS" }
    ]
  }
]

    // Call this when Register button is clicked
    const handleRegisterSave = () => {
        const cooperative = {
            // ...other registration fields,
            location: savedLocation,
        };
        console.log("location:", cooperative);
        // ...show modal, etc.
    };

    
    const [location, setLocation] = useState(null);

    // This gets called when "Save Location" is clicked inside LocationPicker
    const [locationCountry, setLocationCountry] = useState("");

    const handleSaveLocation = (country) => {
        setLocationCountry(country);
        console.log("User selected country:", country);
    };
const [showPassword, setShowPassword] = useState(false); // Define state for password visibility

const togglePasswordVisibility = () => {
  setShowPassword((prev) => !prev);
};
const handleCountrySelect = (country) => {
  setSelectedCountry(country);
  // Update report selections with the new country
  setReportSelections(prev => ({
    ...prev,
    COUNTRY: country.name
  }));
};

    const [showUnits, setShowUnits] = useState(false);
    const [selectedUnit, setSelectedUnit] = useState("Hectare");
    const [landSize, setLandSize] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [copyMessage, setCopyMessage] = useState("");

    const [selected3, setSelected3] = useState("Individual");

    const handleCopy = () => {
        navigator.clipboard.writeText("ZA25-582-9511");
        setCopyMessage("Copied!"); // Set the "Copied!" message

        // Hide the message after 2 seconds
        setTimeout(() => {
            setCopyMessage("");
        }, 2000);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const units = ["Hectare", "Acre", "Square Meter"];

    const handleUnitSelect = (unit) => {
        setSelectedUnit(unit);
        setShowUnits(false);
    };

    // Report dropdown state
    const [reportSelections, setReportSelections] = useState({
        COUNTRY: "-",
        REGION: "-",
        DISTRICT: "-",
        MUNICIPALITY: "-",
        SMMEs: "-",
        "VALUE CHAIN": "-",
        PROJECT: "-",
        "USER TYPE": "-"
      });
          const [regions, setRegions] = useState([]);
          const [isDeleting, setIsDeleting] = useState(false);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
// In ReportsSection component or wherever you handle dropdown changes
const handleReportDropdownChange = (type, value) => {
  setReportSelections(prev => {
    const newSelections = {
      ...prev,
      [type]: value
    };
    
    // When country changes, reset dependent fields
    if (type === 'COUNTRY') {
      newSelections.REGION = "-";
      newSelections.DISTRICT = "-";
      newSelections.MUNICIPALITY = "-";
    }
    
    return newSelections;
  });
};
    const [selectedLanguage, setSelectedLanguage] = useState(null);
    console.log('Navigation URL:', `/ReportsRegistrationPage?country=${
        encodeURIComponent(
          typeof reportSelections.COUNTRY === 'object' 
            ? reportSelections.COUNTRY.name 
            : reportSelections.COUNTRY || "South Africa"
        )
      }`);
      const getSafeCountryName = (countryData) => {
        try {
          if (!countryData) return 'South Africa';
          if (typeof countryData === 'string') return countryData;
          if (typeof countryData === 'object' && countryData.name) return countryData.name;
          return 'South Africa';
        } catch (e) {
          console.error('Error parsing country data:', e);
          return 'South Africa';
        }
      };
      const [userTypeValue, setUserTypeValue] = useState({});

    const handleLanguageChange = (lang) => {
        setSelectedLanguage(lang);
        console.log("Selected language:", lang);
    };
    // Add this state for advertisement image editing
const [advertisementEditingState, setAdvertisementEditingState] = useState({
  isOpen: false,
  imageSrc: null,
  imageType: null,
  imageFile: null,
  context: null // { cardIndex, imageType: 'advertisement' }
});
    const [advertisementCards, setAdvertisementCards] = useState([
      {
        mainImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758458137/image_2529_djjnax.png",
        badgeImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754927255/image_2150_rhvdri.png",
        title: "Veterinary",
        description: "Limited-Time Offer: 20% Off Cakes!  Ready for a fresh pastry? Enjoy 20% OFF your session!"
      },
      {
        mainImage: null,
        badgeImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754927255/image_2150_rhvdri.png",
        title: "-",
        description: "Special Offer: 20% Discount!\nReady for our services? Enjoy 20% OFF!",
        bgColor: "#D9D9D9"
      },
      {
        mainImage: null,
        badgeImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754927255/image_2150_rhvdri.png",
        title: "-",
        description: "Special Offer: 20% Discount!\nReady for our services? Enjoy 20% OFF!",
        bgColor: "#D9D9D9"
      },
      {
        mainImage: null,
        badgeImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754927255/image_2150_rhvdri.png",
        title: "-",
        description: "Special Offer: 20% Discount!\nReady for our services? Enjoy 20% OFF!",
        bgColor: "#D9D9D9"
      }
    ]);
    
    const saveAllFormData = () => {
      const dataToSave = {
        formData,
        orgFormData,
        dropdownSelections,
        reportSelections,
        selectedLanguage,
        landData, // Changed from landType1, landType2, erfNumber
        selectedSkills,
        membershipData,
        groupExperience,
        dataPermissions,
        focusSelected,
        selectedType,
        selectedOption,
        selectedCategories,
        selectedChallenges,
        vision,
        selectedS,
        selectedQ,
        location,
        profileImage,
        productImages,
        certificatesUrls,
        idDocumentUrl,
        agreed,
        race,
        gender,
        disability,
        orgType
      };
      
      try {
        localStorage.setItem("registrationData", JSON.stringify(dataToSave));
        console.log("Data saved to localStorage");
      } catch (error) {
        console.error("Error saving to localStorage:", error);
      }
    };
    
 
    const [race, setRace] = useState("");
    const [gender, setGender] = useState("");
    const [disability, setDisability] = useState("");
    const [personData, setPersonData] = useState({
      gender: "",
      disability: ""
    });
    const handleDisabilityChange = (selectedDisability) => {
        setDisability(selectedDisability);
    };

    // Log all values here when Save is clicked in PersonalInfoForm
    const handlePersonalInfoSave = (data) => {
        console.log("Personal Info Form Data:", data);
    };
  const [activeSection, setActiveSection] = useState('products'); // 'products' or 'bakes'

    const [isOrgDropdownOpen, setIsOrgDropdownOpen] = useState(false);
   // Update the handleTypeSelection function to also update the activeTab
const handleTypeSelection = (type) => {
  setSelectedType(type);
  
  // Update the active tab based on selection
  if (type === 'organization') {
    setActiveTab("organizations");
    setIsOrgDropdownOpen(!isOrgDropdownOpen);
    setActiveSection('bakes'); // Show bakes for organizations
  } else {
    setActiveTab("farmers");
    setIsOrgDropdownOpen(false);
    setActiveSection('products'); // Show products for farmers
  }
};
    const [orgType, setOrgType] = useState("COOPERATIVE 1"); // Initialize with a default value

    const handleOrgSave = (data) => {
        // This logs all org fields to the console
        console.log("Organization Form Data:", data);
    };

    const [loading, setLoading] = useState(false);
    const [progressMsg, setProgressMsg] = useState("");
    const [registrationError, setRegistrationError] = useState(null);
    const [registrationNumber, setRegistrationNumber] = useState("");
    const [showMembershipSections, setShowMembershipSections] = useState(false);
    const onHandleSave = async () => {
        setLoading(true);
        setProgressMsg("Saving...");
        setRegistrationError(null);
    
        try {
          let uid;
    
          if (isEditModalOpen) {
            // If the user is editing, use the existing UID from the logged-in user
            const user = auth.currentUser;
            if (!user) {
              throw new Error("User not logged in.");
            }
            uid = user.uid;
          } else {
            // Create Firebase Auth user (for new registration)
            const userCredential = await createUserWithEmailAndPassword(
              auth,
              formData.email,
              formData.password
            );
            uid = userCredential.user.uid;
            console.log("Firebase Auth user created:", userCredential.user);
          }
    
          // Generate Registration Number
          const regNumber = generateRegistrationNumber();
    
          // Build full data payload
          const registrationPayload = {
            registrationNumber: regNumber, // Make sure this is included
            userType: dropdownSelections.user_type,
            userPurpose: dropdownSelections.user_purpose,
            reportSelections,
            language: selectedLanguage,
            personalInfo: {
              ...formData,
              race, gender, disability
            },
            organizationInfo: {
              ...orgFormData,
              orgType,
           certificates: certificatesUrls.map(cert => ({
  url: cert.url || '',
  previewUrl: cert.previewUrl || cert.url || '',
  cloudinaryUrl: cert.cloudinaryUrl || cert.url || '',
  documentType: cert.documentType || cert.type || 'Unknown',
  type: cert.type || 'certificate',
  file: cert.file // if needed
})),
              idDocument: idDocumentUrl,
            },
            background: { landType1, landType2, erfNumber },
            profingSkills: selectedSkills,
            membershipData: {
              selected: membershipData.selected,
              custom: membershipData.custom,
              customInputBoxes: membershipData.customInputBoxes,
              inputs: membershipData.inputs,
              organizationName: membershipData.organizationName,
              membershipNumber: membershipData.membershipNumber,
              membershipType: membershipData.membershipType,
              membershipDate: membershipData.membershipDate
            },
            groupExperience: groupExperience || [],
            dataPermissions: dataPermissions || [],
            sectionD: { focusSelected, selectedType, selectedOption, selectedCategories },
            industry: { selectedChallenges, vision },
            setaQualification: { selectedS, selectedQ },
            location,
            registrationNumber: regNumber,
            createdAt: new Date().toISOString(),
            uid,
          };
    
          console.log("Registration data to save:", registrationPayload);
    
          // Save to Firestore
          await setDoc(doc(db, "registrations", uid), registrationPayload);
    
          // Send email (for new registrations only)
          if (!isEditModalOpen) {
            await sendRegistrationEmail({
              user_name: formData.firstName + " " + formData.surname,
              registration_number: regNumber,
              user_email: formData.email,
              user_type: dropdownSelections.user_type,
              name: formData.firstName + " " + formData.surname,
              email: formData.email,
              isUpdate: false // Explicitly false for new registrations
            });
            console.log("Registration email sent to:", formData.email, "with registration number:", regNumber);
          }else {
            // For updates
            await sendRegistrationEmail({
              user_name: formData.firstName + " " + formData.surname,
              registration_number: registrationNumber, // Use existing reg number
              user_email: formData.email,
              user_type: dropdownSelections.user_type,
              name: formData.firstName + " " + formData.surname,
              email: formData.email,
              isUpdate: true
            });
          }
    
          // Finish
          setLoading(false);
          setRegistrationNumber(regNumber);
          setIsModalOpen(true);
        } catch (e) {
          setLoading(false);
    
          // Handle errors specifically for new registrations only
          if (!isEditModalOpen) { // <-- Ensure this only applies to new users
            let customErrorMessage = "An error occurred.";
            if (e.code === "auth/email-already-in-use") {
              customErrorMessage = "Error - Email already in use / taken";
            } else if (e.code === "auth/weak-password") {
              customErrorMessage = "Error - Password is too weak";
            } else if (e.code === "auth/invalid-email") {
              customErrorMessage = "Error - Invalid email address";
            }
            setRegistrationError(customErrorMessage);
          } else {
            console.error("Error during edit:", e);
          }
        }
      };
  
    
    const pdfPreviewRef = useRef(null);
    const validateForm = () => {
      // Different validation based on selected type
      if (selectedType === 'farmer') {
          // Farmer validation - personal fields required
          const requiredFields = [
              'firstName', 'surname', 
              'idNumber', 'mobile', 
              'email', 'password'
          ];
          
          for (const field of requiredFields) {
              if (!formData[field]?.trim()) {
                  setRegistrationError(`Please fill in ${field.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
                  return false;
              }
          }
      } else if (selectedType === 'organization') {
          // Organization validation - organization fields required
          const requiredOrgFields = [
              'cooperativeName', 'mobile', 'email', 'password'
          ];
          
          for (const field of requiredOrgFields) {
              if (!orgFormData[field]?.trim() && !formData[field]?.trim()) {
                  setRegistrationError(`Please fill in ${field.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
                  return false;
              }
          }
      }
      
      // Common validation for both types
      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const email = selectedType === 'organization' ? (orgFormData.email || formData.email) : formData.email;
      if (!emailRegex.test(email)) {
          setRegistrationError("Please enter a valid email address");
          return false;
      }
      
      // Password length
      const password = selectedType === 'organization' ? (orgFormData.password || formData.password) : formData.password;
      if (password.length < 6) {
          setRegistrationError("Password must be at least 6 characters long");
          return false;
      }
      
      // Terms agreement
      if (!agreed) {
          setShowAgreementError(true);
          setRegistrationError("Please agree to the terms and conditions");
          return false;
      }
      
      return true;
  };
      useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
          if (user) {
            console.log("Logged in user:", user.uid);
          } else {
            console.log("No user logged in");
          }
        });
      
        return () => unsubscribe();
      }, []);
      
      const renderButtonWithIcon = (text, bgColor, iconColor, isLarge = false) => {
        // Define color mappings
        const bgColorClasses = {
          "#152C24": "bg-[#152C24]",
          "#2E453D": "bg-[#2E453D]",
          "#FDBB26": "bg-[#FDBB26]",
        };
      
        const iconColorClasses = {
          "#152C24": "bg-[#152C24]",
          "#2E453D": "bg-[#2E453D]",
          "#FDBB26": "bg-[#FDBB26]",
        };
      
        return (
          <div className="flex items-center">
            {/* Button Text */}
            <div className={`${bgColorClasses[bgColor]} text-white md:text-[14px] text-[5px] px-2 md:px-4 ${
              isLarge ? "md:h-[45px] py-[3px]" : "md:h-[13px] py-[3px]"
            } md:rounded-l-md rounded-l-md font-bold md:w-[200px] whitespace-nowrap flex items-center h-full`}>
              {text}
            </div>
            
            {/* Desktop Icon (visible on md and up) */}
            <div className={`${iconColorClasses[iconColor]} hidden md:flex items-center md:py-4  justify-center md:w-[57px] md:h-[45px] rounded-r-md`}>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                alt="Expand"
                className="w-[20px] h-[6px] md:h-[25px] md:w-[30px]  object-contain"
              />
            </div>
            
            {/* Mobile Icon (visible below md) */}
            <div className={`${iconColorClasses[iconColor]} md:hidden flex items-center justify-center w-[20px]  h-[14px] rounded-r-md`}>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                alt="Expand"
                className="w-[20px] h-[6px]  object-contain"
              />
            </div>
          </div>
        );
      };
      
    // Add this useEffect to load saved data when component mounts

      // Add these states near your other modal states
const [isAdminForgotPasswordModalOpen, setIsAdminForgotPasswordModalOpen] = useState(false);
const [adminForgotPasswordEmail, setAdminForgotPasswordEmail] = useState("");
const [adminForgotPasswordStep, setAdminForgotPasswordStep] = useState(1);
const [adminForgotPasswordError, setAdminForgotPasswordError] = useState("");
const [adminForgotPasswordSuccess, setAdminForgotPasswordSuccess] = useState("");
      // Update the register button click handler
 // In PDFPreviewPage.jsx (before rendering memberships)
 const [referralCodeInput, setReferralCodeInput] = useState("");
      console.log('Current country selection:', reportSelections.COUNTRY);
console.log('Generated URL:', `/ReportsRegistrationPage?country=${encodeURIComponent(reportSelections.COUNTRY)}`);
      // Update the register button click handler
      const handleRegisterClick = async () => {
        if (!validateForm()) return;
        
        setLoading(true);
        setRegistrationError(null);
      
        try {
          if (isLoggedIn) {
            // Update existing registration
            await updateUserDetails();
            setIsModalOpen(true);
          } else {
            // Create new registration
            await handleRegister();
          }
        } catch (error) {
          setRegistrationError(error.message || "Registration failed");
        } finally {
          setLoading(false); // Ensure loading is always reset
        }
      };
      // Add this near the top of your component

  // Add this to your registration function
  const debugRegistration = (payload) => {
    console.group("Registration Payload");
    console.log("User data:", payload);
    console.log("Auth state:", auth.currentUser);
    console.log("Form validation:", validateForm());
    console.groupEnd();
  };
  const saveDocumentsToFirebase = async () => {
    try {
      setIsSavingDocuments(true);
      setDocumentSaveStatus("Saving documents...");
      
      if (!auth.currentUser) {
        throw new Error("User not logged in");
      }
      
      // Upload any pending documents first
      const uploadPromises = certificatesUrls.map(async (cert, index) => {
        if (cert.file && !cert.cloudinaryUrl) {
          const cloudinaryUrl = await uploadDocumentImage(cert.file, index);
          return { ...cert, cloudinaryUrl };
        }
        return cert;
      });
      
      const uploadedCertificates = await Promise.all(uploadPromises);
      
      // Save to Firebase
      const userRef = doc(db, "registrations", auth.currentUser.uid);
      await updateDoc(userRef, {
        "organizationInfo.certificates": uploadedCertificates.map(cert => ({
          title: cert.title,
          url: cert.cloudinaryUrl || cert.url || '',
          previewUrl: cert.previewUrl || '',
          cloudinaryUrl: cert.cloudinaryUrl || '',
          documentType: cert.documentType || cert.type || 'Unknown',
          type: cert.type || 'certificate',
          uploadedAt: new Date().toISOString()
        })),
        lastUpdated: new Date().toISOString()
      });
      
      setDocumentSaveStatus("Documents saved successfully!");
      setTimeout(() => setDocumentSaveStatus(""), 3000);
      
    } catch (error) {
      console.error("Error saving documents:", error);
      setDocumentSaveStatus("Failed to save documents. Please try again.");
    } finally {
      setIsSavingDocuments(false);
    }
  };
    // Example: Reset error when typing in the email or password fields
    const handleFormInputChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
        setRegistrationError(null); // Clear the error when the user starts typing
    };
// Add this useEffect hook to automatically save all form data
useEffect(() => {
  const saveData = () => {
    const dataToSave = {
      formData,
      orgFormData,
      dropdownSelections,
      reportSelections,
      selectedLanguage,
      landData,
      selectedSkills,
      membershipData,
      groupExperience,
      dataPermissions,
      focusSelected,
      selectedType,
      selectedOption,
      selectedCategories,
      selectedChallenges,
      vision,
      selectedS,
      selectedQ,
      location,
      profileImage,
      productImages,
      certificatesUrls,
      idDocumentUrl,
      agreed,
      race,
      gender,
      disability,
      orgType
    };
    
    try {
      localStorage.setItem('farmRegistrationData', JSON.stringify(dataToSave));
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };
  // Save data when component unmounts or before page refresh/close
  const handleBeforeUnload = (e) => {
    saveData();
  };

  window.addEventListener('beforeunload', handleBeforeUnload);
  
  // Also save periodically (every 30 seconds) in case beforeunload doesn't fire
  const saveInterval = setInterval(saveData, 30000);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
    clearInterval(saveInterval);
    saveData(); // One final save when component unmounts
  };
}, [
  // All state dependencies
  formData, orgFormData, dropdownSelections, reportSelections,
  selectedLanguage, landData, selectedSkills, membershipData,
  groupExperience,
  dataPermissions, focusSelected, selectedType, selectedOption,
  selectedCategories, selectedChallenges, vision, selectedS,
  selectedQ, location, profileImage, productImages, certificatesUrls,
  idDocumentUrl, agreed, race, gender, disability, orgType
]);
useEffect(() => {
  return () => {
    // Clean up object URLs when component unmounts
    if (profileImage?.previewUrl) URL.revokeObjectURL(profileImage.previewUrl);
    productImages.forEach(img => {
      if (img.previewUrl) URL.revokeObjectURL(img.previewUrl);
    });
    certificatesUrls.forEach(cert => {
      if (cert.previewUrl) URL.revokeObjectURL(cert.previewUrl);
    });
    if (idDocumentUrl && typeof idDocumentUrl === 'object' && idDocumentUrl.previewUrl) {
      URL.revokeObjectURL(idDocumentUrl.previewUrl);
    }
  };
}, [profileImage, productImages, certificatesUrls, idDocumentUrl]);
useEffect(() => {
  const handleBeforeUnload = (e) => {
    // Check if there's any unsaved data (you can customize this condition)
    const hasUnsavedData = Object.values(formData).some(value => value) || 
                          Object.values(orgFormData).some(value => value);
    
    if (hasUnsavedData) {
      e.preventDefault();
      e.returnValue = 'Are you sure you want to leave this page? Your registration progress may be lost.';
      return e.returnValue;
    }
  };

  window.addEventListener('beforeunload', handleBeforeUnload);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, [formData, orgFormData]); // Add other state dependencies if needed


// Inside your component


// Add this useEffect to sync the top tab with the selectedType
useEffect(() => {
  if (selectedType === 'farmer') {
    setActiveTab("farmers");
  } else if (selectedType === 'organization') {
    setActiveTab("organizations");
  }
}, [selectedType]);



// Add this function to handle top tab clicks
const handleTopTabClick = (tab) => {
  setActiveTab(tab);
  
  if (tab === "organizations") {
    setSelectedType('organization');
    setIsOrgDropdownOpen(!isOrgDropdownOpen);
    setActiveSection('bakes');
  } else {
    setSelectedType('farmer');
    setIsOrgDropdownOpen(false);
    setActiveSection('products');
  }
};

                      // Add this useEffect hook near your other useEffect hooks in the component
                      useEffect(() => {
                        const handleBeforeUnload = (e) => {
                          // Check if there's any unsaved data (customize this condition as needed)
                          const hasUnsavedData = 
                            formData.firstName || 
                            formData.surname || 
                            formData.email || 
                            formData.password || 

                            orgFormData.cooperativeName ||
                            (selectedChallenges && selectedChallenges.length > 0) ||
                            (productImages && productImages.length > 0);
                      
                          if (hasUnsavedData) {
                            // Modern browsers require setting both returnValue and preventDefault
                            e.preventDefault();
                            e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
                            return e.returnValue;
                          }
                        };
                      
                        window.addEventListener('beforeunload', handleBeforeUnload);
                      
                        return () => {
                          window.removeEventListener('beforeunload', handleBeforeUnload);
                        };
                      }, [formData, orgFormData, selectedChallenges, productImages]);
  const [clicked, setClicked] = useState(false);
  
  const validatedReportSelections = {
    COUNTRY: reportSelections.COUNTRY || "--",
    REGION: reportSelections.REGION || "--",
    DISTRICT: reportSelections.DISTRICT || "--",
    MUNICIPALITY: reportSelections.MUNICIPALITY || "--",
    SMMEs: reportSelections.SMMEs || "--",
    "VALUE CHAIN": reportSelections["VALUE CHAIN"] || "--",
    PROJECT: reportSelections.PROJECT || "--",
    "USER TYPE": reportSelections["USER TYPE"] || "--"
  };
  useEffect(() => {
    console.log("Current membership data:", membershipData);
  }, [membershipData]);

  const UnselectedIcon = () => (
    <svg
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-[6px] h-[6px] md:w-[17px] md:h-[17px]"
    >
      <circle cx="8.5" cy="8.5" r="8" fill="#D9D9D9" stroke="none" />
    </svg>
  );
  
  const SelectedIcon = () => (
    <svg
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-[6px] h-[6px] md:w-[17px] md:h-[17px]"
    >
      <circle cx="8.5" cy="8.5" r="8" fill="#2E453D" stroke="#FFBD26" />
      <path
        d="M5 8.5L7.5 11L12 6"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  // Calculate thumb height based on content height
useEffect(() => {
  const content = contentRef.current;
  if (!content) return;

  const updateThumbHeight = () => {
      const { scrollHeight, clientHeight } = content;
      const visibleRatio = clientHeight / scrollHeight;
      setThumbHeight(Math.max(visibleRatio * (clientHeight - 40), 20));
  };

  updateThumbHeight();
  window.addEventListener("resize", updateThumbHeight);
  return () => window.removeEventListener("resize", updateThumbHeight);
}, [isOrgDropdownOpen, dropdownItems.ORGANIZATION]);

// Handle scroll events
const handleScroll = () => {
  const content = contentRef.current;
  if (!content) return;

  const { scrollTop, scrollHeight, clientHeight } = content;
  const maxScrollTop = scrollHeight - clientHeight;
  const scrollRatio = scrollTop / maxScrollTop;
  const trackHeight = content.clientHeight - 40;
  setScrollTop(scrollRatio * trackHeight + 20);
};

// Mouse down on thumb
const handleThumbMouseDown = (e) => {
  e.preventDefault();
  e.stopPropagation();
  setIsDragging(true);
  setStartY(e.clientY);
  setStartScrollTop(contentRef.current.scrollTop);
  document.addEventListener("mousemove", handleThumbMouseMove);
  document.addEventListener("mouseup", handleThumbMouseUp);
  document.body.style.cursor = "grabbing";
};

// Mouse move when dragging thumb
const handleThumbMouseMove = (e) => {
  if (!isDragging) return;
  const deltaY = e.clientY - startY;
  const content = contentRef.current;
  const { scrollHeight, clientHeight } = content;
  const maxScrollTop = scrollHeight - clientHeight;
  const trackHeight = clientHeight - 40;

  const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
  const newScrollTop = Math.min(
      Math.max(0, startScrollTop + scrollDelta),
      maxScrollTop
  );
  content.scrollTop = newScrollTop;
};

// Mouse up when dragging thumb
const handleThumbMouseUp = () => {
  setIsDragging(false);
  document.removeEventListener("mousemove", handleThumbMouseMove);
  document.removeEventListener("mouseup", handleThumbMouseUp);
  document.body.style.cursor = "";
};

// Click on track to jump to position
const handleTrackClick = (e) => {
  const content = contentRef.current;
  if (!content || e.target === thumbRef.current) return;

  const track = e.currentTarget;
  const trackRect = track.getBoundingClientRect();
  const clickPosition = e.clientY - trackRect.top;
  
  if (clickPosition < 20) {
      content.scrollTop -= 50;
      return;
  } else if (clickPosition > trackRect.height - 20) {
      content.scrollTop += 50;
      return;
  }

  const thumbCenter = thumbHeight / 2;
  const scrollRatio =
      (clickPosition - 20 - thumbCenter) / (trackRect.height - 40 - thumbHeight);

  const { scrollHeight, clientHeight } = content;
  const maxScrollTop = scrollHeight - clientHeight;
  content.scrollTop = scrollRatio * maxScrollTop;
};

// Scroll up handler
const handleScrollUp = () => {
  if (contentRef.current) {
      contentRef.current.scrollTop -= 50;
  }
};

// Scroll down handler
const handleScrollDown = () => {
  if (contentRef.current) {
      contentRef.current.scrollTop += 50;
  }
};
  const [disabilities, setDisabilities] = useState([]); // Changed from disability
  const contentRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [thumbHeight, setThumbHeight] = useState(40);
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);
  const [startScrollTop, setStartScrollTop] = useState(0);
  const thumbRef = useRef(null);
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("PRODUCTS"); // Default to PRODUCTS
  const [isEditingAbout, setIsEditingAbout] = useState(false);
  const [isEditingPlaceholder, setIsEditingPlaceholder] = useState(false);
  const [isEditingTagline, setIsEditingTagline] = useState(false);
  const [aboutText, setAboutText] = useState(
    "At Ubuntu Farm, nestled in the heart of Gauteng, we’re a small, community-rooted farm dedicated to growing fresh, wholesome produce with care and passion. Whether you're visiting us for a farm-fresh market day or simply enjoying the peaceful countryside, we offer a warm, welcoming atmosphere and honest, homegrown goodness. Our produce and products are cultivated using sustainable practices and inspired by the rich agricultural heritage of the region."
  );
  
  const [placeholderText, setPlaceholderText] = useState(
    "Type here to insert information about your enterprise"
  );
  
  const [tagline, setTagline] = useState(
    "Customer is at the heart of our business"
  );
  const [products, setProducts] = useState([
    {
      id: "cake-1",
      category: "Polutry",
      items: [
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758364341/image_2516_xtqife.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" }
      ]
    },
  
    {
      id: "doughnut-1",
      category: "Tomatoes",
      items: [
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758364341/image_2519_zjqewa.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" }
      ]
    },
  
    {
      id: "samosa-1",
      category: "Maize",
      items: [
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758364341/image_2517_zibaol.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" }
      ]
    },
  
    {
      id: "potatoes-1",
      category: "Potatoes",
      items: [
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758364341/image_2518_enqxda.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" },
        { name: "", variety: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png" }
      ]
    }
  ]);
  const [activeButton, setActiveButton] = useState(0);
  const [activeTab, setActiveTab] = useState("farmers");

  const buttons = [
    { label: "Catalogues", path: "/Catalogue" },
    { label: "View Registration", path: "/document" },
    { label: "Verify Registration", path: "/document" },
    { label: "Share Registration", path: "/document" },
    { label: "-", path: "/" }, // You can update these paths as needed
    { label: "-", path: "/" },
    { label: "-", path: "/" },
  ];
  // Helper function to generate ID if not provided
  const generateId = () => {
    return `${Date.now()}-${Math.floor(Math.random() * 1000)}`;
  };
  const saveAllProducts = async (username) => {
    try {
      const userIdentifier = username || formData.email;
      
      if (!userIdentifier) {
        throw new Error("User identifier is required to save products");
      }
  
      // Filter out empty products and ensure we only save valid products
      const validProducts = products
        .map(product => ({
          id: product.id || generateId(),
          category: product.category || "",
          items: product.items
            .filter(item => item.name && item.name.trim() !== "" && item.name !== "XXXXX")
            .map(item => ({
              name: item.name || "",
              imageUrl: item.imageUrl, // Only Cloudinary URL, not placeholder
              cloudinaryData: item.cloudinaryData || null,
              createdAt: new Date().toISOString()
            })),
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        }))
        .filter(product => product.items.length > 0);
  
      if (validProducts.length === 0) {
        alert("No valid products to save. Please add product names.");
        return [];
      }
  
      // Save to Firebase - only metadata, images are in Cloudinary
      const savePromises = validProducts.map(async (productData) => {
        try {
          const userProductsRef = collection(db, "users", userIdentifier, "products");
          const productDocRef = doc(userProductsRef, productData.id || generateId());
          
          await setDoc(productDocRef, {
            ...productData,
            id: productDocRef.id,
            userId: userIdentifier,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp()
          });
          
          console.log(`Saved product: ${productData.category}`);
          return { success: true, category: productData.category, id: productDocRef.id };
        } catch (error) {
          console.error(`Error saving product ${productData.category}:`, error);
          return { success: false, category: productData.category, error: error.message };
        }
      });
  
      const results = await Promise.all(savePromises);
      const successfulSaves = results.filter(r => r.success);
      
      if (successfulSaves.length > 0) {
        alert(`Successfully saved ${successfulSaves.length} product(s)!`);
      } else {
        alert("Failed to save any products. Please try again.");
      }
      
      return results;
  
    } catch (error) {
      console.error("Error saving all products:", error);
      alert(`Failed to save: ${error.message}`);
      throw error;
    }
  };
  const saveProductToFirebase = async (productData, username) => {
    try {
      const userIdentifier = username || formData.email || 'temp-user';
      
      if (!userIdentifier) {
        throw new Error("User identifier is required to save products");
      }
  
      const userProductsRef = collection(db, "users", userIdentifier, "products");
      const productDocRef = doc(userProductsRef, productData.id);
      
      await setDoc(productDocRef, {
        ...productData,
        id: productDocRef.id,
        updatedAt: serverTimestamp()
      });
      
      console.log(`Saved product: ${productData.category}`);
      return { success: true, category: productData.category, id: productDocRef.id };
      
    } catch (error) {
      console.error(`Error saving product ${productData.category}:`, error);
      throw error;
    }
  };

const [productNames, setProductNames] = useState(Array(4).fill(""));
const handleDeleteCertificate = (index) => {
  const defaultTitles = [
    "Business Registration",
    "Trade Certificate", 
    "Business License",
    "Health Certificate"
  ];
  
  setCertificatesUrls(prev => {
    const updated = [...prev];
    updated[index] = {
      title: defaultTitles[index],
      url: '',
      previewUrl: '',
      cloudinaryUrl: '',
      documentType: defaultTitles[index],
      type: 'certificate'
    };
    return updated;
  });
};

 
const ProductsDropdown = ({ label, items, selectedItem, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (item) => {
    onChange(item);
    setIsOpen(false);
    // Also update the main state immediately
    setSelectedProduct(item);
  };

  return (
    <div className="flex flex-col w-full relative">
      {/* Button showing selected item */}
      <div className="flex relative z-20 w-full">
        <button
          onClick={() => setIsOpen(prev => !prev)}
          className={`md:w-[520px] w-[80px] h-[15px] md:h-[64px] bg-[#152C24] rounded-[5px] flex items-center justify-between pl-4`}
        >
          <span className="md:text-[32px] text-[6px] truncate font-bold text-white">
            {selectedItem || "PRODUCTS"} {/* Default to PRODUCTS if none selected */}
          </span>
        </button>

        <div
          className="md:h-[64px] h-[15px] w-[20px] md:w-[80px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
          onClick={() => setIsOpen(prev => !prev)}
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
            alt="expand"
            className="md:w-6 w-2 h-[8px] md:h-[24px]"
          />
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-4 md:top-16 mt-1 left-0 z-[100] md:w-[590px] w-full"
          >
            <ul className="space-y-1">
              {items.map((item, index) => (
                <li
                  key={index}
                  className={`flex items-center ${selectedItem === item ? 'bg-[#F5F5F5]' : ''}`}
                  onClick={() => {
                    handleSelect(item);
                    setIsOpen(false);
                  }}
                >
                  <button
                    className={`md:w-[520px] w-[80px] h-[15px] md:h-[64px] bg-[#152C24] rounded-[5px] flex items-center justify-between pl-4`}
                  >
                    <span className={`text-[6px] md:text-[32px] truncate font-bold ${
                      selectedItem === item ? 'text-white' : 'text-white'
                    }`}>
                      {item}
                    </span>
                  </button>
                  <div
                    className="md:h-[64px] h-[15px] w-[20px] md:w-[80px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                  >
                    {selectedItem === item ? (
                      <svg
                        viewBox="0 0 17 17"
                        fill="none"
                        className="md:w-[17px] h-[5px] w-[5px] md:h-[17px]"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="8.5" cy="8.5" r="8" fill="#152C24" stroke="#FFBD26" />
                        <path
                          d="M5 8.5L7.5 11L12 6"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      <span>--</span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
const getDefaultImage = (productIndex, itemIndex) => {
  const product = products[productIndex];
  if (product && product.items && product.items[itemIndex]) {
    const item = product.items[itemIndex];
    // Only return image if it's an actual product image (has a name and valid image)
    if (item.name && item.name.trim() !== "" && item.image && item.image.trim() !== "") {
      return item.image;
    }
  }
  return null;
};
// In your ProductImagesSection component, update it to include the ImageEditorModal:

const ProductImagesSection = ({ products, onProductsChange, username }) => {
  const fileInputRefs = useRef([]);
  const [imageEditingState, setImageEditingState] = useState({
    isOpen: false,
    imageSrc: null,
    imageType: null,
    imageFile: null,
    context: null
  });
  const [imageLoading, setImageLoading] = useState({});
  
  // Open image editor
  const openImageEditor = (imageSrc, imageType, imageFile = null, context = null) => {
    setImageEditingState({
      isOpen: true,
      imageSrc,
      imageType,
      imageFile,
      context
    });
  };

  // Close image editor
  const closeImageEditor = () => {
    setImageEditingState({
      isOpen: false,
      imageSrc: null,
      imageType: null,
      imageFile: null,
      context: null
    });
  };

  // Handle saving edited image for products
  const handleSaveEditedImage = async (imageUrl, imageBlob) => {
    try {
      let cloudinaryUrl = imageUrl;
      
      // If we have a blob, upload to Cloudinary
      if (imageBlob) {
        const uploadResult = await uploadToCloudinary(imageBlob, {
          folder: `products/${username || 'temp'}`,
          userId: auth.currentUser?.uid
        });
        cloudinaryUrl = uploadResult.url;
      }
      
      // If no blob but we have a URL (when skipping), try to upload the URL
      if (!imageBlob && imageUrl && !imageUrl.startsWith('blob:')) {
        // It's already a Cloudinary URL or external URL, use as-is
        cloudinaryUrl = imageUrl;
      }

      // Update the product with the new image
      const { productIndex, itemIndex } = imageEditingState.context;
      
      onProductsChange(prev => {
        const updatedProducts = [...prev];
        const updatedItems = [...updatedProducts[productIndex].items];
        
        updatedItems[itemIndex] = {
          ...updatedItems[itemIndex],
          imageUrl: cloudinaryUrl,
          previewUrl: imageUrl,
          cloudinaryUrl: cloudinaryUrl,
          cloudinaryData: { url: cloudinaryUrl }
        };
        
        updatedProducts[productIndex] = {
          ...updatedProducts[productIndex],
          items: updatedItems
        };
        
        console.log('Product image updated:', updatedItems[itemIndex]);
        return updatedProducts;
      });

      console.log("Product image saved successfully");
      closeImageEditor();
      
    } catch (error) {
      console.error("Error saving edited product image:", error);
      alert("Failed to save edited image. Please try again.");
      
      // Fallback: at least set the preview URL so the image shows up
      const { productIndex, itemIndex } = imageEditingState.context;
      onProductsChange(prev => {
        const updatedProducts = [...prev];
        const updatedItems = [...updatedProducts[productIndex].items];
        
        updatedItems[itemIndex] = {
          ...updatedItems[itemIndex],
          previewUrl: imageUrl,
          imageUrl: imageUrl
        };
        
        updatedProducts[productIndex] = {
          ...updatedProducts[productIndex],
          items: updatedItems
        };
        
        return updatedProducts;
      });
      
      closeImageEditor();
    }
  };
// In your registration page component
useEffect(() => {
  const loadUserCatalog = async () => {
    const savedDocId = localStorage.getItem('currentCatalogDocId');
    if (savedDocId) {
      // You can either redirect to the catalog page or load it in a modal
      navigate(`/catalog/${savedDocId}`);
    }
  };

  // Call this when catalog tab is clicked
  if (activeTab === "catalogues") {
    loadUserCatalog();
  }
}, [activeTab, navigate]);
  // Handle editing existing product image
  const handleEditExistingImage = (productIndex, itemIndex) => {
    const item = products[productIndex].items[itemIndex];
    if (item.imageUrl || item.cloudinaryUrl) {
      openImageEditor(
        item.cloudinaryUrl || item.imageUrl, 
        'product', 
        null, 
        { productIndex, itemIndex }
      );
    }
  };

  const handleImageUpload = async (e, productIndex, itemIndex) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file before upload
    if (!file.type.startsWith('image/')) {
      alert('Please select a valid image file');
      return;
    }

    const loadingKey = `product-${productIndex}-${itemIndex}`;
    
    try {
      setImageLoading(prev => ({
        ...prev,
        [loadingKey]: true
      }));

      // Open image editor instead of direct upload
      const previewUrl = URL.createObjectURL(file);
      openImageEditor(previewUrl, 'product', file, { productIndex, itemIndex });

    } catch (error) {
      console.error("Error processing product image:", error);
      alert("Failed to process product image: " + error.message);
    } finally {
      setImageLoading(prev => ({
        ...prev,
        [loadingKey]: false
      }));
    }
  };

  const handleProductNameChange = (e, productIndex, itemIndex) => {
    onProductsChange(prev => {
      const updatedProducts = [...prev];
      const updatedItems = [...updatedProducts[productIndex].items];
      
      updatedItems[itemIndex] = {
        ...updatedItems[itemIndex],
        name: e.target.value,
        variety: updatedItems[itemIndex].variety || ""
      };
      
      updatedProducts[productIndex] = {
        ...updatedProducts[productIndex],
        items: updatedItems
      };
      
      return updatedProducts;
    });
  };

  const handleCategoryChange = (e, productIndex) => {
    const newCategory = e.target.value;
    onProductsChange(prev => prev.map((p, i) => 
      i === productIndex ? { ...p, category: newCategory } : p
    ));
  };

  const handleDeleteProduct = (productIndex, itemIndex) => {
    onProductsChange(prev => {
      const updatedProducts = [...prev];
      const updatedItems = [...updatedProducts[productIndex].items];
      
      // Reset this item completely (clear both name and image)
      updatedItems[itemIndex] = {
        name: "",
        imageUrl: null,
        imageFile: null,
        cloudinaryUrl: null,
        image: ""
      };
      
      updatedProducts[productIndex] = {
        ...updatedProducts[productIndex],
        items: updatedItems
      };
      
      return updatedProducts;
    });
  };

  const renderProductItem = (product, productIndex, item, itemIndex) => {
    // Only show image if user has uploaded one
    const hasUserUploadedImage = item.cloudinaryUrl || item.imageUrl;
    const hasValidProduct = item.name && item.name.trim() !== "" && item.name !== "XXXXX";
    
    // Use only user-uploaded images, never the default placeholder
    const imageUrl = item.cloudinaryUrl || item.imageUrl;
    const isLoading = imageLoading[`${productIndex}-${itemIndex}`];
    
    return (
      <div key={`${productIndex}-${itemIndex}`} className="sm:w-[calc(50%-0.5rem)] md:w-[calc(25%-0.75rem)] w-[calc(25%-0.5rem)] flex flex-col min-w-0 mb-3">
        <h3 className="flex items-center md:mb-2 mb-1">
          <span className='md:text-[24px] text-[10px] text-[#979797] italic'>Variety </span>
          <input
            type="text"
            value={item.name || ""}
            onChange={(e) => handleProductNameChange(e, productIndex, itemIndex)}
            placeholder="XXXXXX"
            className="italic bg-transparent border md:h-full h-[20px] md:text-[24px] text-[10px] border-white outline-none w-full px-1"
            disabled={isLoading}
          />
        </h3>

        <div className="relative">
          {/* Image Container */}
          <div className="w-full md:h-[180px] h-[60px] bg-gray-200 flex items-center justify-center relative overflow-hidden">
            {isLoading && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-200 bg-opacity-80 z-10">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
              </div>
            )}
            
            {imageUrl ? (
              <img
                src={imageUrl}
                alt="Product"
                className="w-full md:h-[180px] h-[60px] object-cover cursor-pointer"
                onClick={() => !isLoading && handleEditExistingImage(productIndex, itemIndex)}
                onError={(e) => {
                  console.error("Image failed to load:", imageUrl);
                  e.target.style.display = 'none';
                }}
                onLoad={() => {
                  setImageLoading(prev => ({
                    ...prev,
                    [`${productIndex}-${itemIndex}`]: false
                  }));
                }}
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gray-200">
                <span className="text-gray-400 text-[8px] md:text-[12px]"></span>
              </div>
            )}
          </div>
          
          <input
            type="file"
            onChange={(e) => handleImageUpload(e, productIndex, itemIndex)}
            accept="image/*"
            style={{ display: 'none' }}
            ref={el => {
              if (!fileInputRefs.current[productIndex]) {
                fileInputRefs.current[productIndex] = [];
              }
              fileInputRefs.current[productIndex][itemIndex] = el;
            }}
          />
          
          <div className="absolute md:top-2 top-1 right-1 md:right-2 flex flex-col items-end gap-8 md:gap-20">
            <button 
              onClick={() => !isLoading && fileInputRefs.current[productIndex][itemIndex]?.click()}
              className="flex items-center justify-center gap-2"
              disabled={isLoading}
            >
              <h1 className="flex gap-2 items-center text-[4px] md:text-[12px] italic text-[#979797]">Insert image</h1>
              <img 
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758386331/Add_square_duotone_1_jaxyrl.png" 
                alt="Add" 
                className={`md:w-[45px] md:h-[45px] w-[10px] h-[10px] ${isLoading ? 'opacity-50' : ''}`}
              />
            </button>
            
            <button
              onClick={() => !isLoading && handleDeleteProduct(productIndex, itemIndex)}
              className="flex items-center justify-center gap-2"
              disabled={isLoading}
            >
              <h1 className="flex gap-2 items-center text-[4px] md:text-[12px] italic text-[#979797]">Delete</h1>
              <img 
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758032874/Trash_w4r37f.png" 
                alt="Delete" 
                className={`md:w-[25px] md:h-[26px] w-[10px] h-[10px] ${isLoading ? 'opacity-50' : ''}`}
              />
            </button>
          </div>
        </div>
      </div>
    );
  };
    
  return (
    <div className="w-full mt-1 overflow-hidden">
      {/* Render all product rows */}
      {products.map((product, productIndex) => (
        <div key={product.id} className="w-full mb-4">
          <div className="border-b border-black md:mt-2 mt-1 pb-1 md:pb-1">
            <div className="flex items-center justify-between">
              <h2 className="md:text-[32px] text-[16px] font-bold">
                <input
                  type="text"
                  value={product.category}
                  onChange={(e) => handleCategoryChange(e, productIndex)}
                  className="bg-transparent border-none p-0 md:text-[32px] text-[16px] outline-none w-full"
                />
              </h2>
              <p className="md:text-[12px] text-[8px] font-normal italic text-[#979797]">Add/ Edit image and text</p>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 md:gap-3 mt-1 md:mt-4 w-full">
            {product.items.map((item, itemIndex) => 
              renderProductItem(product, productIndex, item, itemIndex)
            )}
          </div>
        </div>
      ))}

      {/* Image Editor Modal for Products */}
      <ImageEditorModal
        isOpen={imageEditingState.isOpen}
        onClose={closeImageEditor}
        onSave={handleSaveEditedImage}
        imageSrc={imageEditingState.imageSrc}
        aspectRatio={4/3} // Good aspect ratio for product images
        type={imageEditingState.imageType}
        allowCropping={true}
        showSkipButton={true}
        onSkip={async () => {
          // When skipping, use the original image without changes
          if (imageEditingState.imageFile) {
            // If we have a file, create a blob URL from it
            const blobUrl = URL.createObjectURL(imageEditingState.imageFile);
            handleSaveEditedImage(blobUrl, imageEditingState.imageFile);
          } else {
            // If no file, just use the original source
            handleSaveEditedImage(imageEditingState.imageSrc, null);
          }
        }}
      />
    </div>
  );
};
  const DocumentDropdown = ({ label, items, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
  
    const handleSelect = (item) => {
      setSelectedItem(item);
      onChange(item);
      setIsOpen(false);
    };
  
    return (
      <div className="flex flex-col w-full relative">
        {/* Header title - remains constant */}
        <h3 className="md:text-[24px] text-[8px] font-bold mb-1">{label}</h3>
        
        {/* Dropdown button showing selected item */}
        <div className="flex relative z-20 w-full">
          <button
            onClick={() => setIsOpen(prev => !prev)}
            className={`w-[80px] md:w-[520px] h-[15px] md:h-[64px] bg-[#152C24] rounded-[5px] flex items-center justify-between pl-4`}
          >
            <span className="md:text-[32px] text-[6px] truncate font-bold text-white">
              {selectedItem || "DOCUMENTS"} {/* Show selected item or dash if none selected */}
            </span>
          </button>
  
          <div
            className="md:h-[64px] h-[15px] w-[20px] md:w-[80px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
            onClick={() => setIsOpen(prev => !prev)}
          >
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
              alt="expand"
              className="md:w-6 w-2 h-2 md:h-[24px]"
            />
          </div>
        </div>
  
        {/* Dropdown menu */}
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="absolute top-full mt-2 left-0 w-[90px] md:w-[590px] border border-[#979797]/80 bg-[#152C24] rounded shadow-lg flex flex-col"
              style={{ zIndex: 1000 }}
            >
              <div className="custom-scroll-area">
                <ul className="custom-scroll-content">
                  <li className="flex items-center justify-between px-0.5 md:px-2 py-1 mb-2">
                    <span className="md:text-[20px] text-[8px] text-white font-semibold">
                      {label} {/* Header title inside dropdown remains constant */}
                    </span>
                    <img
                      src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754762886/Export_light_2_lnyz7b.png"
                      alt="icon"
                      className="md:w-[30px] w-[10px] h-[10px] md:h-[30px] cursor-pointer"
                      onClick={() => setIsOpen(false)}
                    />
                  </li>
                  
                  {items.map((item, index) => (
                    <li
                      key={index}
                      className="flex items-center justify-between md:px-3 px-1 md:py-2 py-1 mt-1 rounded-md cursor-pointer "
                      onClick={() => handleSelect(item)}
                    >
                      <span className="md:text-[18px] text-[6px] text-white ">
                        {item}
                      </span>
                      <svg
                        viewBox="0 0 17 17"
                        fill="none"
                        className="md:w-[17px] w-[10px] h-[10px] md:h-[17px]"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle 
                          cx="8.5" 
                          cy="8.5" 
                          r="8" 
                          fill={selectedItem === item ? "#152C24" : "#D9D9D9"} 
                          stroke={selectedItem === item ? "#FFBD26" : "none"} 
                        />
                        {selectedItem === item && (
                          <path
                            d="M5 8.5L7.5 11L12 6"
                            stroke="white"
                            strokeWidth="1"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        )}
                      </svg>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
  
      
      </div>
    );
  };
  
  const [areaFocusSelections, setAreaFocusSelections] = useState([]); // State for area focus selections

  const [promoCards, setPromoCards] = useState([
    {
      mainImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758386941/image_2514_xynx0q.png",
      badgeImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754927255/image_2150_rhvdri.png",
      title: "Vegetables",
      description: "Limited-Time Offer: 20% Off Cakes!\nReady for a fresh pastry? Enjoy 20% OFF your session!"
    },
    {
      mainImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png",
     badgeImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754927255/image_2150_rhvdri.png",
      title: "-",
  description: "Limited-Time Offer: 20% Off Cakes!\nReady for a fresh pastry? Enjoy 20% OFF your session!",
    },
    {
   mainImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png",
    badgeImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754927255/image_2150_rhvdri.png",
      title: "-",
      description: "Limited-Time Offer: 20% Off Cakes!\nReady for a fresh pastry? Enjoy 20% OFF your session!",
    },
    {
     mainImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758367384/Rectangle_34643961_bhnhks.png",
      badgeImage: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754927255/image_2150_rhvdri.png",
      title: "-",
      description: "Limited-Time Offer: 20% Off Cakes!\nReady for a fresh pastry? Enjoy 20% OFF your session!",
    }
  ]);
 
  const saveCertificatesToFirebase = async (username) => {
    try {
      if (!username) {
        throw new Error("Username is required");
      }
      
      const userRef = doc(db, "users", username);
      
      // Check if user document exists first
      const userDoc = await getDoc(userRef);
      if (!userDoc.exists()) {
        throw new Error("User document does not exist");
      }
      
      // Upload certificate images to Cloudinary
      const certificatesWithUrls = await Promise.all(
        certificates.map(async (cert, index) => {
          let imageUrl = cert.img;
          
          // If it's a file (not a URL), upload it
          if (cert.img && cert.img instanceof File) {
            try {
              const uploadResult = await uploadToCloudinary(cert.img, username);
              imageUrl = uploadResult.url;
            } catch (error) {
              console.error("Error uploading certificate image:", error);
            }
          }
          
          return {
            title: cert.title,
            img: imageUrl,
            bg: cert.bg || "#D9D9D9"
          };
        })
      );
      
      // Update the user document with certificates
      await updateDoc(userRef, {
        certificates: certificatesWithUrls,
        updatedAt: serverTimestamp()
      });
      
      console.log("Certificates saved successfully for user:", username);
      return true;
    } catch (error) {
      console.error("Error saving certificates:", error);
      throw error;
    }
  };
  const handleCloseEditor = () => {
    // If user cancels, you might want to still use the original image
    if (currentImageFile) {
      if (currentImageType === 'profile') {
        const previewUrl = URL.createObjectURL(currentImageFile);
        setProfileImage({
          file: currentImageFile,
          url: previewUrl,
          previewUrl: previewUrl,
          cloudinaryUrl: null,
          documentType: 'Profile Image'
        });
      } 
      else if (currentImageType === 'background') {
        const previewUrl = URL.createObjectURL(currentImageFile);
        setBackgroundImage(previewUrl);
        setBackgroundImageFile(currentImageFile);
      }
    }
    
    setIsImageEditorOpen(false);
    setCurrentEditingImage(null);
    setCurrentImageType(null);
    setCurrentImageFile(null);
  };
  const PromoDropdown = ({ label, items, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const contentRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    const [thumbHeight, setThumbHeight] = useState(40);
    const [isDragging, setIsDragging] = useState(false);
    const [startY, setStartY] = useState(0);
    const [startScrollTop, setStartScrollTop] = useState(0);
    const thumbRef = useRef(null);
  
    const handleSelect = (item) => {
        setSelectedItem(item);
        onChange(item);
        setIsOpen(false);
    };
    useEffect(() => {
      const saveDataToStorage = () => {
        // Create minimal data object to avoid quota issues
        const minimalData = {
          formData: {
            firstName: formData.firstName,
            surname: formData.surname,
            email: formData.email,
            // Add other essential fields
          },
          dropdownSelections,
          reportSelections,
          selectedLanguage,
          agreed,
          race,
          gender,
          disability,
          orgType
          // Don't save images or large files to localStorage
        };
        
        try {
          localStorage.setItem('farmRegistrationData', JSON.stringify(minimalData));
        } catch (error) {
          console.error('Error saving data to localStorage:', error);
        }
      };
    
      const handleBeforeUnload = (e) => {
        saveDataToStorage();
      };
    
      window.addEventListener('beforeunload', handleBeforeUnload);
      
      // Save less frequently (every 60 seconds instead of 30)
      const saveInterval = setInterval(saveDataToStorage, 60000);
    
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
        clearInterval(saveInterval);
        saveDataToStorage(); // Final save
      };
    }, [
      // Only include essential dependencies
      formData.firstName, formData.surname, formData.email,
      dropdownSelections, reportSelections, selectedLanguage,
      agreed, race, gender, disability, orgType
    ]);
    // Scroll related effects (same as Dropdown1)
    useEffect(() => {
        const content = contentRef.current;
        if (!content) return;
  
        const updateThumbHeight = () => {
            const { scrollHeight, clientHeight } = content;
            const visibleRatio = clientHeight / scrollHeight;
            setThumbHeight(Math.max(visibleRatio * clientHeight, 20));
        };
  
        updateThumbHeight();
        window.addEventListener("resize", updateThumbHeight);
        return () => window.removeEventListener("resize", updateThumbHeight);
    }, [isOpen, items]);
  
    const handleScroll = () => {
        const content = contentRef.current;
        if (!content) return;
  
        const { scrollTop, scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        const scrollRatio = scrollTop / maxScrollTop;
        const trackHeight = content.clientHeight - thumbHeight;
        setScrollTop(scrollRatio * trackHeight);
    };
  
    // Scroll handlers (same as Dropdown1)
    const handleThumbMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
        setStartY(e.clientY);
        setStartScrollTop(contentRef.current.scrollTop);
        document.addEventListener("mousemove", handleThumbMouseMove);
        document.addEventListener("mouseup", handleThumbMouseUp);
        document.body.style.cursor = "grabbing";
    };
  
    const handleThumbMouseMove = (e) => {
        if (!isDragging) return;
        const deltaY = e.clientY - startY;
        const content = contentRef.current;
        const { scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        const trackHeight = clientHeight - thumbHeight;
        const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
        const newScrollTop = Math.min(
            Math.max(0, startScrollTop + scrollDelta),
            maxScrollTop
        );
        content.scrollTop = newScrollTop;
    };
  
    const handleThumbMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener("mousemove", handleThumbMouseMove);
        document.removeEventListener("mouseup", handleThumbMouseUp);
        document.body.style.cursor = "";
    };
  
    const handleTrackClick = (e) => {
        const content = contentRef.current;
        if (!content || e.target === thumbRef.current) return;
        const track = e.currentTarget;
        const trackRect = track.getBoundingClientRect();
        const clickPosition = e.clientY - trackRect.top;
        const thumbCenter = thumbHeight / 2;
        const scrollRatio = (clickPosition - thumbCenter) / (trackRect.height - thumbHeight);
        const { scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        content.scrollTop = scrollRatio * maxScrollTop;
    };
  
    const handleButtonScroll = (direction) => {
        if (contentRef.current) {
            contentRef.current.scrollBy({
                top: direction === 'up' ? -50 : 50,
                behavior: 'smooth'
            });
        }
    };
  
    return (
        <div className="flex flex-col w-full relative">
            {/* Button showing selected item */}
            <div className="flex relative z-20 w-full">
          <button
            onClick={() => setIsOpen(prev => !prev)}
            className={`md:w-[520px] w-[80px] h-[15px] md:h-[64px] bg-[#152C24] rounded-[5px] flex items-center justify-between pl-4`}
          >
            <span className="md:text-[32px] text-[6px] truncate font-bold text-white">
              {selectedItem || label}
            </span>
          </button>
  
          <div
            className="md:h-[64px] h-[15px] w-[20px] md:w-[80px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
            onClick={() => setIsOpen(prev => !prev)}
          >
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
              alt="expand"
              className="md:w-6 w-2  h-[8px] md:h-[24px]"
            />
          </div>
        </div>
  
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="absolute top-4 md:top-16 mt-1 left-0 z-[100] md:w-[590px] w-full"
            >
              <ul className="space-y-1">
                {items.map((item, index) => (
                  <li
                    key={index}
                    className={`flex items-center ${selectedItem === item ? 'bg-[#F5F5F5]' : ''}`}
                    onClick={() => {
                      handleSelect(item);
                      setIsOpen(false);
                    }}
                  >
                    <button
                           className={`md:w-[520px] w-[80px] h-[15px] md:h-[64px] bg-[#152C24] rounded-[5px] flex items-center justify-between pl-4`}
                    >
                      <span className={`text-[6px] md:text-[32px] truncate font-bold ${
                        selectedItem === item ? 'text-white' : 'text-white'
                      }`}>
                        {item}
                      </span>
                    </button>
                    <div
              className="md:h-[64px] h-[15px] w-[20px] md:w-[80px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                    >
                      {selectedItem === item ? (
                        <svg
                          viewBox="0 0 17 17"
                          fill="none"
                          className="md:w-[17px] h-[5px] w-[5px] md:h-[17px]"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="8.5" cy="8.5" r="8" fill="#152C24" stroke="#FFBD26" />
                          <path
                            d="M5 8.5L7.5 11L12 6"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        <span>--</span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </motion.div>
          )}
        </AnimatePresence>
            <style jsx>{`
                .custom-scroll-area {
                    position: relative;
                    max-height: 300px;
                    display: flex;
                    overflow: hidden;
                }
  
                .custom-scroll-content {
                    flex: 1;
                    overflow-y: scroll;
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                    padding-right: 4px;
                }
  
                .custom-scroll-content::-webkit-scrollbar {
                    display: none;
                }
  
                .custom-scroll-track {
                    width: 14px;
                    background: #F5F5F5;
                    border-radius: 3px;
                    position: relative;
                    margin-left: 4px;
                    cursor: pointer;
                }
  
                .custom-scroll-thumb {
                    width: 100%;
                    background: #979797;
                    border-radius: 3px;
                    position: absolute;
                    right: 0;
                    transition: background 0.2s;
                }
  
                .custom-scroll-thumb:hover {
                    background: #444;
                }
            `}</style>
        </div>
    );
  };
  const fileInputRefs = useRef([]);

  const BakeSection = ({ bakes, onBakesChange, username }) => {
    const fileInputRefs = useRef([]);
    const [imageLoading, setImageLoading] = useState({});
    const [imageEditingState, setImageEditingState] = useState({
      isOpen: false,
      imageSrc: null,
      imageType: null,
      imageFile: null,
      context: null
    });
  
    // Open image editor
    const openImageEditor = (imageSrc, imageType, imageFile = null, context = null) => {
      setImageEditingState({
        isOpen: true,
        imageSrc,
        imageType,
        imageFile,
        context
      });
    };
  
    // Close image editor
    const closeImageEditor = () => {
      setImageEditingState({
        isOpen: false,
        imageSrc: null,
        imageType: null,
        imageFile: null,
        context: null
      });
    };
  

    // In your Bake section - ensure this function is properly implemented
const handleSaveEditedImage = async (imageUrl, imageBlob) => {
  try {
    console.log('Bake section - Received edited image:', { imageUrl, imageBlob });
    
    let cloudinaryUrl = imageUrl;
    
    // If we have a blob, upload to Cloudinary
    if (imageBlob) {
      const uploadResult = await uploadToCloudinary(imageBlob, {
        folder: `bakes/${username || 'temp'}`,
        userId: auth.currentUser?.uid
      });
      cloudinaryUrl = uploadResult.url;
    }
    
    // Update the bake with the new image
    const { bakeIndex, itemIndex } = imageEditingState.context;
    
    onBakesChange(prev => {
      const updatedBakes = [...prev];
      const updatedItems = [...updatedBakes[bakeIndex].items];
      
      updatedItems[itemIndex] = {
        ...updatedItems[itemIndex],
        imageUrl: cloudinaryUrl,
        previewUrl: imageUrl,
        cloudinaryUrl: cloudinaryUrl,
        cloudinaryData: { url: cloudinaryUrl }
      };
      
      updatedBakes[bakeIndex] = {
        ...updatedBakes[bakeIndex],
        items: updatedItems
      };
      
      console.log('Bake section - Updated bake item:', updatedItems[itemIndex]);
      return updatedBakes;
    });

    console.log("Bake image saved successfully");
    
  } catch (error) {
    console.error("Error saving edited bake image:", error);
    alert("Failed to save edited image. Please try again.");
  }
};
    // Handle editing existing bake image
    const handleEditExistingImage = (bakeIndex, itemIndex) => {
      const item = bakes[bakeIndex].items[itemIndex];
      if (item.imageUrl || item.cloudinaryUrl) {
        openImageEditor(
          item.cloudinaryUrl || item.imageUrl, 
          'bake', 
          null, 
          { bakeIndex, itemIndex }
        );
      }
    };
  
    const handleImageUpload = async (e, bakeIndex, itemIndex) => {
      const file = e.target.files[0];
      if (!file) return;
  
      // Validate file before upload
      if (!file.type.startsWith('image/')) {
        alert('Please select a valid image file');
        return;
      }
  
      const loadingKey = `bake-${bakeIndex}-${itemIndex}`;
      
      try {
        setImageLoading(prev => ({
          ...prev,
          [loadingKey]: true
        }));
  
        // Open image editor instead of direct upload
        const previewUrl = URL.createObjectURL(file);
        openImageEditor(previewUrl, 'bake', file, { bakeIndex, itemIndex });
  
      } catch (error) {
        console.error("Error processing bake image:", error);
        alert("Failed to process bake image: " + error.message);
      } finally {
        setImageLoading(prev => ({
          ...prev,
          [loadingKey]: false
        }));
      }
    };
  
    const handleBakeNameChange = (e, bakeIndex, itemIndex) => {
      onBakesChange(prev => {
        const updatedBakes = [...prev];
        const updatedItems = [...updatedBakes[bakeIndex].items];
        updatedItems[itemIndex] = {
          ...updatedItems[itemIndex],
          name: e.target.value
        };
        updatedBakes[bakeIndex] = {
          ...updatedBakes[bakeIndex],
          items: updatedItems
        };
        return updatedBakes;
      });
    };
  
    const handleCategoryChange = (e, bakeIndex) => {
      const newCategory = e.target.value;
      onBakesChange(prev => prev.map((b, i) => 
        i === bakeIndex ? { ...b, category: newCategory } : b
      ));
    };
  
    const handleDeleteBake = (bakeIndex, itemIndex) => {
      onBakesChange(prev => {
        const updatedBakes = [...prev];
        const updatedItems = [...updatedBakes[bakeIndex].items];
        
        // Reset this item
        updatedItems[itemIndex] = {
          name: "",
          imageUrl: null,
          cloudinaryUrl: null,
          cloudinaryData: null
        };
        
        updatedBakes[bakeIndex] = {
          ...updatedBakes[bakeIndex],
          items: updatedItems
        };
        
        return updatedBakes;
      });
    };
  
    const renderBakeItem = (bake, bakeIndex, item, itemIndex) => {
      const imageUrl = item.cloudinaryUrl || item.imageUrl || item.image;
      const hasValidData = item.name && item.name.trim() !== "" && item.name !== "XXXXX";
      const isLoading = imageLoading[`bake-${bakeIndex}-${itemIndex}`];
      
      return (
        <div key={`${bakeIndex}-${itemIndex}`} className="md:w-1/2 w-full relative">
          <h3 className="flex items-center md:mb-4 mb-1">
            <h1 className='md:text-[24px] text-[4px] text-black italic'>Variety </h1>
            <input
              type="text"
              value={item.name}
              onChange={(e) => handleBakeNameChange(e, bakeIndex, itemIndex)}
              placeholder="XXXXXX"
              className="italic bg-transparent border p-0 md:text-[24px] text-[4px] border-white outline-none w-full"
              disabled={isLoading}
            />
          </h3>
  
          <div className="relative">
            {isLoading ? (
              <div className="bg-gray-200 md:w-full md:h-[410px] w-full h-[130px] flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
              </div>
            ) : imageUrl ? (
              <img
                src={imageUrl}
                alt="Bake"
                className="md:w-full md:h-[410px] w-full h-[130px] object-cover cursor-pointer"
                onClick={() => !isLoading && handleEditExistingImage(bakeIndex, itemIndex)}
                onError={(e) => {
                  console.error("Image failed to load:", imageUrl);
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
            ) : (
              <div className="bg-gray-200 md:w-full md:h-[410px] w-full h-[130px] flex items-center justify-center">
                <span className="text-gray-500 text-xs">No image</span>
              </div>
            )}
            
            <input
              type="file"
              onChange={(e) => handleImageUpload(e, bakeIndex, itemIndex)}
              accept="image/*"
              style={{ display: 'none' }}
              ref={el => {
                if (!fileInputRefs.current[bakeIndex]) {
                  fileInputRefs.current[bakeIndex] = [];
                }
                fileInputRefs.current[bakeIndex][itemIndex] = el;
              }}
              disabled={isLoading}
            />
            
            <div className="absolute top-2 right-2 flex flex-col gap-2">
              <button 
                onClick={() => !isLoading && fileInputRefs.current[bakeIndex][itemIndex]?.click()}
                className="flex items-center justify-center"
                disabled={isLoading}
              >
                <img 
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754924245/Add_square_duotone_quvbbl.png" 
                  alt="Add" 
                  className="md:w-[46px] md:h-[46px] w-6 h-6"
                />
              </button>
              
              <button
                onClick={() => !isLoading && handleDeleteBake(bakeIndex, itemIndex)}
                className="flex items-center justify-center"
                disabled={isLoading}
              >
                <img 
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758032874/Trash_w4r37f.png" 
                  alt="Delete" 
                  className="md:w-[25px] md:h-[26px] w-6 h-6"
                />
              </button>
            </div>
          </div>
        </div>
      );
    };
  
    return (
      <div className="w-full mt-1 md:mt-4">
        {bakes.map((bake, bakeIndex) => (
          <div key={bake.id} className="md:mt-1 mt-0">
            <div className="flex justify-between items-center border-b border-black md:mt-2 mt-0 pb-1 md:pb-2">
              <div className="flex items-center gap-16 md:gap-24">
                <h2 className="md:text-[32px] text-[10px] font-bold">
                  <input
                    type="text"
                    value={bake.category}
                    onChange={(e) => handleCategoryChange(e, bakeIndex)}
                    className="bg-transparent border-none md:text-[32px] p-0 text-[8px] outline-none w-full"
                  />
                </h2>
                {bakeIndex === 0 && (
                  <p className="md:text-[12px] text-[6px] font-normal italic text-[#979797]">Auto Spelling check</p>
                )}
              </div>
              {bakeIndex === 0 && (
                <h1 className="md:text-[24px] text-[6px] italic">Type bake name and insert image</h1>
              )}
            </div>
  
            <div className="flex md:gap-6 gap-0.5 mt-1 md:mt-4">
              {bake.items.map((item, itemIndex) => 
                renderBakeItem(bake, bakeIndex, item, itemIndex)
              )}
            </div>
          </div>
        ))}
  
        {/* Image Editor Modal for Bakes */}
        <ImageEditorModal
          isOpen={imageEditingState.isOpen}
          onClose={closeImageEditor}
          onSave={handleSaveEditedImage}
          imageSrc={imageEditingState.imageSrc}
          aspectRatio={16/9}
          type={imageEditingState.imageType}
          allowCropping={true}
          showSkipButton={true}
          onSkip={async () => {
            // When skipping, use the original image without changes
            if (imageEditingState.imageFile) {
              // If we have a file, create a blob URL from it
              const blobUrl = URL.createObjectURL(imageEditingState.imageFile);
              handleSaveEditedImage(blobUrl, imageEditingState.imageFile);
            } else {
              // If no file, just use the original source
              handleSaveEditedImage(imageEditingState.imageSrc, null);
            }
          }}
        />
      </div>
    );
  };
  const saveBakesToFirebase = async (bakesData, username) => {
    try {
      if (!username) {
        throw new Error("Username is required to save bakes");
      }
  
      // Filter and validate bakes data
      const validBakes = bakesData
        .map(bake => ({
          id: bake.id || generateId(),
          category: bake.category || "",
          items: bake.items
            .filter(item => item.name && item.name.trim() !== "" && item.name !== "XXXXX")
            .map(item => ({
              name: item.name,
              imageUrl: item.cloudinaryUrl || item.imageUrl,
              cloudinaryUrl: item.cloudinaryUrl,
              cloudinaryData: item.cloudinaryData || null,
              createdAt: new Date().toISOString()
            })),
          username: username,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        }))
        .filter(bake => bake.items.length > 0);
  
      if (validBakes.length === 0) {
        console.log("No valid bakes to save");
        return [];
      }
  
      console.log('Saving bakes to Firebase:', validBakes);
  
      const savePromises = validBakes.map(async (bakeData) => {
        try {
          const userBakesRef = collection(db, "users", username, "bakes");
          const bakeDocRef = doc(userBakesRef, bakeData.id);
          
          await setDoc(bakeDocRef, {
            ...bakeData,
            id: bakeDocRef.id,
            updatedAt: serverTimestamp()
          });
          
          console.log(`Saved bake: ${bakeData.category}`);
          return { 
            success: true, 
            category: bakeData.category, 
            id: bakeDocRef.id,
            items: bakeData.items.length
          };
        } catch (error) {
          console.error(`Error saving bake ${bakeData.category}:`, error);
          return { 
            success: false, 
            category: bakeData.category, 
            error: error.message 
          };
        }
      });
  
      const results = await Promise.all(savePromises);
      
      const successfulSaves = results.filter(r => r.success);
      console.log(`Successfully saved ${successfulSaves.length} out of ${results.length} bakes`);
      
      return results;
  
    } catch (error) {
      console.error("Error saving all bakes:", error);
      throw error;
    }
  };
  
  const handleSaveBakes = async () => {
    try {
      const userIdentifier = formData.username || formData.email;
      
      if (!userIdentifier) {
        alert("Please complete registration first");
        return;
      }
  
      const results = await saveBakesToFirebase(bakes, userIdentifier);
      
      const successfulSaves = results.filter(r => r.success);
      
      if (successfulSaves.length > 0) {
        alert(`Successfully saved ${successfulSaves.length} bake(s)!`);
        
        // Log details for debugging
        successfulSaves.forEach(bake => {
          console.log(`Bake "${bake.category}" saved with ID: ${bake.id}`);
        });
      } else {
        alert("Failed to save any bakes. Please try again.");
      }
      
      return results;
    } catch (error) {
      console.error("Error saving bakes:", error);
      alert(`Failed to save bakes: ${error.message}`);
      throw error;
    }
  };
   const [imageLoading, setImageLoading] = useState(false);
  useEffect(() => {
    const savedData = localStorage.getItem('farmRegistrationData');
    if (savedData) {
      setShowRecovery(true);
    }
  }, []);
  const saveServicesToFirebase = async (servicesData, username) => {
    try {
      if (!username) {
        throw new Error("Username is required to save services");
      }
  
      // Filter and validate services data
      const validServices = servicesData
        .map(service => ({
          id: service.id || generateId(),
          category: service.category || "",
          items: service.items
            .filter(item => item.name && item.name.trim() !== "" && item.name !== "XXXXX")
            .map(item => ({
              name: item.name,
              imageUrl: item.cloudinaryUrl || item.imageUrl, // Prefer cloudinaryUrl
              cloudinaryUrl: item.cloudinaryUrl, // Store separately
              cloudinaryData: item.cloudinaryData || null,
              createdAt: new Date().toISOString()
            })),
          username: username,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        }))
        .filter(service => service.items.length > 0);
  
      if (validServices.length === 0) {
        console.log("No valid services to save");
        return [];
      }
  
      console.log('Saving services to Firebase:', validServices);
  
      const savePromises = validServices.map(async (serviceData) => {
        try {
          const userServicesRef = collection(db, "users", username, "services");
          const serviceDocRef = doc(userServicesRef, serviceData.id);
          
          await setDoc(serviceDocRef, {
            ...serviceData,
            id: serviceDocRef.id,
            updatedAt: serverTimestamp()
          });
          
          console.log(`Saved service: ${serviceData.category}`);
          return { 
            success: true, 
            category: serviceData.category, 
            id: serviceDocRef.id,
            items: serviceData.items.length
          };
        } catch (error) {
          console.error(`Error saving service ${serviceData.category}:`, error);
          return { 
            success: false, 
            category: serviceData.category, 
            error: error.message 
          };
        }
      });
  
      const results = await Promise.all(savePromises);
      
      // Log results
      const successfulSaves = results.filter(r => r.success);
      console.log(`Successfully saved ${successfulSaves.length} out of ${results.length} services`);
      
      return results;
  
    } catch (error) {
      console.error("Error saving all services:", error);
      throw error;
    }
  };
  const ServicesSection = ({ services, onServicesChange, username }) => {
    const fileInputRefs = useRef([]);
    const [imageLoading, setImageLoading] = useState({});
    const [imageEditingState, setImageEditingState] = useState({
      isOpen: false,
      imageSrc: null,
      imageType: null,
      imageFile: null,
      context: null
    });
  
    // Open image editor
    const openImageEditor = (imageSrc, imageType, imageFile = null, context = null) => {
      setImageEditingState({
        isOpen: true,
        imageSrc,
        imageType,
        imageFile,
        context
      });
    };
  
    // Close image editor
    const closeImageEditor = () => {
      setImageEditingState({
        isOpen: false,
        imageSrc: null,
        imageType: null,
        imageFile: null,
        context: null
      });
    };
  
    // Handle saving edited image
    const handleSaveEditedImage = async (imageUrl, imageBlob) => {
      try {
        let cloudinaryUrl = imageUrl;
        let finalBlob = imageBlob;
        
        // If we have a blob, upload to Cloudinary
        if (imageBlob) {
          const uploadResult = await uploadToCloudinary(imageBlob, {
            folder: `services/${username || 'temp'}`,
            userId: auth.currentUser?.uid
          });
          cloudinaryUrl = uploadResult.url;
          finalBlob = imageBlob;
        }
        
        // If no blob but we have a URL (when skipping), try to upload the URL
        if (!imageBlob && imageUrl && !imageUrl.startsWith('blob:')) {
          // It's already a Cloudinary URL or external URL, use as-is
          cloudinaryUrl = imageUrl;
        }
  
        // Update the service with the new image
        const { serviceIndex, itemIndex } = imageEditingState.context;
        
        onServicesChange(prev => {
          const updatedServices = [...prev];
          const updatedItems = [...updatedServices[serviceIndex].items];
          
          updatedItems[itemIndex] = {
            ...updatedItems[itemIndex],
            imageUrl: cloudinaryUrl,
            previewUrl: imageUrl,
            cloudinaryUrl: cloudinaryUrl,
            cloudinaryData: { url: cloudinaryUrl }
          };
          
          updatedServices[serviceIndex] = {
            ...updatedServices[serviceIndex],
            items: updatedItems
          };
          
          return updatedServices;
        });
  
        console.log("Service image saved successfully");
        closeImageEditor();
        
      } catch (error) {
        console.error("Error saving edited service image:", error);
        alert("Failed to save edited image. Please try again.");
        
        // Fallback: at least set the preview URL so the image shows up
        const { serviceIndex, itemIndex } = imageEditingState.context;
        onServicesChange(prev => {
          const updatedServices = [...prev];
          const updatedItems = [...updatedServices[serviceIndex].items];
          
          updatedItems[itemIndex] = {
            ...updatedItems[itemIndex],
            previewUrl: imageUrl,
            imageUrl: imageUrl
          };
          
          updatedServices[serviceIndex] = {
            ...updatedServices[serviceIndex],
            items: updatedItems
          };
          
          return updatedServices;
        });
        
        closeImageEditor();
      }
    };
  
    // Handle editing existing service image
    const handleEditExistingImage = (serviceIndex, itemIndex) => {
      const item = services[serviceIndex].items[itemIndex];
      if (item.imageUrl || item.cloudinaryUrl) {
        openImageEditor(
          item.cloudinaryUrl || item.imageUrl, 
          'service', 
          null, 
          { serviceIndex, itemIndex }
        );
      }
    };
  
    const handleImageUpload = async (e, serviceIndex, itemIndex) => {
      const file = e.target.files[0];
      if (!file) return;
  
      // Validate file before upload
      if (!file.type.startsWith('image/')) {
        alert('Please select a valid image file');
        return;
      }
  
      const loadingKey = `service-${serviceIndex}-${itemIndex}`;
      
      try {
        setImageLoading(prev => ({
          ...prev,
          [loadingKey]: true
        }));
  
        // Open image editor instead of direct upload
        const previewUrl = URL.createObjectURL(file);
        openImageEditor(previewUrl, 'service', file, { serviceIndex, itemIndex });
  
      } catch (error) {
        console.error("Error processing service image:", error);
        alert("Failed to process service image: " + error.message);
      } finally {
        setImageLoading(prev => ({
          ...prev,
          [loadingKey]: false
        }));
      }
    };
  
    const handleServiceNameChange = (e, serviceIndex, itemIndex) => {
      onServicesChange(prev => {
        const updatedServices = [...prev];
        const updatedItems = [...updatedServices[serviceIndex].items];
        updatedItems[itemIndex] = {
          ...updatedItems[itemIndex],
          name: e.target.value
        };
        updatedServices[serviceIndex] = {
          ...updatedServices[serviceIndex],
          items: updatedItems
        };
        return updatedServices;
      });
    };
  
    const handleCategoryChange = (e, serviceIndex) => {
      const newCategory = e.target.value;
      onServicesChange(prev => prev.map((s, i) => 
        i === serviceIndex ? { ...s, category: newCategory } : s
      ));
    };
  
    const handleDeleteService = (serviceIndex, itemIndex) => {
      onServicesChange(prev => {
        const updatedServices = [...prev];
        const updatedItems = [...updatedServices[serviceIndex].items];
        
        // Reset this item
        updatedItems[itemIndex] = {
          name: "",
          imageUrl: null,
          cloudinaryUrl: null,
          cloudinaryData: null
        };
        
        updatedServices[serviceIndex] = {
          ...updatedServices[serviceIndex],
          items: updatedItems
        };
        
        return updatedServices;
      });
    };
  
    const renderServiceItem = (service, serviceIndex, item, itemIndex) => {
      // Always use cloudinaryUrl if available, otherwise fall back to imageUrl
      const imageUrl = item.cloudinaryUrl || item.imageUrl || item.image;
      const hasValidData = item.name && item.name.trim() !== "" && item.name !== "XXXXX";
      const isLoading = imageLoading[`service-${serviceIndex}-${itemIndex}`];
      
      return (
        <div key={`${serviceIndex}-${itemIndex}`} className="md:w-1/2 w-full relative">
          <h3 className="flex items-center md:mb-4 mb-1">
            <h1 className='md:text-[24px] text-[4px] text-black italic'>Variety </h1>
            <input
              type="text"
              value={item.name}
              onChange={(e) => handleServiceNameChange(e, serviceIndex, itemIndex)}
              placeholder="XXXXXX"
              className="italic bg-transparent border p-0 md:text-[24px] text-[4px] border-white outline-none w-full"
              disabled={isLoading}
            />
          </h3>
  
          <div className="relative">
            {isLoading ? (
              <div className="bg-gray-200 md:w-full md:h-[410px] w-full h-[130px] flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
              </div>
            ) : imageUrl ? (
              <img
                src={imageUrl}
                alt="Service"
                className="md:w-full md:h-[410px] w-full h-[130px] object-cover cursor-pointer"
                onClick={() => !isLoading && handleEditExistingImage(serviceIndex, itemIndex)}
                onError={(e) => {
                  console.error("Image failed to load:", imageUrl);
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
            ) : (
              <div className="bg-gray-200 md:w-full md:h-[410px] w-full h-[130px] flex items-center justify-center">
                <span className="text-gray-500 text-xs">No image</span>
              </div>
            )}
            
            <input
              type="file"
              onChange={(e) => handleImageUpload(e, serviceIndex, itemIndex)}
              accept="image/*"
              style={{ display: 'none' }}
              ref={el => {
                if (!fileInputRefs.current[serviceIndex]) {
                  fileInputRefs.current[serviceIndex] = [];
                }
                fileInputRefs.current[serviceIndex][itemIndex] = el;
              }}
              disabled={isLoading}
            />
            
            <div className="absolute top-2 right-2 flex flex-col gap-2">
              <button 
                onClick={() => !isLoading && fileInputRefs.current[serviceIndex][itemIndex]?.click()}
                className="flex items-center justify-center"
                disabled={isLoading}
              >
                <img 
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754924245/Add_square_duotone_quvbbl.png" 
                  alt="Add" 
                  className="md:w-[46px] md:h-[46px] w-6 h-6"
                />
              </button>
              
              <button
                onClick={() => !isLoading && handleDeleteService(serviceIndex, itemIndex)}
                className="flex items-center justify-center"
                disabled={isLoading}
              >
                <img 
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758032874/Trash_w4r37f.png" 
                  alt="Delete" 
                  className="md:w-[25px] md:h-[26px] w-6 h-6"
                />
              </button>
            </div>
          </div>
        </div>
      );
    };
  
    return (
      <div className="w-full mt-1 md:mt-4">
        {services.map((service, serviceIndex) => (
          <div key={service.id} className="md:mt-1 mt-0">
            <div className="flex justify-between items-center border-b border-black md:mt-2 mt-0 pb-1 md:pb-2">
              <div className="flex items-center gap-16 md:gap-24">
                <h2 className="md:text-[32px] text-[10px] font-bold">
                  <input
                    type="text"
                    value={service.category}
                    onChange={(e) => handleCategoryChange(e, serviceIndex)}
                    className="bg-transparent border-none md:text-[32px] p-0 text-[8px] outline-none w-full"
                  />
                </h2>
                {serviceIndex === 0 && (
                  <p className="md:text-[12px] text-[6px] font-normal italic text-[#979797]">Auto Spelling check</p>
                )}
              </div>
              {serviceIndex === 0 && (
                <h1 className="md:text-[24px] text-[6px] italic">Type service name and insert image</h1>
              )}
            </div>
  
            <div className="flex md:gap-6 gap-0.5 mt-1 md:mt-4">
              {service.items.map((item, itemIndex) => 
                renderServiceItem(service, serviceIndex, item, itemIndex)
              )}
            </div>
          </div>
        ))}
  
        {/* Image Editor Modal for Services */}
        <ImageEditorModal
          isOpen={imageEditingState.isOpen}
          onClose={closeImageEditor}
          onSave={handleSaveEditedImage}
          imageSrc={imageEditingState.imageSrc}
          aspectRatio={16/9}
          type={imageEditingState.imageType}
          allowCropping={true}
          showSkipButton={true}
          onSkip={async () => {
            // When skipping, use the original image without changes
            if (imageEditingState.imageFile) {
              // If we have a file, create a blob URL from it
              const blobUrl = URL.createObjectURL(imageEditingState.imageFile);
              handleSaveEditedImage(blobUrl, imageEditingState.imageFile);
            } else {
              // If no file, just use the original source
              handleSaveEditedImage(imageEditingState.imageSrc, null);
            }
          }}
        />
      </div>
    );
  };
  const [selectedPromotionType, setSelectedPromotionType] = useState("");
  const handlePromotionSelect = (selectedType) => {
    setSelectedPromotionType(selectedType);
    console.log("Selected promotion type:", selectedType);
    
    // Update the state that will be saved to Firebase
    setHasUnsavedChanges(true);
  };
const [backgroundImage, setBackgroundImage] = useState(null);
const [backgroundImageFile, setBackgroundImageFile] = useState(null);
const [isBackgroundEditing, setIsBackgroundEditing] = useState(false);
const [isProfileEditing, setIsProfileEditing] = useState(false);
const [currentEditingContext, setCurrentEditingContext] = useState(null)


const handleBackgroundImageUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    const previewUrl = URL.createObjectURL(file);
    openImageEditor(previewUrl, 'background', file);
  }
};

const [productEditingState, setProductEditingState] = useState({
  image: null,
  file: null,
  isEditing: false,
  context: null
});
const handleEditExistingImage = (productIndex, itemIndex) => {
  const item = products[productIndex].items[itemIndex];
  if (item.imageUrl || item.cloudinaryUrl) {
    openImageEditor(
      item.cloudinaryUrl || item.imageUrl, 
      'product', 
      null, 
      { productIndex, itemIndex }
    );
  }
};
const [imageEditingState, setImageEditingState] = useState({
  isOpen: false,
  imageSrc: null,
  imageType: null, // 'profile', 'background', or 'product'
  imageFile: null,
  context: null // additional context for product images
});
// Replace all the individual state setters with these functions:
const openImageEditor = (imageSrc, imageType, imageFile = null, context = null) => {
  setImageEditingState({
    isOpen: true,
    imageSrc,
    imageType,
    imageFile,
    context
  });
};

const closeImageEditor = () => {
  setImageEditingState({
    isOpen: false,
    imageSrc: null,
    imageType: null,
    imageFile: null,
    context: null
  });
};
const handleDeleteBackgroundImage = () => {
  setBackgroundImage(null);
  setBackgroundImageFile(null);
  setBackgroundEditingState({ image: null, file: null, isEditing: false });
};
// Profile image handlers (you already have some profile image state)
const handleProfileImageUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    const previewUrl = URL.createObjectURL(file);
    openImageEditor(previewUrl, 'profile', file);
  }
};



const handleDeleteProfileImage = () => {
  if (profileImage?.previewUrl) {
    URL.revokeObjectURL(profileImage.previewUrl);
  }
  setProfileImage(null);
  setProfileEditingState({ image: null, file: null, isEditing: false });
};

const backgroundInputRef = useRef(null);
const profileInputRef = useRef(null);
const handleSaveEditedImage = async (imageUrl, imageBlob) => {
  try {
    let cloudinaryUrl = imageUrl;
    let finalBlob = imageBlob;
    
    // If we have a blob, upload to Cloudinary
    if (imageBlob) {
      let folderName = 'images';
      
      switch (imageEditingState.imageType) {
        case 'profile':
          folderName = 'profile-images';
          break;
        case 'background':
          folderName = 'background-images';
          break;
        case 'product':
          folderName = 'product-images';
          break;
        default:
          folderName = 'images';
      }
      
      const uploadResult = await uploadToCloudinary(imageBlob, {
        folder: folderName,
        userId: auth.currentUser?.uid
      });
      cloudinaryUrl = uploadResult.url;
      finalBlob = imageBlob;
    }
    
    // If no blob but we have a URL (when skipping), try to upload the URL
    if (!imageBlob && imageUrl && !imageUrl.startsWith('blob:')) {
      // It's already a Cloudinary URL or external URL, use as-is
      cloudinaryUrl = imageUrl;
    }

    // Update the appropriate state
    switch (imageEditingState.imageType) {
      case 'profile':
        setProfileImage({
          file: finalBlob || imageEditingState.imageFile,
          url: cloudinaryUrl,
          previewUrl: imageUrl, // Keep the preview URL for immediate display
          cloudinaryUrl: cloudinaryUrl,
          documentType: 'Profile Image'
        });
        break;
        
      case 'background':
        setBackgroundImage(imageUrl); // Use preview URL for immediate display
        setBackgroundImageFile(finalBlob || imageEditingState.imageFile);
        // Store Cloudinary URL separately if needed
        if (cloudinaryUrl !== imageUrl) {
          // You might want to add a state for backgroundCloudinaryUrl
        }
        break;
        
      case 'product':
        const { productIndex, itemIndex } = imageEditingState.context;
        setProducts(prev => {
          const updatedProducts = [...prev];
          const updatedItems = [...updatedProducts[productIndex].items];
          
          updatedItems[itemIndex] = {
            ...updatedItems[itemIndex],
            imageUrl: cloudinaryUrl,
            previewUrl: imageUrl,
            cloudinaryUrl: cloudinaryUrl,
            cloudinaryData: { url: cloudinaryUrl }
          };
          
          updatedProducts[productIndex] = {
            ...updatedProducts[productIndex],
            items: updatedItems
          };
          
          return updatedProducts;
        });
        break;
    }

    console.log(`${imageEditingState.imageType} image saved successfully`);
    closeImageEditor();
    
  } catch (error) {
    console.error("Error saving edited image:", error);
    alert("Failed to save edited image. Please try again.");
    
    // Fallback: at least set the preview URL so the image shows up
    switch (imageEditingState.imageType) {
      case 'profile':
        setProfileImage(prev => ({
          ...prev,
          previewUrl: imageUrl,
          url: imageUrl
        }));
        break;
      case 'background':
        setBackgroundImage(imageUrl);
        break;
    }
    
    closeImageEditor();
  }
};

 // Replace your current bakes state initialization with this:
 const [bakes, setBakes] = useState([
  {
    id: "bake-1",
    category: "Pesticide",
    items: [
      { 
        name: "Pesticide", 
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758037980/image_2164_oo5pwe.png",
        imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758037980/image_2164_oo5pwe.png"
      },
      { 
        name: "", 
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758452177/Rectangle_34643979_1_m1ifgy.png",
        imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758452177/Rectangle_34643979_1_m1ifgy.png"
      }
    ]
  },
  {
    id: "bake-2",
    category: "Bake",
    items: [
      { 
        name: "", 
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758452177/Rectangle_34643979_1_m1ifgy.png",
        imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758452177/Rectangle_34643979_1_m1ifgy.png"
      },
      { 
        name: "", 
        image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758452177/Rectangle_34643979_1_m1ifgy.png",
        imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758452177/Rectangle_34643979_1_m1ifgy.png"
      }
    ]
  }
]);

  
  const [services, setServices] = useState([
    {
      id: "service-1", // Changed to unique ID
      category: "Spraying",
      items: [
        { name: "Pesticide", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758454321/image_2522_usqgia.png" },
        { name: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758452177/Rectangle_34643979_1_m1ifgy.png" }
      ]
    },
    {
      id: "service-2", // Changed to unique ID
      items: [
        { name: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758452177/Rectangle_34643979_1_m1ifgy.png" },
        { name: "", image: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758452177/Rectangle_34643979_1_m1ifgy.png" }
      ]
    }
  ]);
 
  const [isEditingTitle, setIsEditingTitle] = useState(null);


  const handlePromotionImageEdit = (cardIndex, imageType = 'promotion') => {
    const card = promoCards[cardIndex];
    if (card.mainImage) {
      setPromotionEditingState({
        isOpen: true,
        imageSrc: card.mainImage,
        imageType: imageType,
        imageFile: card.mainImageFile || null,
        context: { cardIndex, imageType: 'promotion' }
      });
    }
  };
  
  const handleSaveEditedPromotionImage = async (imageUrl, imageBlob) => {
    try {
      let cloudinaryUrl = imageUrl;
      
      if (imageBlob) {
        const uploadResult = await uploadToCloudinary(imageBlob, {
          folder: 'promotions',
          userId: auth.currentUser?.uid
        });
        cloudinaryUrl = uploadResult.url;
      }
      
      const { cardIndex } = promotionEditingState.context;
      
      setPromoCards(prev => {
        const updatedCards = [...prev];
        updatedCards[cardIndex] = {
          ...updatedCards[cardIndex],
          mainImage: cloudinaryUrl,
          cloudinaryUrl: cloudinaryUrl,
          mainImageFile: imageBlob || updatedCards[cardIndex].mainImageFile
        };
        
        return updatedCards;
      });
  
      console.log("Promotion image saved successfully");
      setPromotionEditingState({
        isOpen: false,
        imageSrc: null,
        imageType: null,
        imageFile: null,
        context: null
      });
      
    } catch (error) {
      console.error("Error saving edited promotion image:", error);
      alert("Failed to save edited image. Please try again.");
    }
  };
  const PromotionCard = ({ initialData, onSave, index }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [cardData, setCardData] = useState(initialData);
    const mainImageInputRef = useRef(null);
    const [isUploading, setIsUploading] = useState(false);
  
    const handleDeleteImage = () => {
      setCardData(prev => ({ 
        ...prev, 
        mainImage: null,
        mainImageFile: null
      }));
    };
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setCardData(prev => ({ ...prev, [name]: value }));
    };
  
    const handleImageChange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
    
      setIsUploading(true);
      try {
        const previewUrl = URL.createObjectURL(file);
        setPromotionEditingState({
          isOpen: true,
          imageSrc: previewUrl,
          imageType: 'promotion',
          imageFile: file,
          context: { cardIndex: index, imageType: 'promotion' }
        });
        
      } catch (error) {
        console.error("Error processing promotion image:", error);
        alert("Failed to process image: " + error.message);
      } finally {
        setIsUploading(false);
      }
    };
  
    const handleEditExistingImage = () => {
      if (cardData.mainImage) {
        handlePromotionImageEdit(index, 'promotion');
      }
    };
  
    const handleSave = () => {
      onSave(cardData);
      setIsEditing(false);
    };
  
    return (
      <div className="overflow-hidden">
        {/* Main image section with similar editing functionality */}
        <div className='relative' style={{ backgroundColor: cardData.bgColor || 'transparent' }}>
          {cardData.mainImage ? (
            <>
              <img 
                src={cardData.mainImage} 
                alt="Main" 
                className="md:h-[350px] h-[120px] rounded-[2px] w-full object-cover cursor-pointer" 
                onClick={handleEditExistingImage}
              />
              
              <div className="absolute top-2 right-2 cursor-pointer">
                <div 
                  className="flex items-center gap-1"
                  onClick={() => mainImageInputRef.current?.click()}
                >
                  <span className="text-[8px] md:text-[10px] italic text-[#979797]">
                    {isUploading ? "Uploading..." : "Insert image"}
                  </span>
                  <img 
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754924245/Add_square_duotone_quvbbl.png" 
                    alt="Change" 
                    className="w-3 h-3 md:w-[40px] md:h-[40px]"
                  />
                </div>
              </div>
              
              <div className="absolute bottom-2 right-2 cursor-pointer">
                <div 
                  className="flex items-center gap-1 "
                  onClick={handleDeleteImage}
                >
                  <span className="text-[8px] md:text-[10px] italic text-[#979797]">
                    Delete
                  </span>
                  <img 
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758032874/Trash_w4r37f.png" 
                    alt="Delete" 
                    className="w-3 h-3 md:w-[25px] md:h-[25px]"
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="md:h-[350px] h-[120px] rounded-[2px] bg-[#D9D9D9] relative">
              <div className="absolute top-2 right-2 cursor-pointer">
                <div 
                  className="flex items-center gap-1 p-1"
                  onClick={() => mainImageInputRef.current?.click()}
                >
                  <span className="text-[8px] md:text-[10px] italic text-[#979797]">
                    {isUploading ? "Uploading..." : "Insert Image"}
                  </span>
                  <img 
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754924245/Add_square_duotone_quvbbl.png" 
                    alt="Add" 
                    className="w-3 h-3 md:w-[40px] md:h-[40px]"
                  />
                </div>
              </div>
            </div>
          )}
          
          <input
            type="file"
            ref={mainImageInputRef}
            onChange={handleImageChange}
            accept="image/*"
            className="hidden"
            disabled={isUploading}
          />
  
          {cardData.badgeImage && (
            <div className="absolute bottom-[15px] right-2 md:w-[128px] w-[60px] h-[60px] md:h-[128px]">
              <img
                src={cardData.badgeImage}
                alt="Special Offer"
                className="w-full h-full object-contain"
              />
            </div>
          )}
        </div>
        
        {/* Rest of the PromotionCard component remains the same */}
        <div className="w-full bg-white px-1 py-1">
          <div className="flex items-center justify-between mb-1">
            {isEditing ? (
              <input
                type="text"
                name="title"
                value={cardData.title}
                onChange={handleInputChange}
                className="md:text-[32px] text-[8px] md:h-full h-[20px] font-bold w-full border-b border-gray-300 outline-none"
              />
            ) : (
              <h2 className="md:text-[32px] text-[8px] font-bold text-black italic">
                {cardData.title}
              </h2>
            )}
            
            <div className="flex items-center gap-2">
              {isEditing ? (
                <input
                  type="text"
                  placeholder="Additional text"
                  className="text-[8px] md:text-[12px] italic text-[#979797] border-b border-gray-300 outline-none w-16 md:w-24"
                />
              ) : (
                <span className="text-[8px] md:text-[12px] italic text-[#979797]">
                  Additional text
                </span>
              )}
            </div>
          </div>
          
          <div className="flex justify-between items-start">
            {isEditing ? (
              <textarea
                name="description"
                value={cardData.description}
                onChange={handleInputChange}
                className="md:text-[24px] text-[6px] font-normal w-full h-[50px] md:h-[100px] border border-gray-300 outline-none mt-1 p-1 text-[#979797] italic"
                placeholder="Enter description"
              />
            ) : (
              <p className="md:text-[24px] text-[6px] font-normal leading-snug whitespace-pre-line text-black italic">
                {cardData.description}
              </p>
            )}
            <div className="flex items-center gap-1">
              {isEditing ? (
                <div 
                  className="cursor-pointer p-1 hover:bg-gray-200 rounded-full"
                  onClick={handleSave}
                  title="Save"
                >
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750801615/Import_lll7wj.png"
                    alt="Save"
                    className="w-3 h-3 md:w-4 md:h-4"
                  />
                </div>
              ) : (
                <div 
                  className="cursor-pointer p-1 hover:bg-gray-200 rounded-full"
                  onClick={() => setIsEditing(true)}
                  title="Edit text"
                >
                  <img
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754927254/Edit_fill_lr0kv7.png"
                    alt="Edit text"
                    className="w-3 h-3 md:w-[30px] md:h-[30px]"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  

 
 
  

const handleSaveServices = async () => {
  try {
    const userIdentifier = formData.username || formData.email;
    
    if (!userIdentifier) {
      alert("Please complete registration first");
      return;
    }

    const results = await saveServicesToFirebase(services, userIdentifier);
    
    const successfulSaves = results.filter(r => r.success);
    
    if (successfulSaves.length > 0) {
      alert(`Successfully saved ${successfulSaves.length} service(s)!`);
      
      // Log details for debugging
      successfulSaves.forEach(service => {
        console.log(`Service "${service.category}" saved with ID: ${service.id}`);
      });
    } else {
      alert("Failed to save any services. Please try again.");
    }
    
    return results;
  } catch (error) {
    console.error("Error saving services:", error);
    alert(`Failed to save services: ${error.message}`);
    throw error;
  }
};

const saveData = useCallback(() => {
  if (!hasUnsavedChanges) return;
  
  setIsSaving(true);
  
  // Create a minimal version of data for localStorage
  const dataToSave = {
    // Only save essential data, not images/files
    formData: {
      firstName: formData.firstName,
      surname: formData.surname,
      email: formData.email,
      // Add other essential fields but skip large data
    },
    dropdownSelections,
    reportSelections,
    selectedLanguage,
    // Don't save image data to localStorage
    agreed,
    race,
    gender,
    disability,
    orgType
  };
  
  try {
    localStorage.setItem('farmRegistrationData', JSON.stringify(dataToSave));
    setLastSaved(new Date().toLocaleTimeString());
    setHasUnsavedChanges(false);
  } catch (error) {
    console.error('Error saving data:', error);
    // If localStorage is full, try to clear some space
    if (error.name === 'QuotaExceededError') {
      try {
        // Clear old data and try again
        localStorage.removeItem('farmRegistrationData');
        localStorage.setItem('farmRegistrationData', JSON.stringify(dataToSave));
      } catch (e) {
        console.error('Still unable to save data:', e);
      }
    }
  } finally {
    setTimeout(() => setIsSaving(false), 1000);
  }
}, [hasUnsavedChanges, formData, reportSelections, selectedLanguage, agreed, race, gender, disability, orgType]);
// Update the saveMarketingData function
const saveMarketingData = async (uid) => {
  try {
    // Process advertisements - only save Cloudinary URLs
    const uploadedAdvertisements = await Promise.all(
      advertisementCards.map(async (card, index) => {
        try {
          let mainImageUrl = card.cloudinaryUrl || card.mainImage;
          
          // If it's a blob URL or file, try to upload to Cloudinary
          if ((card.mainImage && card.mainImage.startsWith('blob:')) || card.mainImageFile) {
            const fileToUpload = card.mainImageFile || (await fetch(card.mainImage).then(r => r.blob()));
            mainImageUrl = await uploadMarketingImageToCloudinary(fileToUpload, 'advertisements');
          }
          
          return {
            title: card.title,
            description: card.description,
            mainImage: mainImageUrl, // This should now be Cloudinary URL
            badgeImage: card.badgeImage,
            bgColor: card.bgColor || '#D9D9D9',
            type: 'ADVERTISEMENT',
            createdAt: new Date().toISOString()
          };
        } catch (error) {
          console.error("Error processing advertisement card:", error);
          return null;
        }
      })
    );

    // Process promotions similarly
    const uploadedPromotions = await Promise.all(
      promoCards.map(async (card, index) => {
        try {
          let mainImageUrl = card.cloudinaryUrl || card.mainImage;
          
          if ((card.mainImage && card.mainImage.startsWith('blob:')) || card.mainImageFile) {
            const fileToUpload = card.mainImageFile || (await fetch(card.mainImage).then(r => r.blob()));
            mainImageUrl = await uploadMarketingImageToCloudinary(fileToUpload, 'promotions');
          }
          
          return {
            title: card.title,
            description: card.description,
            mainImage: mainImageUrl,
            badgeImage: card.badgeImage,
            bgColor: card.bgColor || '#D9D9D9',
            type: 'PROMOTION',
            createdAt: new Date().toISOString()
          };
        } catch (error) {
          console.error("Error processing promotion card:", error);
          return null;
        }
      })
    );

    // Filter out failed uploads and cards with blob URLs
    const validAdvertisements = uploadedAdvertisements.filter(card => 
      card !== null && card.mainImage && !card.mainImage.startsWith('blob:')
    );
    
    const validPromotions = uploadedPromotions.filter(card => 
      card !== null && card.mainImage && !card.mainImage.startsWith('blob:')
    );

    // Save to Firestore
    const userRef = doc(db, "registrations", uid);
    await updateDoc(userRef, {
      marketingData: {
        advertisements: validAdvertisements,
        promotions: validPromotions,
        lastUpdated: new Date().toISOString()
      },
      lastUpdated: new Date().toISOString()
    });

    console.log("Marketing data saved with Cloudinary URLs:", {
      advertisements: validAdvertisements.length,
      promotions: validPromotions.length
    });
    
    return true;
  } catch (error) {
    console.error("Error saving marketing data:", error);
    throw error;
  }
};

const debugImageUploads = () => {
  console.log("Advertisement cards:", advertisementCards);
  console.log("Promotion cards:", promoCards);
  
  advertisementCards.forEach((card, index) => {
    console.log(`Ad ${index}:`, {
      hasFile: card.mainImage instanceof File || card.mainImageFile instanceof File,
      isURL: typeof card.mainImage === 'string',
      fileType: card.mainImage instanceof File ? card.mainImage.type : 'N/A'
    });
  });
};const handleAdvertisementImageEdit = (cardIndex, imageType = 'advertisement') => {
  const card = advertisementCards[cardIndex];
  if (card.mainImage) {
    setAdvertisementEditingState({
      isOpen: true,
      imageSrc: card.mainImage,
      imageType: imageType,
      imageFile: card.mainImageFile || null,
      context: { cardIndex, imageType: 'advertisement' }
    });
  }
};

// Add this function to handle saving edited advertisement images
const handleSaveEditedAdvertisementImage = async (imageUrl, imageBlob) => {
  try {
    let cloudinaryUrl = imageUrl;
    
    // If we have a blob, upload to Cloudinary
    if (imageBlob) {
      const uploadResult = await uploadToCloudinary(imageBlob, {
        folder: 'advertisements',
        userId: auth.currentUser?.uid
      });
      cloudinaryUrl = uploadResult.url;
    }
    
    // Update the advertisement card with the new image
    const { cardIndex } = advertisementEditingState.context;
    
    setAdvertisementCards(prev => {
      const updatedCards = [...prev];
      updatedCards[cardIndex] = {
        ...updatedCards[cardIndex],
        mainImage: cloudinaryUrl,
        cloudinaryUrl: cloudinaryUrl,
        mainImageFile: imageBlob || updatedCards[cardIndex].mainImageFile
      };
      
      return updatedCards;
    });

    console.log("Advertisement image saved successfully");
    setAdvertisementEditingState({
      isOpen: false,
      imageSrc: null,
      imageType: null,
      imageFile: null,
      context: null
    });
    
  } catch (error) {
    console.error("Error saving edited advertisement image:", error);
    alert("Failed to save edited image. Please try again.");
  }
};
const AdvertisementCard = ({ initialData, onSave, index }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [cardData, setCardData] = useState(initialData);
  const [isUploading, setIsUploading] = useState(false);
  const mainImageInputRef = useRef(null);

  const handleDeleteImage = () => {
    setCardData(prev => ({ 
      ...prev, 
      mainImage: null,
      mainImageFile: null,
      cloudinaryUrl: null
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCardData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    setIsUploading(true);
    try {
      // Instead of uploading immediately, open the image editor
      const previewUrl = URL.createObjectURL(file);
      setAdvertisementEditingState({
        isOpen: true,
        imageSrc: previewUrl,
        imageType: 'advertisement',
        imageFile: file,
        context: { cardIndex: index, imageType: 'advertisement' }
      });
      
    } catch (error) {
      console.error("Error processing advertisement image:", error);
      alert("Failed to process image: " + error.message);
    } finally {
      setIsUploading(false);
    }
  };

  const handleEditExistingImage = () => {
    if (cardData.mainImage) {
      handleAdvertisementImageEdit(index, 'advertisement');
    }
  };

  const handleSave = () => {
    const dataToSave = {
      ...cardData,
      mainImage: cardData.cloudinaryUrl || cardData.mainImage
    };
    
    onSave(index, dataToSave);
    setIsEditing(false);
  };

  return (
    <div className="overflow-hidden">
      {/* Main image */}
      <div className='relative' style={{ backgroundColor: cardData.bgColor || 'transparent' }}>
        {cardData.mainImage ? (
          <>
            <img 
              src={cardData.mainImage} 
              alt="Main" 
              className="md:h-[350px] h-[120px] rounded-[2px] w-full object-cover cursor-pointer" 
              onClick={handleEditExistingImage}
            />
            
            {/* Image controls */}
            <div className="absolute top-2 right-2 cursor-pointer">
              <div 
                className="flex items-center gap-1"
                onClick={() => mainImageInputRef.current?.click()}
              >
                <span className="text-[8px] md:text-[10px] italic text-[#979797]">
                  {isUploading ? "Uploading..." : "Insert iMAGE"}
                </span>
                <img 
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754924245/Add_square_duotone_quvbbl.png" 
                  alt="Change" 
                  className="w-3 h-3 md:w-[40px] md:h-[40px]"
                />
              </div>
            </div>
            
            <div className="absolute bottom-2 right-2 cursor-pointer">
              <div 
                className="flex items-center gap-1 "
                onClick={handleDeleteImage}
              >
                <span className="text-[8px] md:text-[10px] italic text-[#979797]">
                  Delete
                </span>
                <img 
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758032874/Trash_w4r37f.png" 
                  alt="Delete" 
                  className="w-3 h-3 md:w-[25px] md:h-[25px]"
                />
              </div>
            </div>
          </>
        ) : (
          <div className="md:h-[350px] h-[120px] rounded-[2px] bg-[#D9D9D9] relative">
            <div className="absolute top-2 right-2 cursor-pointer">
              <div 
                className="flex items-center gap-1 p-1"
                onClick={() => mainImageInputRef.current?.click()}
              >
                <span className="text-[8px] md:text-[10px] italic text-[#979797]">
                  {isUploading ? "Uploading..." : "Insert Image"}
                </span>
                <img 
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754924245/Add_square_duotone_quvbbl.png" 
                  alt="Add" 
                  className="w-3 h-3 md:w-[40px] md:h-[40px]"
                />
              </div>
            </div>
          </div>
        )}
        
        {/* Hidden file input */}
        <input
          type="file"
          ref={mainImageInputRef}
          onChange={handleImageChange}
          accept="image/*"
          className="hidden"
          disabled={isUploading}
        />

        {/* Special Offer badge */}
        {cardData.badgeImage && (
          <div className="absolute bottom-[15px] right-2 md:w-[128px] w-[60px] h-[60px] md:h-[128px]">
            <img
              src={cardData.badgeImage}
              alt="Special Offer"
              className="w-full h-full object-contain"
            />
          </div>
        )}
      </div>
      
      {/* Bottom content */}
      <div className="w-full bg-white px-1 py-1">
        <div className="flex items-center justify-between mb-1">
          {isEditing ? (
            <input
              type="text"
              name="title"
              value={cardData.title}
              onChange={handleInputChange}
              className="md:text-[32px] text-[8px] md:h-full h-[20px] font-bold w-full border-b border-gray-300 outline-none"
            />
          ) : (
            <h2 className="md:text-[32px] text-[8px] font-bold text-black italic">
              {cardData.title}
            </h2>
          )}
          
          <div className="flex items-center gap-2">
            {isEditing ? (
              <input
                type="text"
                placeholder="Additional text"
                className="text-[8px] md:text-[12px] italic text-[#979797] border-b border-gray-300 outline-none w-16 md:w-24"
              />
            ) : (
              <span className="text-[8px] md:text-[12px] italic text-[#979797]">
                Additional text
              </span>
            )}
          </div>
        </div>
        
        <div className="flex justify-between items-start">
          {isEditing ? (
            <textarea
              name="description"
              value={cardData.description}
              onChange={handleInputChange}
              className="md:text-[24px] text-[6px] font-normal w-full h-[50px] md:h-[100px] border border-gray-300 outline-none mt-1 p-1 text-[#979797] italic"
              placeholder="Enter description"
            />
          ) : (
            <p className="md:text-[24px] text-[6px] font-normal leading-snug whitespace-pre-line text-black italic">
              {cardData.description}
            </p>
          )}
          <div className="flex items-center gap-1">
            {isEditing ? (
              <div 
                className="cursor-pointer p-1 hover:bg-gray-200 rounded-full"
                onClick={handleSave}
                title="Save"
              >
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750801615/Import_lll7wj.png"
                  alt="Save"
                  className="w-3 h-3 md:w-4 md:h-4"
                />
              </div>
            ) : (
              <div 
                className="cursor-pointer p-1 hover:bg-gray-200 rounded-full"
                onClick={() => setIsEditing(true)}
                title="Edit text"
              >
                <img
                  src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754927254/Edit_fill_lr0kv7.png"
                  alt="Edit text"
                  className="w-3 h-3 md:w-[30px] md:h-[30px]"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Add similar functionality for Promotion cards
const [promotionEditingState, setPromotionEditingState] = useState({
  isOpen: false,
  imageSrc: null,
  imageType: null,
  imageFile: null,
  context: null
});


const [isSavingMarketing, setIsSavingMarketing] = useState(false);
const [saveMarketingMessage, setSaveMarketingMessage] = useState("");

// Add this function to handle the save button click
const handleSaveMarketingClick = async () => {
  if (!auth.currentUser) {
    setSaveMarketingMessage("Please register first before saving marketing data");
    return;
  }

  setIsSavingMarketing(true);
  setSaveMarketingMessage("");

  try {
    await saveMarketingData(auth.currentUser.uid);
    setSaveMarketingMessage("Marketing data saved successfully!");
    
    // Show success message for 3 seconds
    setTimeout(() => {
      setSaveMarketingMessage("");
    }, 3000);
    
  } catch (error) {
    console.error("Error saving marketing data:", error);
    setSaveMarketingMessage("Failed to save marketing data. Please try again.");
  } finally {
    setIsSavingMarketing(false);
  }
};

const handleSaveMarketingData = async () => {
  if (auth.currentUser) {
    try {
      // Check if any images are still uploading
      const isUploading = Object.values(uploadingImages).some(status => status);
      if (isUploading) {
        alert("Please wait for images to finish uploading");
        return;
      }

      setUploadingImages({}); // Reset uploading state
      
      const success = await saveMarketingData(auth.currentUser.uid);
      
      if (success) {
        // Show success message
        alert("Congratulations! Marketing data saved successfully with images!");
        
        // Optional: Show celebration animation
        setShowCelebration(true);
        setTimeout(() => setShowCelebration(false), 3000);
      } else {
        alert("Failed to save marketing data. Please try again.");
      }
    } catch (error) {
      console.error("Marketing data save error:", error);
      
      // Show specific error message
      if (error.message.includes("Upload failed")) {
        alert("Failed to upload images. Please check your internet connection and try again.");
      } else {
        alert("Failed to save marketing data: " + error.message);
      }
    }
  } else {
    alert("Please register first before saving marketing data");
  }
};
const handleAdvertisementCardSave = (index, newData) => {
  const updatedCards = [...advertisementCards];
  
  // Don't save if it's still a blob URL
  if (newData.mainImage && newData.mainImage.startsWith('blob:')) {
    alert("Please wait for image to finish uploading to Cloudinary");
    return;
  }
  
  updatedCards[index] = {
    ...newData,
    mainImage: newData.cloudinaryUrl || newData.mainImage // Prefer Cloudinary URL
  };
  setAdvertisementCards(updatedCards);
};

const handlePromoCardSave = (index, newData) => {
  const updatedCards = [...promoCards];
  updatedCards[index] = {
    ...newData,
    // If mainImage is already a URL (from Cloudinary), keep it
    // If it's a file object, we need to handle it (though it should be uploaded by now)
    mainImage: typeof newData.mainImage === 'string' 
      ? newData.mainImage 
      : newData.mainImageFile ? URL.createObjectURL(newData.mainImageFile) : null
  };
  setPromoCards(updatedCards);
};
const handleDocumentSelect = (documentName) => {
  setCertificates(prevCertificates => {
    // Find the first box that still has default title
    const updatedCertificates = [...prevCertificates];
    const defaultTitles = [
      "Business Registration",
      "Trade Certificate", 
      "Business License",
      "Health Certificate"
    ];
    
    // Find index of first box that still has default title
    const indexToUpdate = updatedCertificates.findIndex(
      (cert, index) => cert.title === defaultTitles[index]
    );
    
    if (indexToUpdate !== -1) {
      updatedCertificates[indexToUpdate] = {
        ...updatedCertificates[indexToUpdate],
        title: documentName
      };
    }
    
    return updatedCertificates;
  });
};
const handleReferralCodeChange = (e) => {
  setReferralCodeInput(e.target.value);
};
const [isSavingDocuments, setIsSavingDocuments] = useState(false);
const [documentSaveStatus, setDocumentSaveStatus] = useState("");

const uploadDocumentImage = async (file, index) => {
  try {
    if (!file) return null;
    
    // Upload to Cloudinary
    const uploadResult = await uploadToCloudinary(file, {
      folder: 'documents',
      userId: auth.currentUser?.uid
    });
    
    // Update local state with the new image URL
    setCertificatesUrls(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        url: uploadResult.url,
        cloudinaryUrl: uploadResult.url,
        previewUrl: URL.createObjectURL(file), // Keep preview for UI
        file: null, // Clear the file object after upload
        documentType: updated[index]?.documentType || 'Unknown',
        type: 'certificate'
      };
      return updated;
    });
    
    return uploadResult.url;
  } catch (error) {
    console.error('Error uploading document:', error);
    alert('Failed to upload document image');
    return null;
  }
};
const [profileEditingState, setProfileEditingState] = useState({
  image: null,
  file: null,
  isEditing: false
});

const [backgroundEditingState, setBackgroundEditingState] = useState({
  image: null,
  file: null,
  isEditing: false
});
const [isEnterpriseEditing, setIsEnterpriseEditing] = useState(false);
    return (
      <div className="bg-white">
      <div className="md:px-28 px-4">
          {/* Header Section */}
          <div className="w-full mx-auto md:pt-4 pt-4">
          {/* <div className="flex justify-between items-end ">
  <h1 className="md:text-4xl text-xs font-bold md:mb-3 mb-1">REGISTRATION</h1>
    <a href="/Document">
            <div>
              {renderButtonWithIcon("VERIFY REGISTRTION", "#152C24", "#FDBB26", true)}
              <p className="md:text-[14px] text-[4px] font-normal mt-1">Click to verify registration</p>
            </div>
          </a>
  </div> */}
   {/* Heading */}
   <h1 className="text-3xl md:text-4xl lg:text-[36px] font-bold mb-4">
        Registration
      </h1>

      {/* Buttons Row */}
      <div className="grid grid-cols-7 gap-1 md:gap-2 w-full mb-4 md:mb-8">
  {buttons.map((btn, index) => (
    <button
      key={index}
      onClick={() => navigate(btn.path)}
      className={`
        h-4 md:h-10 lg:h-[40px] 
        rounded-[2px] shadow-md 
        text-[4px] md:text-sm lg:text-[14px] font-normal
        bg-[#152C24] text-white
        border-b-2 
        ${
          activeButton === index
            ? "border-[#FDBD26]"
            : "border-gray-400"
        }
        hover:bg-[#1a3a30] transition-colors duration-200
      `}
    >
      {btn.label}
    </button>
  ))}
</div>

      {/* Section Heading */}
      <h2 className="text-xl md:text-2xl lg:text-[24px] font-normal mb-4">
        <span className="font-bold">Individual Registration</span> (Farmer)
      </h2>

      {/* Paragraph */}
      <p className="text-base md:text-lg lg:text-[24px] font-normal mb-10">
        The registration process on the Farmnet website involves filling out a
        simple online form with your personal and farm details to create an
        account and gain access to the platform’s farming tools and services.
      </p>
      <div className="flex justify-between  items-center mb-2  text-lg md:text-[36px] lg:text-[36px] font-bold mt-2">
      <div className="w-1/2 flex items-center justify-center">
          <span   onClick={() => handleTopTabClick("farmers")}>Farmers</span>
      </div>
     <div className="w-1/2 flex items-center justify-center">
        <span     onClick={() => handleTopTabClick("organizations")}> Organizations</span>
        </div>
      </div>
      {/* Tabs */}
      <div className="flex w-full h-[6px] md:h-[10px] rounded-[10px] overflow-hidden mt-2">
  <div
    onClick={() => handleTopTabClick("farmers")}
    className={`w-1/2 cursor-pointer rounded-[10px] transition-all duration-300 ${
      activeTab === "farmers" ? "bg-[#152C24]" : "bg-[#E7EBEB]"
    }`}
  ></div>
  <div
    onClick={() => handleTopTabClick("organizations")}
    className={`w-1/2 cursor-pointer rounded-[10px] transition-all duration-300 ${
      activeTab === "organizations" ? "bg-[#152C24]" : "bg-[#E7EBEB]"
    }`}
  ></div>
</div>


      {/* Tab Labels */}
      
  <div className="md:mt-3 mt-1 relative">
  <div 
    className="relative w-full h-[160px] md:h-[705px] bg-cover rounded-md bg-center transition-all duration-300" 
    style={{ 
  backgroundImage: backgroundImage ? `url(${backgroundImage})` : "linear-gradient(to bottom, #D9D9D9, #D9D9D9)",
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundColor: backgroundImage ? 'transparent' : '#D9D9D9'
}}
  >
    {/* Placeholder text when no background image */}
    {!backgroundImage && (
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-4">
        <p className="text-[#979797] font-bold text-[8px] md:text-[40px] md:mb-2">
          Insert Background Image Here
        </p>
        <p className="text-[#979797] font-normal text-[6px] md:text-[24px]">
          Select and add image from your business or industry
        </p>
      </div>
    )}

    {/* Profile image area */}
    <div className="absolute bottom-1 left-1 md:bottom-6 md:left-6 flex flex-col items-center">
      <div className="relative h-[70px] w-[70px] md:w-[250px] md:h-[250px]">
        {/* Profile image */}
        {profileImage?.previewUrl ? (
  <div 
    className="w-full h-full bg-cover bg-center rounded-full" 
    style={{ backgroundImage: `url(${profileImage.previewUrl})` }} 
  />
) : (
  <div className="w-full h-full bg-[#B3B3B3] rounded-full flex flex-col items-center justify-center text-center"></div>
)}
        {/* Profile add button */}
        <div className="flex gap-2 md:gap-6 items-center absolute top-2 -right-6 md:top-7 md:-right-32 cursor-pointer group">
          <button
            className="p-0.5 md:p-1 rounded-full group-hover:bg-yellow-500/20 transition-all"
            onClick={() => profileInputRef.current?.click()}
          >
            <img 
              src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754757592/Add_ring_duotone_x8uckd.png" 
              alt="Add" 
              className="w-2 h-2 md:w-8 md:h-8 group-hover:scale-110 transition-transform" 
            />
          </button>
          <p className="text-[4px] md:text-2xl font-normal text-[#979797] group-hover:text-yellow-400"      onClick={() => profileInputRef.current?.click()}>
            Insert Image
          </p>
        </div>

        {/* Profile delete button */}
          <button className="flex gap-2 md:gap-6 items-center absolute bottom-2 -right-6 md:bottom-7 md:-right-32 cursor-pointer group">
            <div 
              className="p-0.5 md:p-1 rounded-full group-hover:bg-yellow-500/20 transition-all"
              onClick={handleDeleteProfileImage}
            >
              <img 
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754757592/Trash_duotone_line_varm7v.png" 
                alt="Delete" 
                className="w-2 h-2 md:w-8 md:h-8 group-hover:scale-110 transition-transform" 
              />
            </div>
            <p className="text-[4px] md:text-2xl font-normal text-[#979797] group-hover:text-yellow-400">
              Delete Image
            </p>
          </button>
      </div>
    </div>

    {/* Background controls */}
    <div className="absolute top-2 right-2 md:top-6 md:right-3 flex items-center text-[#979797] cursor-pointer group">
      <button
        className="p-1 md:p-2 rounded-full group-hover:bg-yellow-500/20 transition-all"
        onClick={() => backgroundInputRef.current?.click()}
      >
        <img 
          src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754757592/Add_ring_duotone_x8uckd.png" 
          alt="Add Background" 
          className="w-4 h-4 md:w-8 md:h-8 group-hover:scale-110 transition-transform" 
        />
      </button>
      <p className="text-[8px] md:text-2xl font-normal text-right leading-tight group-hover:text-yellow-400"   onClick={() => backgroundInputRef.current?.click()}>
        Insert / add background
      </p>
    </div>

    {/* Background delete button */}
      <button className="absolute bottom-2 right-2 md:bottom-3 md:right-3 flex items-center text-[#979797] cursor-pointer group">
        <p className="text-[8px] md:text-2xl font-normal text-right leading-tight -ml-8 md:-ml-16 group-hover:text-yellow-400">
          Delete Background
        </p>
        <div 
          className="p-1 md:p-2 rounded-full group-hover:bg-yellow-500/20 transition-all"
          onClick={handleDeleteBackgroundImage}
        >
          <img 
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754757592/Trash_duotone_line_varm7v.png" 
            alt="Delete Background" 
            className="w-4 h-4 md:w-8 md:h-8 group-hover:scale-110 transition-transform" 
          />
        </div>
      </button>
  </div>
  
  {/* Hidden file inputs */}
  <input
    type="file"
    ref={backgroundInputRef}
    onChange={handleBackgroundImageUpload}
    accept="image/*"
    className="hidden"
  />
  <input
    type="file"
    ref={profileInputRef}
    onChange={handleProfileImageUpload}
    accept="image/*"
    className="hidden"
  />
</div>
              <h1 className="text-[#979797] md:text-[36px] text-[14px] font-bold md:mt-3 mt-1 md:mb-3">
                  REGISTRATION{" "}
                  <span className="text-[#152C24]">| INDIVIDUAL</span>
              </h1>
       <div className="flex justify-between items-center w-full md:mt-3">
       
              <div className="flex items-center gap-2" >
              <a href={`/ReportsRegistrationPage?country=${encodeURIComponent(selectedCountry.name || "South Africa")}`}>
  <div className="mt-2">
    <h1 className="md:text-[20px] text-[6px] font-extrabold md:mb-1">COUNTRY</h1>
    <div className="flex w-fit md:mt-1">
      <button className={`xl:w-[240px] lg:w-[140px] md:w-[90px] w-[67px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
        <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">
          {selectedCountry.name.toUpperCase() || "SOUTH AFRICA"}
        </span>
      </button>
      <div className="w-[20px] h-[15px] md:h-[53px] md:w-[60px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer">
        <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate font-medium">
          {selectedCountry.code || "27"}
        </span>
      </div>
    </div>
    <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
      Select country flag to change country
    </p>
  </div>
</a>
<div className="w-auto mt-2">
<Dropdown1
label="LANGUAGE"
items={language.FACILITATOR}
type="FACILITATOR"
isLanguageDropdown={false}
onChange={handleDropdownChange}
/>
</div>
</div>
<div className="flex items-center gap-2">
<TypeFarming
  value={reportSelections["TYPE OF FARMING"]}
  onChange={(type, value) => {
    setReportSelections(prev => ({
      ...prev,
      "TYPE OF FARMING": value
    }));
  }}
/>
<TypeUser
  value={reportSelections["USER TYPE"]}
  onChange={(type, value) => {
    // Ensure value is properly handled whether it's an object or string
    const userTypeValue = typeof value === 'object' ? value : { name: value, value: value };
    setReportSelections(prev => ({
      ...prev,
      "USER TYPE": userTypeValue
    }));
  }}
  required={true}
/>
</div>
       </div>
          </div>
          <div className="w-full mx-auto md:pt-5 pt-2">
          <div className="flex sm:flex-row w-full gap-2">
            {['farmer', 'organization'].map((type) => (
              <div key={type} className="w-1/2 sm:w-1/2 relative">
                <button
                  className={`w-full h-6 md:h-12 flex items-center justify-between px-4 rounded-md ${
                    selectedType === type 
                      ? 'bg-[#152C24] text-white border-b-[2px] md:border-b-[4px] border-yellow-400' 
                      : 'bg-[#eaeaea] text-black'
                  }`}
                  onClick={() => handleTypeSelection(type)}
                >
                  <span className="font-bold md:text-xl text-[10px] capitalize">
                    {type === 'organization' 
                      ? (dropdownSelections.organization_type || 'Organization')
                      : type}
                  </span>
                  {type === 'organization' && (
                    <img 
                      src={
                        selectedType === 'organization'
                          ? "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754924326/Expand_down_3_mp2ztl.png"
                          : "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754854035/Expand_down_2_htv2di.png"
                      } 
                      alt="Expand icon" 
                      className={`md:w-7 md:h-6 w-4 h-3 transition-transform ${isOrgDropdownOpen ? 'transform rotate-180' : ''}`}
                    />
                  )}
                </button>
                <p className="md:text-sm text-[6px] text-left md:mt-2 text-gray-600 pl-1">
                  Select to register {type === 'farmer' ? 'individual farmer' : 'organization'}
                </p>

                {type === 'organization' && isOrgDropdownOpen && (
                  <AnimatePresence>
                    <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      className="absolute top-full left-0 w-full border border-[#979797]/80 bg-[#152C24] rounded shadow-lg max-h-[300px] overflow-y-auto z-[1000]"
                    >
                      <ul className="py-2">
                        {language.ORGANIZATION.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              setDropdownSelections(prev => ({
                                ...prev,
                                organization_type: item
                              }));
                              setIsOrgDropdownOpen(false);
                            }}
                            className="flex justify-between items-center px-2 md:px-4 py-1 md:py-2 hover:bg-gray-700 cursor-pointer"
                          >
                            <span className="text-white text-[6px] md:text-sm flex-1 mr-2">
                              {item}
                            </span>
                            <div className="flex items-center">
                              {dropdownSelections.organization_type === item ? (
                                <SelectedIcon />
                              ) : (
                                <UnselectedIcon />
                              )}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </motion.div>
                  </AnimatePresence>
                )}
              </div>
            ))}
          </div>
        </div>
      <div className="flex justify-between items-center md:mt-0 -mt-2">
      <ReportsSection
        values={reportSelections}
        onChange={handleReportDropdownChange}
        smmesOptions={SMMEsOptions}
      />
 <a
    href="/Why"
          className="md:w-[600px] w-[200px] h-[20px]  md:h-[55px] shadow-xl flex items-center justify-center rounded-[2px] md:rounded-[8px] font-bold text-[6px] md:text-[20px] text-white md:mb-0"
          style={{
            background: "linear-gradient(90deg, #FDBB26 25%, #152C24 53%)",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
          }}
        >
          <span className="flex-1 text-center">Why register as an entrepreneur</span>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756410811/Expand_right_1_bpdsxb.png"
            alt="arrow"
            className="md:w-[23px] w-[12px] h-[14px] md:h-[21px] mr-1 md:mr-4"
          />
        </a>
      </div>
   <div className="flex items-center bg-[#F5F5F5] shadow-[#979797] shadow-sm h-10 border-gray-500 border-b-2 rounded-lg md:h-24 w-full mt-4">
      <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750797856/image_3_alrxij.png" alt="Registration Icon" className="ml-4 md:w-20 md:h-20 w-4 h-4" />
      <div className="flex flex-col flex-grow items-center">
      <h1 className="md:text-5xl text-[16px] font-bold text-center w-full">
  {reportSelections.REGION === "-" || !reportSelections.REGION 
    ? "XXXXXXXXXXXXXXXXX" 
    : generateRegistrationNumber({
        COUNTRY: selectedCountry,
        REGION: reportSelections.REGION || "--",
        DISTRICT: reportSelections.DISTRICT || "--", 
        MUNICIPALITY: reportSelections.MUNICIPALITY || "--",
        SMMEs: reportSelections.SMMEs?.value || "--",
        "USER TYPE": typeof reportSelections["USER TYPE"] === 'object' 
          ? reportSelections["USER TYPE"].name 
          : reportSelections["USER TYPE"] || "--",
        selectedType: selectedType // Add this for preview too
      }, selectedCountry)}
</h1>
      </div>
    </div>
        {/* Conditionally render forms based on selectedType */}
        {selectedType === 'farmer' ? (
          <>
            {/* Personal Information Form */}
            <PersonalInfoForm
              formData={formData}
              onFormDataChange={setFormData}
              race={race}
              onRaceChange={setRace}
              gender={gender}
              onGenderChange={setGender}
              disability={disability}
              onDisabilityChange={setDisability}
              onSave={handlePersonalInfoSave}
            />
            
            {/* Person Section */}
            <div className="md:mt-5 mt-4">
  <label className="block font-bold md:mb-1 md:pl-1 mb-1 text-[8px] md:text-[24px] text-black">Person</label>
  <div className="grid grid-cols-2 md:grid-cols-2 gap-1 md:gap-y-5">
    {['Male', 'Female', 'Youth'].map((option) => {
      const isSelected = selectedGenders.includes(option); // Changed to check array inclusion
      
      return (
        <button
          key={option}
          className={`flex items-center justify-between w-full h-6 md:h-[65px] ${
            isSelected ? 'bg-[#F3F3F3]' : 'bg-[#F3F3F3]'
          } border-gray-500 border-b-2 md:border-b-4 rounded-md md:rounded-lg px-4 overflow-hidden`}
          onClick={() => {
            // Toggle this gender selection
            setSelectedGenders(prev => 
              isSelected 
                ? prev.filter(g => g !== option) 
                : [...prev, option]
            );
          }}
        >
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-2 md:gap-28">
              <span className="font-medium text-[8px] md:text-2xl">{option}</span>
            </div>
            
            <div className="flex items-center">
              <span className={`md:w-14 md:h-14 h-5 w-5 rounded-full ${
                isSelected ? 'bg-[#152C24] md:border-4 border-2 border-white' : 'md:border-4 border-2 border-white bg-gray-300'
              }`} />
            </div>
          </div>
        </button>
      );
    })}

    {/* Disability Dropdown (unchanged) */}
    <div className="relative">
      <button
          className={`flex items-center justify-between w-full h-6 md:h-[65px] relative bg-[#F5F5F5] border-gray-500 border-b-2 md:border-b-4 rounded-sm md:rounded-lg px-4 overflow-hidden`}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        <div className="absolute left-0 top-0 bottom-0 w-[100px] md:w-[370px] rounded-l-md md:rounded-r-lg bg-[#D9D9D9] z-0"></div>
        <div className="absolute right-0 top-0 bottom-0 md:w-[35%] rounded-l-md md:rounded-r-lg bg-[#F5F5F5] z-0"></div>
        
        <div className="flex items-center justify-between w-full relative z-10">
          <div className="flex items-center gap-2 md:gap-8">
            <span className="font-medium text-[8px] md:text-2xl">
                {disabilities.length > 0 ? disabilities.join(", ") : "Disability"}
            </span>
            <img 
              src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754854035/Expand_down_2_htv2di.png" 
              alt="dropdown"
              className={`w-2 h-2 md:w-6 md:h-6 transition-transform ${isDropdownOpen ? 'transform rotate-180' : ''}`}
            />
          </div>
          
          <div className="flex items-center">
            <span className={`md:w-14 md:h-14 h-5 w-5 rounded-full ${
              disabilities.length > 0 ? 'bg-gray-800 md:border-4 border-2 border-white' : 'md:border-4 border-2 border-white bg-gray-300'
            }`} />
          </div>
        </div>
      </button>

      <AnimatePresence>
        {isDropdownOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full mt-1 left-0 md:w-72 w-full border border-[#979797]/80 bg-[#152C24] rounded shadow-lg md:max-h-[800px] flex flex-col"
            style={{ zIndex: 1000 }}
          >
            <div className="custom-scroll-area">
              <div className="custom-scroll-content" ref={contentRef} onScroll={handleScroll}>
                <div className="flex justify-end items-end md:px-3 px-1">
                  <img
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1755000024/Export_light_3_h1yrpw.png"
                    alt="icon"
                    className="md:w-[30px] md:h-[30px] h-[8px] w-[8px] cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsDropdownOpen(false);
                    }}
                  />
                </div>
                <ul className="md:px-2">
                  {dropdownOptions.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        const newDisabilities = disabilities.includes(item)
                          ? disabilities.filter(d => d !== item)
                          : [...disabilities, item];
                        
                        setDisabilities(newDisabilities);
                      }}
                      className="flex justify-between items-center px-[3px] md:px-3 py-1 md:py-2 rounded-md cursor-pointer relative"
                    >
                      <span className="text-white text-[4px] md:text-[14px] flex-1 mr-2 font-bold whitespace-normal break-words">
                        {item}
                      </span>
                      <div className="flex items-center">
                        {disabilities.includes(item) ? <SelectedIcon /> : <UnselectedIcon />}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="custom-scroll-track" onClick={handleTrackClick}>
                <div className="scroll-arrow up" onClick={handleScrollUp}>
                  <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 6.5L6.5 1L12 6.5" stroke="#000" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div
                  ref={thumbRef}
                  className="custom-scroll-thumb"
                  style={{
                    height: `${thumbHeight}px`,
                    top: `${scrollTop + 20}px`,
                  }}
                  onMouseDown={handleThumbMouseDown}
                ></div>
                <div className="scroll-arrow down" onClick={handleScrollDown}>
                  <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.5L6.5 7L12 1.5" stroke="#000" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  </div>
</div>
          </>
        ) : (
          /* Organization Form */
          <OrganizationForm0
  formData={formData}
  onFormDataChange={setFormData}
  orgFormData={orgFormData}
  onOrgFormDataChange={setOrgFormData}
  race={race}
  onRaceChange={setRace}
  gender={gender}
  onGenderChange={setGender}
  disability={disability}
  onDisabilityChange={setDisability}
  onSave={handlePersonalInfoSave}
/>
        )}

          <div>
          <div className="flex gap-1 md:gap-4 items-center justify-center mt-3 md:mt-5">
      <div
        className="md:w-16 md:h-16 w-6 h-5 rounded-md bg-gray-300 flex items-center justify-center cursor-pointer"
        onClick={() => {
          setAgreed((prev) => !prev);
          setShowAgreementError(false);
        }}
        tabIndex={0}
        aria-pressed={agreed}
        aria-label="Confirm terms and conditions"
      >
        {agreed ? (
          <svg viewBox="0 0 54 54" fill="none" className="w-4 h-4 md:w-14 md:h-14 transition-all" xmlns="http://www.w3.org/2000/svg">
            <circle cx="27" cy="27" r="27" fill="#152C24" />
            <path d="M39 21L24.75 35L15 25.4545" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ) : (
          <svg viewBox="0 0 54 54" fill="none" className="w-4 h-4 md:w-14 md:h-14 transition-all" xmlns="http://www.w3.org/2000/svg">
            <circle cx="27" cy="27" r="27" fill="#222" />
            <path d="M39 21L24.75 35L15 25.4545" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </div>
      <p className="md:text-2xl text-[6px]">
        By clicking i confirm that i agree with {" "}
        <a className="underline hover:text-gray-800" href="/TermsAndCondition">| Terms of Use{" "}</a>
        <a className="underline hover:text-gray-800" href="/PrivacyPolicy">| Privacy {" "}</a>
        <a className="underline hover:text-gray-800" href="/PrivacyPolicy">| Contact |{" "}</a>
        © 2025 Farmnet
        <p className={`md:text-sm text-[6px] ${agreed ? "text-white hidden" : "text-red-600 cursor-not-allowed"}`}>
          Please agree to the terms and conditions to proceed.
        </p>
      </p>
    </div>
  
    {/* Register Button */}
    <div className="flex justify-center mb-2">
      <div className="relative">
        <button 
          className={`relative bg-[#152C24] w-[200px] md:w-[620px] h-[25px] md:h-[71px] mt-1 md:mt-5   text-[#FDBD26] font-bold px-2 py-1 md:py-2.5 md:rounded-br-[10px] md:rounded-bl-[10px] rounded-md text-[7px] md:text-[30px] flex items-center justify-center ${
            agreed ? "bg-[#152C24] text-white" : "bg-[#CFD7D7] text-white cursor-not-allowed"
          }`}
          disabled={!agreed}
          onClick={handleRegister}
        >
          <span>Click to register</span>
        </button>
        
        <img 
          src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754855134/image_1804_usbobp.png" 
          alt="Register icon"
          className="absolute right-0 top-[61%] transform -translate-y-1/2 w-[22px] h-[22px] md:w-[95px] md:h-[95px] object-contain"
          style={{ right: '-2px', '@media (max-width: 767px)': { right: '-1px', width: '22px', height: '22px' } }}
        />
      </div>
    </div>
  
    <p className="text-[8px] md:text-2xl italic text-black md:mb-4 mb-2 mt-5 text-center">
      "When you register as a enterpreneur, you will be assigned a unique User ID number. Please check your email to confirm that you have received it."
    </p>
    <div className="flex justify-end items-center gap-4 md:mt-24 " onClick={() => setIsEnterpriseEditing(!isEnterpriseEditing)}
>
      <h1 className="md:text-[24px] text-[8px] text-[#919291] italic">{isEnterpriseEditing ? "Save" : "Edit"}</h1>
      
      <img src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758363740/Edit_fill_2_e8uyib.png" alt="icon" className="md:w-[30px] md:h-[30px] h-[12px] w-[12px] "/>
    </div>
    <h2 className="md:text-4xl  text-[10px] font-bold underline text-center md:mt-2 mb-4 ">Section 2 : Complete your registration</h2>
  
    <p className="md:text-2xl text-[8px] italic font-normal mb-2 md:mb-8 ">
      "Complete your registration to create a profile that enhances your business visibility, 
      grants access to support, and helps you effectively market your products or services. 
      Providing complete and accurate information ensures you're found more quickly."
    </p>
    <h3 className="md:text-4xl text-[10px] font-bold mb-2 md:mb-4">About your Enterprise</h3>
  <div >
  
  <div 
    className="bg-[#F5F5F5] md:h-64 h-16 w-full rounded-md flex items-center p-1 md:p-6 mb-1 md:mb-4 cursor-text"
    onClick={() => isEnterpriseEditing && setIsEditingAbout(true)}
  >
    {isEditingAbout || isEnterpriseEditing ? (
      <textarea
        className="md:text-2xl text-[6px] font-normal w-full h-full bg-transparent  outline-none focus:ring-0  border-none focus:outline-none resize-none"
        value={aboutText}
        onChange={(e) => setAboutText(e.target.value)}
        onBlur={() => {
          setIsEditingAbout(false);
          if (!isEnterpriseEditing) setIsEnterpriseEditing(false);
        }}
        autoFocus={isEnterpriseEditing}
      />
    ) : (
      <p className="md:text-2xl text-[6px] font-normal w-full text-[#979797]">{aboutText}</p>
    )}
  </div>
  
      
      {/* Placeholder Text */}
      <p className="md:text-2xl text-[6px] font-normal mb-2 md:mb-8 px-1 md:px-4">Type here to insert information about your enterprise</p>
      
      {/* Tagline Section */}
      <h3 className="md:text-4xl text-[6px] font-bold mb-2">Tagline</h3>
  <div 
    className="bg-[#F5F5F5] h-5 md:h-20 w-full rounded-md flex items-center p-2 md:p-6 cursor-text"
    onClick={() => isEnterpriseEditing && setIsEditingTagline(true)}
  >
    {isEditingTagline || isEnterpriseEditing ? (
      <input
        type="text"
        className="md:text-2xl text-[6px] font-normal w-full bg-transparent border-none outline-none focus:ring-0 focus:outline-none border-none"
        value={tagline}
        onChange={(e) => setTagline(e.target.value)}
        onBlur={() => {
          setIsEditingTagline(false);
          if (!isEnterpriseEditing) setIsEnterpriseEditing(false);
        }}
        autoFocus={isEnterpriseEditing}
      />
    ) : (
      <p className="md:text-2xl text-[6px] font-normal w-full">{tagline}</p>
    )}
  </div>
  </div>



          </div>
       
          {activeSection === 'products' ? (
  <>
 {/* Always show the dropdown but conditionally render content based on selection */}
<div className="w-full mt-1">
  <div className="flex justify-between items-center">
    <ProductsDropdown
      label="PRODUCTS"
      items={["PRODUCTS", "SERVICES"]}
      selectedItem={selectedProduct}
      onChange={(product) => setSelectedProduct(product)}
    />
    <h1 className="md:text-[24px] font-normal text-[6px]">
      Add your product or services now to get seen by customers on the online marketplace
    </h1>
  </div>
  
  {/* Render based on selected product type */}
  {selectedProduct === "SERVICES" ? (
    <div>
      <ServicesSection
        services={services}
        onServicesChange={setServices}
        username={formData.username}
      />
      <div className="flex justify-end items-end">
  <SaveButtonWithModal
    onSave={async () => {
      try {
        await handleSaveServices();
        return true;
      } catch (error) {
        console.error("Error saving services:", error);
        return false;
      }
    }}
    buttonText="Save Services"
    buttonClassName="flex items-center justify-center gap-2 h-[15px] md:h-[44px] md:text-[24px] text-[6px] font-normal italic rounded-[5px] mt-4"
    iconSrc="https://res.cloudinary.com/dzngpgki4/image/upload/v1750801615/Import_lll7wj.png"
    iconClassName="md:w-8 md:h-8 h-3 w-3"
  />
</div>
    </div>
  ) : (
    // Default to PRODUCTS view
    <div>
      <ProductImagesSection
        products={products}
        onProductsChange={setProducts}
        username={formData.username}
      />
   <div className="flex justify-end items-end">
  <SaveButtonWithModal
    onSave={async () => {
      try {
        const userIdentifier = formData.username || formData.email;
        const results = await saveAllProducts(userIdentifier);
        
        if (results.some(r => r.success)) {
          console.log("Products saved successfully to Firebase");
          return true; // Return true for success
        }
        return false; // Return false for failure
      } catch (error) {
        console.error("Error saving products:", error);
        return false; // Return false for failure
      }
    }}
    buttonText="Save Products"
    buttonClassName="flex items-center justify-center gap-2 h-[15px] md:h-[44px] md:text-[24px] text-[6px] font-normal italic rounded-[5px] mt-4"
    iconSrc="https://res.cloudinary.com/dzngpgki4/image/upload/v1750801615/Import_lll7wj.png"
    iconClassName="md:w-8 md:h-8 h-3 w-3"
  />
</div>
    </div>
  )}
</div>
  </>
) : (
  <>
    <div className="w-full mt-4">
      <ProductsDropdown
        label="-"
        items={["SERVICES","PRODUCTS"]}
        selectedItem={selectedProduct}
        onChange={(product) => setSelectedProduct(product)}
      />
           {selectedProduct === "PRODUCTS" ? (
      
         <ProductImagesSection
          products={products}
          onProductsChange={setProducts}
          username={formData.username}
        />
      ) : (
        <>
    <BakeSection
      bakes={bakes}
      onBakesChange={setBakes}
      username={formData.username}
    />
<div className="flex justify-end items-end">
  <SaveButtonWithModal
    onSave={async () => {
      try {
        await handleSaveBakes();
        return true;
      } catch (error) {
        console.error("Error saving bakes:", error);
        return false;
      }
    }}
    buttonText="Save Bakes"
    buttonClassName="flex items-center justify-center gap-2 h-[15px] md:h-[44px] md:text-[24px] text-[6px] font-normal italic rounded-[5px] mt-4"
    iconSrc="https://res.cloudinary.com/dzngpgki4/image/upload/v1750801615/Import_lll7wj.png"
    iconClassName="md:w-8 md:h-8 h-3 w-3"
  />
</div>
  </>
      )}
      
    </div>
  </>
)}
<div className="w-full flex flex-col gap-4 mt-6 mb-2 md:mb-12">
  {/* Dropdown */}
  <div className="mt-4 flex justify-between items-center">
      <PromoDropdown
        label="-"
        items={["ADVERTISEMENT", "PROMOTION"]}
        onChange={handlePromotionSelect}
      />
      <h1 className="md:text-[24px] font-normal text-[6px]">
        Add your product or services now to get seen by customers on the online marketplace
      </h1>
  </div>
  
  {/* Conditional rendering based on selected promotion type */}
  {selectedPromotionType === "ADVERTISEMENT" ? (
  <div className="grid grid-cols-2 md:grid-cols-2 gap-2 md:gap-x-10">
    {advertisementCards.map((card, index) => (
      <AdvertisementCard 
        key={index}
        initialData={card}
        onSave={(newData) => handleAdvertisementCardSave(index, newData)}
        index={index}
      />
    ))}
  </div>
) : selectedPromotionType === "PROMOTION" ? (
  <div className="grid grid-cols-2 md:grid-cols-2 gap-2 md:gap-x-10">
    {promoCards.map((card, index) => (
      <PromotionCard 
        key={index}
        initialData={card}
        onSave={(newData) => handlePromoCardSave(index, newData)}
        index={index}
      />
    ))}
  </div>
) : (
  <div className="grid grid-cols-2 md:grid-cols-2 gap-2 md:gap-x-10">
    {promoCards.map((card, index) => (
      <PromotionCard 
        key={index}
        initialData={card}
        onSave={(newData) => handlePromoCardSave(index, newData)}
        index={index}
      />
    ))}
  </div>
)}
</div>

<div className="flex justify-end mt-2">
  <SaveButtonWithModal
    onSave={async () => {
      try {
        await handleSaveMarketingClick();
        return true;
      } catch (error) {
        console.error("Error saving marketing data:", error);
        return false;
      }
    }}
    buttonText={isSavingMarketing ? "Saving..." : "Save"}
    buttonClassName="flex items-center justify-center gap-2 h-[15px] md:h-[44px] md:text-[24px] text-[6px] font-normal italic rounded-[5px] mt-2"
    iconSrc="https://res.cloudinary.com/dzngpgki4/image/upload/v1750801615/Import_lll7wj.png"
    iconClassName="md:w-8 md:h-8 h-3 w-3"
    disabled={isSavingMarketing}
  />
</div>

      <BackgroundInfoSection
languages={languages}
languages1={languages1}
selected={landData.type1?.type}
setSelected={(type) => setLandData(prev => ({
...prev,
type1: { ...prev.type1, type }
}))}
selected1={landData.type2?.type}
setSelected1={(type) => setLandData(prev => ({
...prev,
type2: { ...prev.type2, type }
}))}
erfNumber={landData.erfNumber}
setErfNumber={(number) => setLandData(prev => ({
...prev,
erfNumber: number
}))}
onSave={(data) => {
console.log("Land data saved:", data);
setLandData(data);
}}
showError={showBackgroundError}
/>

      <div className="w-full  d:mt-4">
  <DocumentDropdown
    items={[
      "Awards",
      "Account Resolution",
      "Bank Account",
      "B-BBEE- Affidavit/Certificate",
      "Business Insurance",
      "Business Plan & Financial Records",
      "Business registration",
      "Certified ID",
      "Company profile",
      "COOP /PTY LTD",
      "Drivers License",
      "Environmental Impact assessment (EIA)",
      "GAP certificate"
    ]}
    onChange={handleDocumentSelect}
  />
  <div className="flex items-center justify-between">
  <h3 className="md:text-[20px] text-[6px] font-normal md:mb-2 mt-1 md:mt-2">click to Insert Business documents</h3>
<div className="flex items-center gap-2 md:gap-6 cursor-pointer" >
<h3 className="md:text-[20px] text-[6px] font-normal md:mb-2 mt-1 md:mt-2">click to Insert title of Business documents</h3>

<img src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758044480/Edit_fill_1_lzydue.png" alt="icon" className="md:w-[24px] w-[12px] h-[12px] md:h-[24px] "/>
</div>
  </div>
  
</div>



<div className="flex md:gap-4 gap-1 mt-2 md:mt-6 w-full">
  {certificatesUrls.map((cert, index) => (
    <div key={index} className="flex flex-col items-start flex-1 min-w-0 relative">
      {/* Hidden file input */}
      <input
        type="file"
        ref={el => (fileInputRefs.current[index] = el)}
        onChange={async (e) => {
          const file = e.target.files[0];
          if (file) {
            await uploadDocumentImage(file, index);
          }
        }}
        accept="image/*"
        className="hidden"
      />
      
      {/* Title */}
      <div className="flex items-center w-full justify-between px-1 md:px-2">
        {isEditingTitle === index ? (
          <input
            type="text"
            value={cert.title}
            onChange={(e) => {
              setCertificatesUrls(prev => {
                const updated = [...prev];
                updated[index].title = e.target.value;
                return updated;
              });
            }}
            onBlur={() => setIsEditingTitle(null)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') setIsEditingTitle(null);
            }}
            autoFocus
            className="text-[6px] md:text-[24px] font-normal italic bg-transparent border-b border-gray-500 outline-none w-full"
          />
        ) : (
          <h3 
            className="text-[6px] md:text-[24px] font-normal italic truncate cursor-pointer"
            onClick={() => setIsEditingTitle(index)}
          >
            {cert.title}
          </h3>
        )}
      </div>

      {/* Image Box */}
      <div className="w-full h-[110px] md:h-[430px] rounded-[2px] overflow-hidden flex items-center justify-center mt-2 relative" 
           style={{ backgroundColor: "#D9D9D9" }}>
        {cert.previewUrl || cert.url ? (
          <>
            <img 
              src={cert.previewUrl || cert.url} 
              alt={cert.title} 
              className="w-full h-full object-cover" 
            />
            {/* Delete image button */}
            <div className="absolute bottom-2 right-2 cursor-pointer">
              <img 
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1755036349/Trash_tbotcz.png" 
                alt="Delete" 
                className="md:w-[25px] w-[10px] h-[10px] md:h-[25px] hover:opacity-80 transition-opacity"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteCertificate(index);
                }}
              />
            </div>
            <div className="absolute top-2 right-2 cursor-pointer">
              <img 
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1755036348/Add_square_duotone_dx64ak.png" 
                alt="Add" 
                className="md:w-[45px] h-[8px] w-[8px] md:h-[45px] hover:opacity-80 transition-opacity"
                onClick={() => fileInputRefs.current[index].click()}
              />
            </div>
          </>
        ) : (
          <>
            <span className="text-gray-500"></span>
            <div className="absolute bottom-2 right-2 cursor-pointer">
              <img 
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1755036349/Trash_tbotcz.png" 
                alt="Delete" 
                className="md:w-[25px] h-[10px]  w-[10px] md:h-[25px] hover:opacity-80 transition-opacity"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteCertificate(index);
                }}
              />
            </div>
            {/* Add image button */}
            <div className="absolute top-2 right-2 cursor-pointer">
              <img 
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1755036348/Add_square_duotone_dx64ak.png" 
                alt="Add" 
                className="md:w-[45px] h-[8px] w-[8px] md:h-[45px]  hover:opacity-80 transition-opacity"
                onClick={() => fileInputRefs.current[index].click()}
              />
            </div>
          </>
        )}
      </div>
    </div>
  ))}
</div>

{/* Add a save button */}
<SaveButtonWithModal
  onSave={async () => {
    try {
      await saveDocumentsToFirebase();
      return true;
    } catch (error) {
      console.error("Error saving documents:", error);
      return false;
    }
  }}
  buttonText="Save Documents"
  buttonClassName="flex items-center justify-center gap-2 h-[15px] md:h-[44px] md:text-[24px] text-[6px] font-normal italic rounded-[5px] mt-4"
  iconSrc="https://res.cloudinary.com/dzngpgki4/image/upload/v1750801615/Import_lll7wj.png"
  iconClassName="md:w-8 md:h-8 h-3 w-3"
/>




          <div>
          <div className="md:mt-5 mt-2  w-full md:h-[88px] h-[40px] flex items-center justify-between  bg-[#152C24]  rounded-[10px] relative">
  {/* Left placeholder for spacing - removed absolute positioning */}

  {/* Centered Text - now using flex-grow and text-center */}
    <h3 className="font-bold text-white text-[6px] md:text-[32px] md:px-2">
    COOPERATIVES | COMMUNITIES | GROUPS | ASSOCIATIONS
    </h3>

  {/* Right Box - Toggle Button */}
  <div 
    className="md:w-[154px] md:h-[88px] w-[80px] h-[40px] bg-[#D9D9D9] rounded-r-[10px] flex items-center justify-center border-b border-black cursor-pointer flex-shrink-0"
    onClick={() => setShowMembershipSections(!showMembershipSections)}
  >
    <img
      src={`https://res.cloudinary.com/dzngpgki4/image/upload/${showMembershipSections ? 'v1748785688/Expand_down_yilqh4.png' : 'v1748785688/Expand_down_yilqh4.png'}`}
      alt="expand icon"
      className="md:w-12 md:h-12 w-4 h-4"
    />
  </div>
</div>
{showMembershipSections && (
  <>
  <MembershipSection
  selectedMemberships={membershipData.selected}
  membershipData={membershipData} // Pass the full object
  setSelectedMemberships={(selected) => 
    setMembershipData(prev => ({ ...prev, selected }))
  }
  customInputBoxes={membershipData.customInputBoxes}
  setCustomInputBoxes={(customInputBoxes) => 
    setMembershipData(prev => ({ ...prev, customInputBoxes }))
  }

onSave={(data) => {
  handleMembershipSave({
    ...data,
    organizationName: data.organizationName || '',
    membershipNumber: data.membershipNumber || '',
    membershipType: data.membershipType || '',
    membershipDate: data.membershipDate || ''
  });
}}
/>
</>
)}
<AreasFocus
  selectedAreas={groupExperience}
  onAreasChange={setGroupExperience}
  onSave={handleGroupExperienceSave}
/>
<div 
        className="w-full md:h-[88px] h-[40px] flex items-center justify-between  bg-[#152C24] rounded-b-[1px] rounded-[10px] md:mt-7 mt-3 relative cursor-pointer"
        onClick={toggleExpand}
      >
        <div className="md:w-[140px] md:h-[40px] "></div>
        <div className="absolute md:text-[32px] text-left text-white text-[8px] font-bold px-4">
        INDUSTRY ACTIVITY SURVEY
        </div>
        <div className="md:w-[154px] md:h-[88px]  h-[40px] w-[80px] bg-[#D9D9D9] rounded-br-[10px] flex items-center justify-center">
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748785688/Expand_down_yilqh4.png"
            alt="expand icon"
            className={`md:w-12 md:h-12 w-3 h-3 transition-transform duration-200 ${
              isExpanded ? 'transform rotate-180' : ''
            }`}
          />
        </div>
      </div>

{isExpanded && (
<>
<IndustrySection
selected={selectedChallenges}
setSelected={setSelectedChallenges}
vision={vision}
setVision={setVision}
onSave={(data) => {
    console.log("Industry data saved:", data);
    setSelectedChallenges(data.selectedChallenges);
    setVision(data.vision);
}}
/>

{/* Location Section */}
<SaveButtonWithModal />

</>
)}
<Data
  selectedExperience={dataPermissions}
  setSelectedExperience={setDataPermissions}
  onSave={(data) => {
    console.log("Data Permissions:", data);
    setDataPermissions(data.selectedExperience);
  }}
/>
<div className="mt-2 md:mt-8 mb-1">
  <div className="flex items-center justify-between mb-2">
    {/* Referral Checkbox - Half Width */}
    <div className="w-1/2">
      <button
        className={`
          flex items-center justify-between
          bg-[#F5F5F5]
          border border-[#F5F5F5] rounded-l-[5px]
          md:px-4 px-2
          md:h-[80px] h-[20px]
          w-full
          cursor-pointer
        `}
        onClick={() => {
          // Toggle referral code usage
          if (referralCodeInput) {
            setReferralCodeInput("");
          }
        }}
      >
        <span className="text-[4px] md:text-[20px] font-bold leading-[1.10]">
          Referral
        </span>
        <span
          className={`
            md:w-14 md:h-14 w-3 h-3 rounded-full flex-shrink-0
            ${referralCodeInput ? "bg-[#152C24] md:border-[6px] border-[3px] border-white" : "bg-gray-300 md:border-[6px] border-[3px] border-white"}
          `}
        />
      </button>
      <p className="md:text-[20px] text-[6px] text-white font-medium italic mt-1">
        Enter referral code if applicable
      </p>
    </div>
    
    {/* Input Field - Half Width */}
    <div className="w-1/2">
      <input
        type="text"
        value={referralCodeInput}
        onChange={(e) => setReferralCodeInput(e.target.value)}
        className={`
          w-full bg-[#152C24] placeholder-white text-white 
          md:text-[24px] text-[6px] font-normal rounded-r-[5px] 
          md:py-2 py-1 md:h-[80px] h-[20px] md:px-4 px-2
        `}
        placeholder="XXXXXXXXX"
      />
      <p className="md:text-[20px] text-[6px] font-medium italic mt-1">
        Enter unique user number of person referring you
      </p>
    </div>
  </div>
</div>
<div className="md:mt-3 flex items-center space-x-3">
<img
  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744662306/image_1570_pnbwi8.png"
  alt=".."
  className="md:w-[37px] w-[17px] h-[17px] md:h-[37px]"
/>
<h1 className="md:text-[36px] text-[10px] font-bold">
  Set Location
</h1>
</div>
<div className="h-auto w-full rounded-md mt-3">
<LocationPicker onSaveLocation={handleSaveLocation} />
</div>
                  <div>
                      {/* Checkbox Box */}
           
                      <div className="flex gap-4 items-center mt-5">
                          <div
                              className="md:w-16 md:h-[63px] w-6 h-[30px] rounded-[5px] bg-[#D9D9D9] flex items-center justify-center cursor-pointer transition"
                              onClick={() => {
                                  setAgreed((prev) => !prev);
                                  setShowAgreementError(false); // Clear error when checkbox is clicked
                              }}
                              tabIndex={0}
                              aria-pressed={agreed}
                              aria-label="Confirm terms and conditions">
                              {/* Black or Green Check Round Fill SVG */}
                              {agreed ? (
                                  // GREEN CHECK ROUND FILL
                                  <svg
                                      width="54"
                                      height="54"
                                      viewBox="0 0 54 54"
                                      fill="none"
                                      className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle
                                          cx="27"
                                          cy="27"
                                          r="27"
                                          fill="#152C24"
                                      />
                                      <path
                                          d="M39 21L24.75 35L15 25.4545"
                                          stroke="white"
                                          strokeWidth="4"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                      />
                                  </svg>
                              ) : (
                                  // BLACK CHECK ROUND FILL
                                  <svg
                                      width="54"
                                      height="54"
                                      viewBox="0 0 54 54"
                                      fill="none"
                                      className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <circle
                                          cx="27"
                                          cy="27"
                                          r="27"
                                          fill="#222"
                                      />
                                      <path
                                          d="M39 21L24.75 35L15 25.4545"
                                          stroke="white"
                                          strokeWidth="4"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                      />
                                  </svg>
                              )}
                          </div>
                          <p className="md:text-[20px] text-[6px]">
                              By ticking I confirm that I agree with the{" "}
                              <a
                                  className="underline hover:text-[#152C24]"
                                  href="/TermsAndCondition">
                                  Terms and conditions
                              </a>
                              ,<a href="/DataPolicy"     className="underline hover:text-[#152C24]">Data </a>and{" "}
                              <a
                                  className="underline hover:text-[#152C24]"
                                  href="/PrivacyPolicy">
                                  Privacy policy
                              </a>
                              .
                                 <p
                          className={`md:text-[14px] text-[10px] ${
                              agreed
                                  ? "text-white hidden "
                                  : " text-red-600 cursor-not-allowed"
                          }`}>
                          Please agree to the terms and conditions before
                          proceeding.
                      </p>
                          </p>

                   

                      {/* Text */}
                  </div>
           
              </div>
    {/* Registration Button */}
{/* Registration Button */}
<div className="flex justify-center">
  <button 
    className={`relative w-[200px] md:w-[560px] mt-1 md:mt-5 shadow-md shadow-gray-900 md:border-b-[5px] border-b-[3px] font-bold px-2 py-1 md:py-2.5 md:rounded-br-[10px] md:rounded-bl-[10px] rounded-md text-[7px] md:text-[30px] text-center
      ${
        !agreed
          ? "bg-gray-400 text-gray-200 border-gray-300 cursor-not-allowed"
          : isLoggedIn
            ? "bg-[#2E453D] text-white border-[#152C24] hover:bg-[#3a5a50]"
            : "bg-[#152C24] text-[#FDBD26] border-[#FDBD26] hover:bg-[#1b4a46]"
      }`}
    onClick={handleRegisterClick}
    disabled={!agreed || loading}
  >
    <span className="block text-center">
      {loading 
        ? "Processing..." 
        : isLoggedIn 
          ? "Update Registration" 
          : "Complete Registration"}
    </span>
  </button>
</div>
<div className="md:p-2 md:py-6 md:border-b-2  border-b-[1px] md:mb-6 mb-2 border-[#979797] mt-2 md:mt-5"> 
<p className="md:text-[24px] font-normal text-[6px]">  <p className="md:text-[24px] font-normal text-[6px]"><span className="text-red-500">*</span>After completing your registration, you may download your registration document to view and share it as needed</p>
</p>

</div>
              {/* Register Button */}
              {/* Register Button */}
          
<div  className="flex justify-between items-center">
<div className="flex flex-col   ">
                          {/* Buttons */}
                          <div className="flex md:gap-4 gap-1   mt-2">

                           {/* Save Button */}
                           <div>
                                  {/* Save Button */}
                                  {/* Delete Button */}
<div>
<button
  className="flex items-center justify-between w-[60px] md:w-[190px] h-[15px] md:h-[44px] bg-[#FDBB26] text-white md:text-[14px] text-[6px] font-bold rounded-[5px] px-1 md:px-4"
  onClick={() => setIsDeleteModalOpen(true)}>
  <span>DELETE</span>
  <img 
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748279697/Trash_1_afo0yz.png" 
      alt="Delete" 
      className="md:w-[30px] h-[6px] md:h-[30px] w-[6px]"
  />
</button>
<p className="md:text-[14px] text-[6px] mt-1 font-normal md:px-1">
  Delete registration 
</p>
</div>

                                  {/* Save Confirmation Modal */}
                                 {/* Delete Confirmation Modal */}
                                 <Modal
  isOpen={isDeleteModalOpen}
  onRequestClose={() => setIsDeleteModalOpen(false)}
  contentLabel="Delete Confirmation"
  className="modal-content"
  overlayClassName="modal-overlay"
>
  <AnimatePresence>
    {isDeleting ? (
      // Animation sequence
      <motion.div
        key="animation"
        className="fixed inset-0 flex items-center justify-center z-50"
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ 
            scale: [0.5, 1.5, 2, 0.5],
            opacity: [0, 1, 1, 0],
            y: [0, -50, 100, 0]
          }}
          transition={{ 
            duration: 1.5,
            ease: "easeInOut",
            times: [0, 0.3, 0.8, 1]
          }}
          className="text-center"
        >
          <svg
            width="120"
            height="120"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <motion.path
              d="M3 6H5H21"
              stroke="#152C24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.5 }}
            />
            <motion.path
              d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
              stroke="#152C24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ 
                duration: 0.8,
                delay: 0.3
              }}
            />
            <motion.path
              d="M10 11V17"
              stroke="#152C24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
            />
            <motion.path
              d="M14 11V17"
              stroke="#152C24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.9 }}
            />
          </svg>
          
          <motion.p
            className="mt-4 text-xl font-bold"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.9 }}
          >
            Data Deleted!
          </motion.p>
        </motion.div>
      </motion.div>
    ) : (
      // Original delete confirmation content
      <div key="confirmation">
        <button
          onClick={() => setIsDeleteModalOpen(false)}
          className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
          aria-label="Close"
        >
          &times;
        </button>
        <div>
          <div className="relative bg-white p-0 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[430px]">
            <div className="flex flex-col items-center justify-center text-center w-[300px] h-full md:w-full">
              <div className="relative mb-4 w-full flex justify-center items-center">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748279697/Trash_1_afo0yz.png"
                  alt="Delete"
                  className="w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                />
              </div>
              <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                Confirm Deletion
              </div>
              <p className="text-black text-[10px] md:text-[32px] mb-2">
                Are you sure you want to delete this registration?
              </p>
              <p className="text-black text-[10px] md:text-[24px] mb-6">
                This action cannot be undone.
              </p>
              <div className="flex gap-4 w-full justify-center">
                <button
                  onClick={() => setIsDeleteModalOpen(false)}
                  className="bg-gray-300 hover:bg-gray-400 text-[12px] md:text-[32px] text-black w-[130px] md:w-[300px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setIsDeleting(true);
                    setTimeout(() => {
                      clearAllFormData();
                      setIsDeleteModalOpen(false);
                      setIsDeleting(false);
                    }, 2000); // Match this with animation duration
                  }}
                  className="bg-red-500 hover:bg-red-600 text-[12px] md:text-[32px] text-white w-[130px] md:w-[300px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  </AnimatePresence>
</Modal>
  </div>

                                  {/* Registration Confirmation Modal */}
                                  {isModalOpen && (
  <>
    {showCelebration ? (
      <CelebrationAnimation
        onComplete={() => {
          setShowCelebration(false);
          setIsModalOpen(false);
        }}
        registrationNumber={registrationNumber}
      />
    ) : (
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel={isLoggedIn ? "Update Successful" : "Registration Successful"}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <button
          onClick={() => setIsModalOpen(false)}
          className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
          aria-label="Close"
        >
          &times;
        </button>
        <div>
          <div className="relative bg-white p-4 md:pt-5 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[400px]">
            <div className="flex flex-col items-center justify-center text-center h-full w-full">
              <div className="relative mb-4 w-full flex justify-center items-center">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
                  alt="Success"
                  className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                />
                <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                  {isLoggedIn ? "Update Successful" : "Registration Successful"}
                </div>
              </div>
              <p className="text-black text-[10px] md:text-[32px] mb-2">
                {isLoggedIn
                  ? "Your details have been updated successfully!"
                  : `Thank you for registering with Farmnet`}
              </p>
              {!isLoggedIn && (
                <>
                  <p className="text-black text-[10px] md:text-[32px] mb-4">
                    Your unique registration number is:
                  </p>
                  <div className="flex items-center justify-between w-full mb-4 md:px-10">
                    <div className="flex-1 flex justify-center">
                      <span className="text-[12px] md:text-[36px] font-bold text-center tracking-wide">
                        {registrationNumber}
                      </span>
                    </div>
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(registrationNumber);
                        setCopyMessage("Copied!");
                        setTimeout(() => setCopyMessage(""), 2000);
                      }}
                      className="bg-[#EEB527] hover:bg-orange-600 text-white font-light text-[10px] md:text-[32px] md:w-[140px] md:h-[60px] px-4 py-2 rounded-[10px]"
                    >
                      Copy
                    </button>
                  </div>
                </>
              )}
              {copyMessage && (
                <div className="text-black text-[14px] md:text-[18px] font-semibold">
                  {copyMessage}
                </div>
              )}
              <a href="/">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="bg-[#152C24] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[700px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold"
                >
                  Continue to Home
                </button>
              </a>
            </div>
          </div>
        </div>
      </Modal>
    )}
  </>
)}
                              {/* Edit Button */}
                              <div>
                                  <button
                                      className="flex items-center justify-between md:w-[190px] w-[60px] md:h-[44px] h-[15px] bg-[#2E453D] text-white md:text-[14px] md:px-4 px-1 text-[6px] font-bold rounded-[5px]"
                                      onClick={() =>
                                          setIsEditModalOpen(true)
                                      }>
                                      <span>EDIT</span>
                                      <img
                                          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
                                          alt="Edit Icon"
                                          className="md:w-[30px] h-2  md:h-[30px] w-2"
                                      />
                                  </button>

                                  <p className="md:text-[14px] text-[6px]  mt-1 font-normal md:px-1 ">
                                      Edit registration form
                                  </p>
                                  <Modal
  isOpen={isEditModalOpen}
  onRequestClose={() => {
    setIsEditModalOpen(false);
    setLoginEmail("");
    setLoginPassword("");
    setLoginError(null);
  }}
  contentLabel="Login to Edit"
  className="modal-content bg-[#E7EBEB] w-[350px] md:w-[800px]"
  overlayClassName="modal-overlay"
>
  {/* Close Button */}
  <button
    onClick={() => {
      setIsEditModalOpen(false);
      setLoginEmail("");
      setLoginPassword("");
      setLoginError(null);
    }}
    className="absolute top-2 right-2 md:top-4 md:right-4 text-black opacity-50 hover:opacity-100 text-[12px] md:text-[30px] font-bold z-50"
    aria-label="Close"
  >
    &times;
  </button>
  
  <div className="flex justify-end"> 
    <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748281140/image_aorywu.png" alt="hi" className="md:w-[120px] md:mt-5 md:h-[22px]"/>
  </div>

  <div className="md:p-4 p-2 md:py-2">
    <h2 className="md:text-[40px] font-extrabold mb-4">
      Farm IT , Digitalize IT!
    </h2>
    <h2 className="md:text-[24px] font-bold mb-2">
    Enter new password
    </h2>
    <h2 className="md:text-[24px] font-normal mb-2">
    Your new password must be different from previously used passwords
    </h2>
    <div>
      <input
        type="email"
        value={loginEmail}
        placeholder="Enter Email address"
        onChange={(e) => setLoginEmail(e.target.value)}
        className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#152C24] focus:bg-[#152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px] md:px-6"
      />
    </div>
    
    <div className="relative md:mt-2">
      <input
        type={showPassword ? "text" : "password"}
        value={loginPassword}
        placeholder="Enter password"
        onChange={(e) => setLoginPassword(e.target.value)}
        className="w-full text-[10px] inner-shadow shadow-black md:text-[20px] bg-[#152C24] focus:bg-[#152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px] md:px-6"
      />
      <button
        type="button"
        onClick={togglePasswordVisibility}
        className="absolute right-3 text-[10px] md:text-[30px] top-[50%] transform -translate-y-1/2 text-[#979797]"
      >
        {showPassword ? <FiEye /> : <FiEyeOff />}
      </button>
    </div>
    
    <p 
      className="md:text-[14px] text-[8px] md:mt-2 mt-1 font-normal cursor-pointer underline"
      onClick={() => {
        setIsForgotPasswordModalOpen(true);
        setForgotPasswordStep(1);
        setForgotPasswordError("");
        setForgotPasswordSuccess("");
        setIsEditModalOpen(false);
        setLoginEmail("");
        setLoginPassword("");
      }}
    >
      Forgot your password?
    </p>
    
    {loginError && (
      <p className="text-red-500 text-sm mt-2">
        {loginError}
      </p>
    )}
    
    {isLoggedIn && (
      <p className="text-green-500 text-sm mt-2">
        Login successful!
      </p>
    )}
    
    <div className="mt-6 flex justify-between gap-3 md:gap-8">
      <button
        onClick={() => {
          setIsEditModalOpen(false);
          setLoginEmail("");
          setLoginPassword("");
          setLoginError(null);
        }}
        className="bg-gray-300 shadow-inner shadow-black/40 font-bold text-black text-[8px] md:text-[20px] w-full px-4 md:py-4 py-2 rounded-md"
      >
        Cancel
      </button>
      <button
        onClick={handleLogin}
        className="bg-[#FDBB26] shadow-inner shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 rounded-md"
      >
        {loading ? "Logging in..." : "Login"}
      </button>
    </div>
  </div>
</Modal>
                              </div>
{/* Forgot Password Modal */}
{/* Forgot Password Modal */}
<Modal
  isOpen={isForgotPasswordModalOpen}
  onRequestClose={() => {
    setIsForgotPasswordModalOpen(false);
    setForgotPasswordStep(1);
    setForgotPasswordError("");
    setForgotPasswordSuccess("");
  }}
  contentLabel="Forgot Password"
  className="modal-content bg-[#E7EBEB] w-full md:w-[600px]"
  overlayClassName="modal-overlay z-[1000]" // Increased z-index
>
  <button
    onClick={() => {
      setIsForgotPasswordModalOpen(false);
      setForgotPasswordStep(1);
      setForgotPasswordError("");
      setForgotPasswordSuccess("");
    }}
    className="absolute top-2 right-2 md:top-4 md:right-4 text-black opacity-50 hover:opacity-100 text-[12px] md:text-[30px] font-bold z-50"
    aria-label="Close"
  >
    &times;
  </button>
  
  <div className="flex justify-end"> 
    <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748281140/image_aorywu.png" alt="hi" className="md:w-[120px] md:mt-10 md:h-[22px]"/>
  </div>
  
  <div className="md:p-4 p-2 md:py-20">
    <h2 className="md:text-[40px] font-extrabold mb-4">
      {forgotPasswordStep === 1 ? "Reset Password" : "Check Your Email"}
    </h2>
    
    {forgotPasswordError && (
      <p className="text-red-500 text-sm mt-2 mb-4">
        {forgotPasswordError}
      </p>
    )}
    
    {forgotPasswordStep === 1 ? (
      <>
        <p className="md:text-[16px] text-[10px] mb-4">
          Enter your registered email address to receive a password reset link
        </p>
        <input
          type="email"
          value={forgotPasswordEmail}
          placeholder="Enter Email Address"
          onChange={(e) => setForgotPasswordEmail(e.target.value)}
          className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#152C24] focus:bg-[152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[35px] md:h-[66px] md:px-6"
        />
        <button
          onClick={handleForgotPassword}
          className="bg-[#FDBB26] shadow-inner shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 py-2 rounded-md"
        >
          Send Reset Link
        </button>
      </>
    ) : (
      <>
        <div className="flex justify-center mb-4">
          <img 
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png" 
            alt="Success" 
            className="w-16 h-16"
          />
        </div>
        <p className="md:text-[16px] text-[10px] mb-6 text-center">
          We've sent a password reset link to <strong>{forgotPasswordEmail}</strong>. 
          Please check your email inbox, including spam folder.
        </p>
        <div className="flex gap-4">
          <button
            onClick={() => {
              setIsForgotPasswordModalOpen(false);
              setIsEditModalOpen(true);
            }}
            className="bg-gray-300 hover:bg-gray-400 text-black font-bold md:text-[20px] text-[8px] flex-1 px-4 md:py-4 py-2 rounded-md"
          >
            Return to Login
          </button>
          <button
            onClick={() => {
              setForgotPasswordStep(1);
              setForgotPasswordSuccess("");
            }}
            className="bg-[#FDBB26] hover:bg-orange-600 text-white font-bold md:text-[20px] text-[8px] flex-1 px-4 md:py-4 py-2 rounded-md"
          >
            Resend Email
          </button>
        </div>
      </>
    )}
  </div>
</Modal>
                              {/* Save Button */}
                              <div>
                                  {/* Save Button */}
                                  <div>
                                      <button
                                          className="flex items-center justify-between w-[60px] md:w-[190px] h-[15px] md:h-[44px] bg-[#2E453D] text-white md:text-[14px] text-[6px] font-bold rounded-[5px] px-1 md:px-4"
                                          onClick={handleSaveClick}>
                                          <span>SAVE ALL</span>
                                          <img
                                          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748279791/Arhive_load_duotone_line_ukwrm4.png"
                                          alt="Edit Icon"
                                          className="md:w-[30px] h-[6px]  md:h-[30px] w-[6px]"
                                      />
                                      </button>
                                      <p className="md:text-[14px] text-[6px]  mt-1 font-normal md:px-1">
                                          Save registration
                                      </p>
                                  </div>

                                  {/* Save Confirmation Modal */}
                                  <Modal
                                      isOpen={isSaveModalOpen}
                                      onRequestClose={closeSaveModal}
                                      contentLabel="Save Successful"
                                      className="modal-content"
                                      overlayClassName="modal-overlay">
                                      <button
                                          onClick={closeSaveModal}
                                          className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
                                          aria-label="Close">
                                          &times;
                                      </button>
                                      <div>
                                      <div className="relative bg-white p-0 rounded-lg w-[350px] md:w-[800px] mx-auto md:py-0 py-2 md:h-[430px] flex flex-col items-center justify-center">

                                              <div >
                                                  <div className="relative mb-4 w-full ">
                                                
                                                      <div className="text-[14px] md:text-[48px] font-bold text-center w-full">
                                                          Save Successful
                                                      </div>
                                                  </div>
                                                  <p className="text-black text-[10px] md:text-[32px]  text-center mb-2">
                                                      The registration form
                                                      has been successfully
                                                      saved.
                                                  </p>
                                                  <button
                                                      onClick={
                                                          closeSaveModal
                                                      }
                                                      className="bg-[#152C24] md:mt-3 hover:bg-[#1b4a46] text-[10px] md:text-[32px] text-white w-[320px] md:w-[700px] h-[30px] md:h-[56px] px-5 py-1 rounded-md font-bold">
                                                      Close
                                                  </button>
                                              </div>
                                          </div>
                                      </div>
                                  </Modal>

                                  {/* Registration Confirmation Modal */}
                                  
                              </div>



                   
                          </div>
                      </div>
        <div className="flex items-center md:gap-3 gap-1">
        <a href="/Policy">

<div>
              {renderButtonWithIcon("POLICIES", "#152C24", "#FDBB26", true)}
              <p className="md:text-[14px] text-[4px]  font-normal mt-1">Click to view policies</p>
            </div>
</a>
                      <a 
href="/document"
>
  <div >
  <div>
    <div className="flex w-fit">
      <button className={`xl:w-[220px] lg:w-[160px] md:w-[90px] w-[50px] h-[15px] md:h-[44px] bg-[#152C24] text-white font-bold flex items-center px-1 rounded-l-[5px]`}>
        <div className="md:text-[16px] md:px-2 text-[4px] font-cold md:mt-0 mt-[2px] bg-transparent outline-none placeholder-white">View Registration</div>
      </button>
      <div className="w-[15px] h-[15px] md:h-[44px] md:w-[50px] bg-[#FDBB26] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
          alt="expand"
          className="w-2 h-[10px] md:w-6 md:h-[24px]"
        />
      </div>
    </div>
    <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
      Save registration 
    </p>
  </div>
  </div>
</a>
        </div>
</div>
{/* Error display */}
{registrationError && (
<div className="text-red-500 text-center mt-2">
{registrationError}
</div>
)}
              <Modal
                  isOpen={isModalOpen}
                  onRequestClose={() => setIsModalOpen(false)}
                  contentLabel="Registration Successful"
                  className="modal-content"
                  overlayClassName="modal-overlay"
                  style={{
                      overlay: {
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 1000,
                      },
                      content: {
                          position: "relative",
                          inset: "auto",
                          width: "80%",
                          maxWidth: "800px",
                          margin: "0 auto",
                      },
                  }}>
                  <button
                      onClick={() => setIsModalOpen(false)}
                      className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
                      aria-label="Close">
                      &times;
                  </button>
                  <div>
                      <div className="relative bg-white p-4 md:pt-5 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[400px]">
                          <div className="flex flex-col items-center justify-center text-center h-full w-full">
                              <div className="relative mb-4 w-full flex justify-center items-center">
                                  <img
                                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
                                      alt="Success"
                                      className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                                  />
                                  <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                                      {isLoggedIn
                                          ? "Update Successful"
                                          : "Registration Successful"}
                                  </div>
                              </div>
                              <p className="text-black text-[10px] md:text-[32px] mb-2">
                                  {isLoggedIn
                                      ? "Your details have been updated successfully!"
                                      : `Thank you for registering with Farmnet`}
                              </p>
                              {!isLoggedIn && (
                                  <p className="text-black text-[10px] md:text-[32px] mb-4">
                                      Your unique registration number is:
                                  </p>
                              )}
                              {!isLoggedIn && (
                         <div>
                         <div className="flex-1 flex justify-center">
                                          <span className="text-[12px] md:text-[36px] font-bold text-center tracking-wide">
                                              {registrationNumber}
                                          </span>
                                      </div>
                                
                         </div>
                         
                              )}
                              <div className="flex items-center justify-between w-full mb-4  md:px-10 ">
                                  <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748558039/image_1738_biv82f.png"  alt=".." className="md:w-[70px] w-[20px] h-[20px] md:h-[70px]"/>
                                 
                                      <button
                                          onClick={() => {
                                              navigator.clipboard.writeText(
                                                  registrationNumber,
                                              );
                                              setCopyMessage("Copied!");
                                              setTimeout(
                                                  () => setCopyMessage(""),
                                                  2000,
                                              );
                                          }}
                                          className="bg-[#EEB527] hover:bg-orange-600 text-white font-light text-[10px] md:text-[32px] md:w-[140px] md:h-[60px] px-4 py-2 rounded-[10px]">
                                          Copy
                                      </button>
                                  </div>
                              {copyMessage && (
                                  <div className="text-black text-[14px] md:text-[18px] font-semibold">
                                      {copyMessage}
                                  </div>
                              )}
                              <a href="/">
                                  <button
                                      onClick={() => setIsModalOpen(false)}
                                      className="bg-[#152C24] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[700px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold">
                                      Continue to Home
                                  </button>
                              </a>
                          </div>
                      </div>
                  </div>
              </Modal>
              {/* App Download Section */}
              <div className="md:h-4"></div>
              <h1 className="md:text-[36px] text-[10px] font-bold md:mt-8 mt-1 md:mb-4">
                  Download App
              </h1>
              <div className="flex  justify-between gap-8 md:gap-0  items-center">
          <a href="https://play.google.com/store/apps/details?id=com.farmnet.africa&pcampaignid=web_share" alt="none">   
             <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751889690/google_PLAY-LOGO.WINE_emyxpu.png" className="h-[25px] md:w-[280px] md:h-[180px]" alt="App Store" />    
             <p className="md:text-[14px] text-[6px] md:-mt-12 md:pl-5 font-normal md:px-1">
             Click to download App
  </p>
     </a>
      <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png" className="h-[25px] md:h-[76px]" alt="Google Play" />
      <div>

  <div className="flex w-fit">
      <button className={`xl:w-[220px] lg:w-[160px] md:w-[90px] w-[50px] h-[15px] md:h-[44px] bg-[#152C24] text-white font-bold flex items-center px-1 rounded-l-[5px]`}
    onClick={() => setIsAdminModalOpen(true)}
      
      >
        <div className="md:text-[16px] md:px-2 text-[4px] font-cold md:mt-0 mt-[2px] bg-transparent outline-none placeholder-white">ADMIN</div>
      </button>
      <div className="w-[15px] h-[15px] md:h-[44px] md:w-[50px] bg-[#2E453D] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer">
      <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747168118/User_cicrle_duotone_kaenga.png"
      alt="Edit Icon"
      className="md:w-[35px] h-[6px] md:h-[38px] w-[6px]"
    />
      </div>
    </div>
  <p className="md:text-[14px] text-[6px] mt-1 font-normal md:px-1">
    For official use only
  </p>
</div>

{/* Admin Forgot Password Modal */}
<Modal
  isOpen={isAdminForgotPasswordModalOpen}
  onRequestClose={() => {
    setIsAdminForgotPasswordModalOpen(false);
    setAdminForgotPasswordStep(1);
    setAdminForgotPasswordError("");
    setAdminForgotPasswordSuccess("");
  }}
  contentLabel="Admin Forgot Password"
  className="modal-content  text-black w-[350px] md:w-[800px] z-[1001]"
  overlayClassName="modal-overlay z-[1000]"
>
  <button
    onClick={() => {
      setIsAdminForgotPasswordModalOpen(false);
      setAdminForgotPasswordStep(1);
      setAdminForgotPasswordError("");
      setAdminForgotPasswordSuccess("");
    }}
    className="absolute top-2 right-2 md:top-4 md:right-4 text-black opacity-70 hover:opacity-100 text-[12px] md:text-[30px] font-bold z-50"
    aria-label="Close"
  >
    &times;
  </button>
    
  <div className="md:p-4 p-2 md:py-20">
    <h2 className="md:text-[40px] font-extrabold mb-4">
      {forgotPasswordStep === 1 ? "Reset Password" : 
       forgotPasswordStep === 2 ? "Enter Verification Code" : 
       "Set New Password"}
    </h2>
    
    {forgotPasswordError && (
      <p className="text-red-500 text-sm mt-2 mb-4">
        {forgotPasswordError}
      </p>
    )}
    
    {forgotPasswordSuccess && (
      <p className="text-green-500 text-sm mt-2 mb-4">
        {forgotPasswordSuccess}
      </p>
    )}
    
    {forgotPasswordStep === 1 && (
      <>
        <p className="md:text-[16px] text-[10px] mb-4">
          Enter your registered email address to receive a verification code
        </p>
        <input
          type="email"
          value={forgotPasswordEmail}
          placeholder="Enter Email Address"
          onChange={(e) => setForgotPasswordEmail(e.target.value)}
          className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#152C24] focus:bg-[152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px] md:px-6"
        />
        <button
          onClick={handleForgotPassword}
          className="bg-[#FDBB26] shadow-inner shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 rounded-md"
        >
          Send Verification Code
        </button>
      </>
    )}
    {forgotPasswordStep === 2 && (
  <>
    <p className="md:text-[16px] text-[10px] mb-4">
      {forgotPasswordSuccess || 
       "Check your email for a password reset link. If you don't see it, check your spam folder."}
    </p>
    <button
      onClick={() => setIsForgotPasswordModalOpen(false)}
      className="bg-[#FDBB26] shadow-inner shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 rounded-md"
    >
      Return to Login
    </button>
  </>
)}
    
    {forgotPasswordStep === 3 && (
      <>
        <p className="md:text-[16px] text-[10px] mb-4">
          Enter your new password
        </p>
        <input
          type="password"
          value={newPassword}
          placeholder="New Password"
          onChange={(e) => setNewPassword(e.target.value)}
          className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#152C24] focus:bg-[152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px] md:px-6"
        />
        <input
          type="password"
          value={confirmPassword}
          placeholder="Confirm New Password"
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#152C24] focus:bg-[152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px] md:px-6"
        />
        <button
          onClick={handleResetPassword}
          className="bg-[#FDBB26] shadow-inner shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 rounded-md"
        >
          Reset Password
        </button>
      </>
    )}
  </div>
 
</Modal>
    
    <Modal
  isOpen={isAdminModalOpen}
  onRequestClose={() => setIsAdminModalOpen(false)}
  contentLabel="Admin Login"
  className="modal-content bg-[#E7EBEB] w-[350px] md:w-[800px] z-[999]" // Lower z-index
  overlayClassName="modal-overlay z-[998]" // Lower z-index
>
  <button
    onClick={() => setIsAdminModalOpen(false)}
    className="absolute top-2 right-2 md:top-4 md:right-4 text-black opacity-50 hover:opacity-100 text-[12px] md:text-[30px] font-bold z-0"
    aria-label="Close"
  >
    &times;
  </button>
  <div className="flex justify-end"> 
    <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748281140/image_aorywu.png" alt="hi" className="md:w-[120px] md:mt-10 md:h-[22px]"/>
  </div>
  <div className="md:p-4 p-2 md:py-20">
    <h2 className="md:text-[40px] font-extrabold mb-4">
    Farm IT , Digitalize IT!

    </h2>
    <div>
    <input
  type="email"
  value={adminEmail}
  placeholder="Enter Email Address"
  onChange={(e) => {
    setAdminEmail(e.target.value);
    setAdminError(""); // Clear error when typing
  }}
  className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#152C24] focus:bg-[152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[28px] md:h-[66px] md:px-6"
/>

    </div>
    <div className="relative md:mt-2">
    <input
      type={showPassword ? "text" : "password"}
  value={adminPassword}
  placeholder="Enter  Password"
  onChange={(e) => {
    setAdminPassword(e.target.value);
    setAdminError(""); // C lear error when typing
  }}
  className="w-full text-[10px] inner-shadow shadow-black md:text-[20px] bg-[#152C24] focus:bg-[#152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[28px] md:h-[66px] md:px-6"
/>
   <button
      type="button"
      onClick={togglePasswordVisibility}
      className="absolute right-3 text-[10px] md:text-[30px] md:top-[38%] top-[44%] transform -translate-y-1/2 text-[#979797]"
    >
      {showPassword ? <FiEye /> : <FiEyeOff />}
    </button>
    </div>
    {adminError && (
      <p className="text-red-500 text-sm mt-2">
        {adminError}
      </p>
    )}
    <div className="md:mt-6 mt-2 gap-3 md:gap-8">
     
      <button
        onClick={handleAdminLogin}
        className="bg-[#FDBB26] shadow-inner py-2 shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 rounded-md"
      >
    Continue
      </button>
      <p 
    className="md:text-[14px] text-[8px] md:mt-4 mt-2 font-normal cursor-pointer underline"
    onClick={() => {
      setIsAdminForgotPasswordModalOpen(true);
      setIsAdminModalOpen(false);
    }}
  >
    Forgot your password
  </p>
    </div>
  </div>
</Modal>
          </div>
                    <div className="md:h-4"></div>
                </div>
            </div>
            {/* Forgot Password Modal */}

            {isPDFReady && (
  <PDFGenerator 
    ref={pdfGeneratorRef}
    registrationData={{
      personalInfo: formData,
      organizationInfo: orgFormData,
      dropdownSelections,
      reportSelections,
      selectedLanguage,
      landData,
      selectedSkills,
      membershipData: {
    selected: membershipData.selected,
    custom: membershipData.custom,
    customInputBoxes: membershipData.customInputBoxes,
    inputs: membershipData.inputs,
    organizationName: membershipData.organizationName,
    membershipNumber: membershipData.membershipNumber,
    membershipType: membershipData.membershipType,
    membershipDate: membershipData.membershipDate
  },
      groupExperience,
      dataPermissions,
      focusSelected,
      sectionD: {
        selectedType,
        selectedOption,
        selectedCategories
      },
      industry: { 
        selectedChallenges: (selectedChallenges || []).map(challenge => ({
          id: challenge.id || "",
          title: challenge.title || "",
          description: challenge.description || "",
          solution: challenge.solution || "",
          code: challenge.code || ""
        })),
        vision: vision || ""
      },
      setaQualification: {
        selectedS,
        selectedQ
      },
      location: userLocation,
      registrationNumber,
      idDocumentUrl,
      profileImage,
      productImages,
      certificatesUrls,
      productBoxValues // Make sure this is included
    }}
  />
)}
 {/* Add these at the end of your component */}
      <AutoSaveIndicator isSaving={isSaving} lastSaved={lastSaved} />
     <ImageEditorModal
  isOpen={imageEditingState.isOpen}
  onClose={closeImageEditor}
  onSave={handleSaveEditedImage}
  imageSrc={imageEditingState.imageSrc}
  aspectRatio={imageEditingState.imageType === 'profile' ? 1 : 16/9}
  type={imageEditingState.imageType}
  allowCropping={true}
  showSkipButton={true}
  onSkip={async () => {
    // When skipping, use the original image without changes
    if (imageEditingState.imageFile) {
      // If we have a file, create a blob URL from it
      const blobUrl = URL.createObjectURL(imageEditingState.imageFile);
      handleSaveEditedImage(blobUrl, imageEditingState.imageFile);
    } else {
      // If no file, just use the original source
      handleSaveEditedImage(imageEditingState.imageSrc, null);
    }
  }}
/>
{promotionEditingState.isOpen && (
    <ImageEditorModal
      isOpen={promotionEditingState.isOpen}
      onClose={() => setPromotionEditingState({
        isOpen: false,
        imageSrc: null,
        imageType: null,
        imageFile: null,
        context: null
      })}
      onSave={handleSaveEditedPromotionImage}
      imageSrc={promotionEditingState.imageSrc}
      aspectRatio={16/9}
      type={promotionEditingState.imageType}
      allowCropping={true}
      showSkipButton={true}
      onSkip={async () => {
        if (promotionEditingState.imageFile) {
          const blobUrl = URL.createObjectURL(promotionEditingState.imageFile);
          handleSaveEditedPromotionImage(blobUrl, promotionEditingState.imageFile);
        } else {
          handleSaveEditedPromotionImage(promotionEditingState.imageSrc, null);
        }
      }}
    />
  )}
  {advertisementEditingState.isOpen && (
    <ImageEditorModal
      isOpen={advertisementEditingState.isOpen}
      onClose={() => setAdvertisementEditingState({
        isOpen: false,
        imageSrc: null,
        imageType: null,
        imageFile: null,
        context: null
      })}
      onSave={handleSaveEditedAdvertisementImage}
      imageSrc={advertisementEditingState.imageSrc}
      aspectRatio={16/9}
      type={advertisementEditingState.imageType}
      allowCropping={true}
      showSkipButton={true}
      onSkip={async () => {
        if (advertisementEditingState.imageFile) {
          const blobUrl = URL.createObjectURL(advertisementEditingState.imageFile);
          handleSaveEditedAdvertisementImage(blobUrl, advertisementEditingState.imageFile);
        } else {
          handleSaveEditedAdvertisementImage(advertisementEditingState.imageSrc, null);
        }
      }}
    />
  )}
  
  </div>


        
    );
};

export default RegisterAsFarm;